// GENERATO da scripts/gen_ui_assets.py — non modificare a mano.
//
// Fonte: lms-mini/backend/src/qml/i18n_data.js, che a sua volta e' generato da
// frontend/src/lib/i18n.tsx della webapp originale. Le chiavi devono esistere
// in TUTTE le lingue: il fallback all'inglese qui sotto esiste per non lasciare
// una schermata vuota se una manca, non per autorizzare a ometterla.

export interface Language {
  code: string;
  label: string;
  flag: string;
}

export const LANGUAGES: readonly Language[] = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "hu", label: "Magyar", flag: "🇭🇺" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
];

const TABLE: Record<string, Record<string, string>> = {
  en: {
    "rep.qGood": "Good",
    "rep.qModerate": "Moderate",
    "rep.qPoor": "Poor",
    "rep.totalEmissions": "Total Emissions",
    "rep.totalSiteEmissions": "Total Site Emissions",
    "rep.uncertainty": "Uncertainty",
    "rep.dataCoverage": "Data Coverage",
    "rep.period": "Period",
    "rep.generated": "Generated",
    "rep.confidential": "Confidential",
    "rep.pageOf": "Page {n} of {m}",
    "rep.subtitle": "Gas leak monitoring",
    "rep.daily": "Daily",
    "rep.weekly": "Weekly",
    "rep.monthly": "Monthly",
    "rep.annual": "Annual",
    "rep.quarterly": "Quarterly",
    "rep.halfYearly": "Half-yearly",
    "rep.emissionReport": "EMISSION REPORT",
    "rep.siteEmissionReport": "SITE EMISSION REPORT",
    "rep.dataQuality": "Data quality",
    "rep.colPeriod": "Period",
    "rep.colMass": "Mass",
    "rep.colQuality": "Quality",
    "rep.colReadings": "Readings",
    "rep.colCluster": "Cluster",
    "rep.colCoverage": "Coverage",
    "rep.dailyLeakReport": "DAILY LEAK REPORT",
    "rep.site": "Site",
    "rep.area": "Area",
    "rep.reportDate": "Report date",
    "rep.leakEvents": "Leak events",
    "rep.none": "None",
    "rep.l1Threshold": "L1 alarm threshold",
    "rep.generatedBy": "Generated by",
    "rep.internalDoc": "Internal document — automatically generated by the LMSmini monitoring system.",
    "rep.noDetections": "NO DETECTIONS",
    "rep.noDetectionsBody": "No gas concentration above the L1 alarm threshold ({p} ppm·m) was recorded on {d}.",
    "rep.leakOf": "LEAK {n} OF {m}",
    "rep.colDate": "Date",
    "rep.colTime": "Time",
    "rep.colConcentration": "Concentration",
    "rep.fig": "Fig.",
    "rep.capPlant": "plant view, laser pointer position",
    "rep.capPlantNa": "plant view not available",
    "rep.capCamera": "camera view",
    "rep.capCameraNa": "camera view not available",
    "rep.capAt": "{s} · {w} at {t}",
    "rep.noCameraImage": "NO CAMERA IMAGE",
    "rep.noCameraBody": "No snapshot was captured for this event. Check that the cluster has a camera configured and that its RTSP stream is reachable.",
    "rep.noCameraFile": "The snapshot file recorded for this event is no longer on disk.",
    "rep.noPlantView": "NO PLANT VIEW",
    "rep.noPlantBody": "PTZ position was not recorded for this event, so the laser pointer location cannot be reconstructed.",
    "fld.opticalBaseline": "Optical baseline",
    "syslog.opticalBaseline": "Optical baseline changed — {p}",
    "focus.report": "Daily Report",
    "focus.reportBusy": "GENERATING...",
    "focus.reportSaved": "Report saved — {p} leaks",
    "focus.reportSavedEmpty": "Report saved — no detections",
    "focus.reportFailed": "Report generation failed",
    "ptz.tabManual": "MANUAL",
    "ptz.tabAutomatic": "AUTOMATIC",
    "ptz.resetDcs": "Reset DCS relay",
    "ptz.threshold": "THRESHOLD",
    "ptz.zoomAlwaysOn": "ALWAYS ON",
    "ptz.recordPath": "RECORD PATH",
    "ptz.recordWaypoint": "RECORD WAYPOINT",
    "ptz.pointsRecorded": "points recorded",
    "ptz.savedTraces": "SAVED TRACES",
    "ptz.autoShutoff": "AUTO SHUTOFF",
    "ptz.autoStopPatrol": "Auto-stop patrol",
    "ptz.startPatrol": "START PATROL",
    "ptz.stopPatrol": "STOP PATROL",
    "syslog.dcsRelayReset": "DCS relay reset: {p}",
    "fld.laserPointer": "Laser pointer",
    "btn.laserOn": "TURN ON",
    "btn.laserOff": "TURN OFF",
    "btn.saveFirst": "SAVE FIRST",
    "focus.laserDistance": "Target distance",
    "focus.laserOffScreen": "LASER off-screen · zoom out",
    "app.subtitle": "Supervisory System v1.1",
    "login.bootstrapTitle": "Create administrator",
    "login.bootstrapHint": "First run — create the administrator account.",
    "login.confirmPassword": "Confirm password",
    "login.bootstrapMismatch": "Passwords do not match",
    "login.bootstrapTooShort": "Password must be at least 8 characters",
    "hdr.emissionMetrics": "EMISSION METRICS",
    "hdr.emissionsOverTime": "EMISSIONS OVER TIME",
    "hdr.windVsEmission": "WIND VS EMISSION",
    "hdr.assetStatus": "ASSET STATUS",
    "hdr.eventLog": "EVENT LOG",
    "hdr.performanceMetrics": "PERFORMANCE METRICS",
    "hdr.priorityDistribution": "PRIORITY DISTRIBUTION",
    "hdr.ptzMode": "PTZ MODE",
    "hdr.runtimeResources": "RUNTIME RESOURCES",
    "hdr.operationalControls": "OPERATIONAL CONTROLS",
    "hdr.ptzTransport": "PTZ TRANSPORT",
    "hdr.sensorTransport": "SENSOR TRANSPORT",
    "hdr.laserBeamPointer": "LASER BEAM POINTER",
    "hdr.laserMarkerVideo": "LASER MARKER (VIDEO)",
    "hdr.deadbandDelay": "DEADBAND & DELAY",
    "hdr.noSignal": "NO SIGNAL",
    "hdr.cameraIp": "CAMERA IP",
    "hdr.sensorIp": "SENSOR IP",
    "hdr.dcsIp": "DCS IP",
    "fld.cameraIp": "Camera IP",
    "fld.sensorIp": "Sensor IP",
    "fld.enableDcs": "Enable DCS",
    "fld.moxaIp": "MOXA IP",
    "fld.homeDuration": "Home Duration (ms)",
    "fld.ptzIpNport": "PTZ IP (NPort)",
    "fld.ptzIpOwn": "PTZ IP (own address)",
    "focus.ir": "IR",
    "hdr.irCamera": "IR CAMERA (second video source)",
    "settings.irCameraHint": "Separate network device with its own IP and credentials. When set, Focus mode gains a third tab to switch between the two videos; only one stream decodes at a time. The laser marker stays on the main camera only, because it is computed from that camera’s field of view.",
    "fld.irCameraIp": "IR camera IP",
    "fld.irCameraUsername": "IR camera user",
    "fld.irCameraPassword": "IR camera password (blank = unchanged)",
    "fld.irRtspUrl": "IR stream URL override (rtsp://)",
    "fld.ptzPort": "PTZ Port",
    "fld.deviceAddress": "Device Address",
    "fld.sensorPort": "Sensor Port",
    "fld.pathLength": "Path Length (m)",
    "fld.enableWind": "Enable Wind",
    "fld.windSensorIp": "Wind Sensor IP",
    "fld.windSensorPort": "Wind Sensor Port",
    "fld.sensorX": "Sensor X",
    "fld.sensorY": "Sensor Y",
    "fld.laserEndX": "Laser End X",
    "fld.laserEndY": "Laser End Y",
    "fld.enableLaser": "Enable Laser",
    "fld.hOffset": "H Offset",
    "fld.vOffset": "V Offset",
    "fld.showOnVideo": "Show on video",
    "fld.baseLaserCamera": "Base laser↔camera (m)",
    "fld.verticalOffset": "Vertical offset (m)",
    "fld.laserSide": "Laser side",
    "fld.defaultDistance": "Default distance (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, max 500 KB",
    "msg.noEmissionPeriod": "No emission data for this period",
    "calib.title": "PTZ Calibration",
    "settings.laserMarkerHint": "The marker estimates where the laser points from zoom + distance (laser and camera move together on the PTZ). Tune FOV wide/tele to the camera model and the boresight offset at a known distance.",
    "calTL": "1: Top-Left",
    "calTR": "2: Top-Right",
    "calBL": "3: Bottom-Left",
    "calBR": "4: Bottom-Right",
    "settings.addCalNode": "Add node",
    "calib.noPlantImage": "No plant image configured",
    "calib.configureFirst": "Configure a plant image in settings before calibrating.",
    "calib.backToSettings": "Back to Settings",
    "calib.clickToPlace": "Click on the image to place the points. Active point:",
    "logs.noEvents": "No events recorded",
    "settings.calInterpHint": "Linear interpolation between zoom→offset nodes",
    "nav.gridView": "GRID VIEW",
    "nav.siteMap": "SITE MAP",
    "nav.logout": "Logout",
    "nav.level": "Level",
    "home.activeClusters": "ACTIVE CLUSTERS",
    "home.normal": "NORMAL",
    "home.warnings": "WARNINGS",
    "home.critical": "CRITICAL",
    "home.initializing": "INITIALIZING...",
    "home.notifications": "Notifications",
    "home.unread": "unread",
    "home.noAlarms": "NO ALARMS",
    "home.ack": "ACK",
    "home.ackAll": "ACK ALL",
    "sitemap.status": "STATUS",
    "sitemap.cluster": "CLUSTER",
    "sitemap.area": "AREA",
    "sitemap.thresholds": "THRESHOLDS",
    "sitemap.focus": "FOCUS",
    "login.supervisorySystem": "Supervisory System",
    "login.operatorAccess": "Operator Access",
    "login.username": "USERNAME",
    "login.systemStatusOk": "ALL SYSTEMS OPERATIONAL",
    "login.systemStatusOffline": "HARDWARE OFFLINE",
    "login.systemStatusProbing": "PROBING SYSTEM…",
    "login.systemStatusPartial": "HARDWARE PARTIALLY ONLINE",
    "login.systemStatusUnconfigured": "HARDWARE NOT CONNECTED",
    "login.systemStatusNoClusters": "No clusters configured",
    "login.cluster": "cluster",
    "login.clusters": "clusters",
    "login.devicesOnline": "online",
    "login.devicesOffline": "offline",
    "login.password": "PASSWORD",
    "login.loggingIn": "LOGGING IN...",
    "login.login": "LOGIN",
    "login.authError": "Authentication error",
    "focus.loading": "LOADING...",
    "focus.hlsStream": "HLS Stream",
    "focus.clusterPlant": "Cluster Plant",
    "focus.video": "VIDEO",
    "focus.plant": "PLANT",
    "focus.live": "LIVE",
    "focus.noFeed": "NO FEED",
    "focus.noPlantConfigured": "NO PLANT CONFIGURED",
    "focus.uploadPlantHint": "Upload a plant image in cluster settings",
    "focus.criticalLeak": "CRITICAL LEAK DETECTED",
    "focus.warningThreshold": "WARNING THRESHOLD EXCEEDED",
    "focus.concentrationAt": "Concentration at",
    "focus.limit": "Limit",
    "focus.acknowledge": "ACKNOWLEDGE",
    "focus.alarmAcked": "Alarm Acknowledged by Admin",
    "focus.realtimeConcentration": "REALTIME CONCENTRATION",
    "focus.cameraControl": "Camera Control",
    "focus.noAlarmEvents": "No alarm events recorded",
    "focus.sensorReading":  "Sensor reading",
    "syslog.appStarted":    "Application started",
    "syslog.cameraOffline": "Camera offline: {p}",
    "syslog.cameraOnline":  "Camera online: {p}",
    "syslog.hwSensorOffline": "Laser sensor offline: {p}",
    "syslog.hwSensorOnline":  "Laser sensor online: {p}",
    "syslog.ptzOffline":    "PTZ offline: {p}",
    "syslog.ptzOnline":     "PTZ online: {p}",
    "syslog.sensorOffline": "Sensor offline: {p}",
    "syslog.sensorOnline":  "Sensor online: {p}",
    "syslog.patrolStarted": "Auto patrol started — {p}",
    "syslog.patrolStopped": "Auto patrol stopped — {p}",
    "syslog.patrolStoppedAlarm": "Auto patrol stopped on CRITICAL alarm — {p}",
    "syslog.patrolFault": "Auto patrol stopped — connection lost — {p}",
    "syslog.patrolAutoResumeArmed": "Auto-resume armed — waiting for link — {p}",
    "syslog.patrolAutoResumed": "Auto patrol resumed automatically — {p}",
    "syslog.ptzGotoAlarm": "PTZ pointed to alarm location — {p}",
    "evt.goToLeak": "GO TO LEAK",
    "syslog.ptzGotoNoMove": "PTZ did not move to alarm location — {p}",
    "syslog.ptzZeroCalibrated": "PTZ zero point calibrated — {p}",
    "syslog.videoLost":     "Video signal lost — {p}",
    "syslog.logsCleared":   "System log cleared by operator ({p} entries removed)",
    "syslog.tracesEncoderMigration": "{p} legacy PTZ trace(s) archived — re-record to use the new encoder feedback",
    "logs.deleteBtn":       "DELETE LOGS",
    "logs.downloadBtn":     "DOWNLOAD",
    "logs.confirmTitle":    "Delete all logs?",
    "logs.confirmMsg":      "This will permanently remove all {p} log entries. An AUDIT entry recording this action will remain. Continue?",
    "logs.cancel":          "Cancel",
    "logs.confirm":         "Delete",
    "logs.noPermission":    "Insufficient permission",
    "focus.operationTime": "Operation Time",
    "focus.systemStatus": "System Status",
    "focus.laserSensor": "Sensor",
    "focus.ptzCamera": "Camera",
    "focus.online": "ONLINE",
    "focus.offline": "OFFLINE",
    "focus.horizSpeed": "Horiz. Speed",
    "focus.vertSpeed": "Vert. Speed",
    "focus.parking": "Parking",
    "focus.home": "Home",
    "syslog.ptzParking": "Transport parking (pan 0, tilt up) — {p}",
    "focus.wiper": "Camera Wiper",
    "focus.operatorControls": "Operator Controls",
    "focus.scanControls": "Scan Controls",
    "focus.eventDate": "Date",
    "focus.eventTime": "Time",
    "focus.eventSource": "Source",
    "focus.eventDescription": "Event",
    "focus.gasDetection": "Gas Detection System",
    "focus.userAction": "User Action",
    "focus.systemLms": "System LMS",
    "focus.alarmTriggeredEvent": "Alarm Triggered",
    "focus.alarmAckedEvent": "Alarm Acknowledged",
    "focus.alarmClearedEvent": "Alarm Cleared",
    "focus.alarmShelvedEvent": "Alarm Shelved",
    "ptz.controls": "PTZ CONTROLS",
    "ptz.wide": "WIDE",
    "ptz.tele": "TELE",
    "ptz.rec": "REC",
    "ptz.points": "POINTS",
    "ptz.cancel": "CANCEL",
    "ptz.point": "POINT",
    "ptz.save": "SAVE",
    "ptz.traceName": "TRACE NAME",
    "ptz.traceNamePlaceholder": "e.g. North Scan",
    "ptz.presets": "PRESETS",
    "ptz.recordTrace": "RECORD TRACE",
    "ptz.modePoints": "Points",
    "ptz.mode360": "360° Sweep",
    "ptz.ringHint": "Tilt the camera to the height you want and press “Add band”. Each band = a full 360° sweep at that tilt (12 points).",
    "ptz.ringNoEncoder": "This rig does not report its raw encoder: the 360° band mode cannot capture the tilt level.",
    "ptz.ringBand": "tilt {p}° · 360°",
    "ptz.addBand": "Add band T{p}",
    "ptz.bandsCount": "{p} bands",
    "ptz.autoStop.off": "OFF",
    "ptz.autoStop.tooltip": "Auto-stop patrol after the selected duration",
    "ptz.stopAuto": "STOP PATROL",
    "ptz.autoMode": "START PATROL",
    "ptz.homing": "HOMING...",
    "ptz.noTrace": "NO TRACE",
    "ptz.noTracesSaved": "No saved traces yet",
    "card.streamLost": "PTZ CONNECTION LOST",
    "card.live": "LIVE",
    "card.standby": "STANDBY",
    "card.focusMode": "FOCUS MODE",
    "settings.title": "Settings",
    "settings.systemConfig": "System Configuration",
    "settings.clusterSettings": "Cluster Settings",
    "settings.streaming": "Streaming",
    "settings.system": "System",
    "settings.administration": "Administration",
    "settings.activeClusters": "ACTIVE CLUSTERS",
    "settings.totalAlarms": "TOTAL ALARMS",
    "settings.unacknowledged": "UNACKNOWLEDGED",
    "settings.clusterManagement": "Cluster Management",
    "settings.loading": "LOADING...",
    "settings.editCluster": "Edit Cluster",
    "settings.name": "Name",
    "settings.areaCode": "Area Code",
    "settings.thresholdL1": "Threshold L1 (Warning)",
    "settings.thresholdL2": "Threshold L2 (Critical)",
    "settings.ptzLimits": "PTZ LIMITS",
    "settings.ptzAutoSpeed": "AUTO PAN/TILT SPEED",
    "settings.ptzAutoSpeedHint": "Pelco-D speed (1–63) used during auto-patrol and waypoint routes.",
    "settings.ptzPatrolAutoResume": "AUTO-RESUME PATROL",
    "settings.ptzPatrolAutoResumeHint": "If ON, after a link or keepalive fault the head re-homes and resumes the patrol automatically. If OFF, it stays stopped until an operator restarts it.",
    "settings.clusterPlant": "CLUSTER PLANT",
    "settings.replace": "REPLACE",
    "settings.remove": "REMOVE",
    "settings.removePlant": "Remove the plant?",
    "settings.uploading": "UPLOADING...",
    "settings.uploadPlant": "UPLOAD PLANT",
    "settings.cancel": "CANCEL",
    "settings.save": "SAVE",
    "settings.ptzTraces": "PTZ TRACES",
    "settings.noTraceRecorded": "No trace recorded. Use PTZ controls in Focus Mode to record one.",
    "settings.deactivate": "DEACTIVATE",
    "settings.select": "SELECT",
    "settings.deleteTrace": "Delete this trace?",
    "settings.addCluster": "ADD CLUSTER",
    "settings.newCluster": "New Cluster",
    "settings.create": "CREATE",
    "settings.deactivateCluster": "Deactivate this cluster?",
    "settings.plant": "Plant",
    "settings.ptzTrace": "PTZ Trace",
    "settings.noHardwareIp": "No hardware IP configured",
    "settings.totalClusters": "TOTAL CLUSTERS",
    "settings.activeStreams": "ACTIVE STREAMS",
    "settings.rtspConfigured": "RTSP CONFIGURED",
    "settings.converterTitle": "Converter RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • 2s Segments",
    "settings.starting": "STARTING...",
    "settings.active": "ACTIVE",
    "settings.error": "ERROR",
    "settings.rtspUrl": "RTSP URL",
    "settings.start": "START",
    "settings.stop": "STOP",
    "settings.startedAt": "Started:",
    "settings.loadingDiag": "LOADING DIAGNOSTICS...",
    "settings.ramMemory": "RAM MEMORY",
    "settings.totalRequests": "total requests",
    "settings.wsClients": "WebSocket clients",
    "settings.database": "Database",
    "settings.latency": "LATENCY",
    "settings.apiHealth": "API Health",
    "settings.systemInfo": "System Information",
    "settings.softwareVersion": "Software Version",
    "settings.cameraProtocol": "Camera Protocol",
    "settings.ptzModel": "PTZ MODEL",
    "settings.ptzModelLabel": "Rig model",
    "settings.ptzModelHint": "Selects the rig type: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D via NPort) or BIK-INFORM (extended Pelco-D via NPort, fixed lens, no zoom) — sets protocol and transport automatically. Custom = manual fields.",
    "settings.telemetryFreq": "Telemetry Frequency",
    "settings.defaultThresholdL1": "Default Threshold L1",
    "settings.defaultThresholdL2": "Default Threshold L2",
    "settings.alarmManagement": "Alarm Management",
    "settings.simulationMode": "Demo Mode (Simulation)",
    "settings.simulationDesc": "When enabled, generates simulated sensor data for demonstration and trade show purposes. Disable for real hardware operation.",
    "settings.simulationEnabled": "Simulation Active",
    "settings.simulationDisabled": "Real Hardware Mode",
    "alarm.hero.allClear": "ALL CLEAR",
    "alarm.hero.unacked": "{n} UNACKNOWLEDGED",
    "alarm.hero.stale": "{n} STALE ALARMS",
    "alarm.hero.flood": "ALARM FLOOD DETECTED",
    "alarm.hero.disabled": "ALARMS DISABLED",
    "alarm.hero.warmingUp": "Loading metrics…",
    "alarm.toggle.label": "Generation",
    "alarm.stopPatrol.label": "Stop patrol on L2",
    "alarm.audioAlert.label": "Audio alert",
    "alarm.toggle.on": "ENABLED",
    "alarm.toggle.off": "DISABLED",
    "system.titleOk": "ALL SYSTEMS OPERATIONAL",
    "system.titleDemo": "RUNNING IN DEMO MODE",
    "system.titleWarning": "ELEVATED RESOURCE USAGE",
    "system.titleCritical": "DATABASE ERROR",
    "system.cores": "cores",
    "system.warmingUp": "Initializing…",
    "settings.backupRestore": "Backup & Restore",
    "backup.title": "Backup & Restore",
    "backup.description": "Create full system backups and restore from previous snapshots. Backups include all clusters, users, alarms, audit logs, permissions, and plant images.",
    "backup.createBackup": "Create Backup",
    "backup.creating": "Creating Backup...",
    "backup.restoring": "Restoring...",
    "backup.restore": "Restore",
    "backup.restoreFailed": "Restore failed",
    "backup.download": "Download",
    "backup.delete": "Delete",
    "backup.upload": "Upload Backup",
    "backup.uploadSuccess": "Backup uploaded: {f}",
    "backup.uploadFailed": "Upload failed",
    "backup.uploadDesc": "Upload a previously downloaded backup file to restore.",
    "backup.confirmRestore": "Are you sure you want to restore this backup? This will overwrite current data.",
    "backup.confirmDelete": "Are you sure you want to delete this backup?",
    "backup.noBackups": "No backups found. Create your first backup above.",
    "backup.lastBackup": "Last Backup",
    "backup.totalBackups": "Total Backups",
    "backup.createdBy": "Created By",
    "backup.createdAt": "Created At",
    "backup.fileSize": "File Size",
    "backup.contents": "Contents",
    "backup.selectTables": "Select Tables to Restore",
    "backup.restoreSuccess": "Backup restored successfully",
    "backup.createSuccess": "Backup created successfully",
    "backup.clusters": "Clusters",
    "backup.users": "Users",
    "backup.ptzTraces": "PTZ Traces",
    "backup.alarmEvents": "Alarm Events",
    "backup.auditLog": "Audit Log",
    "backup.rolePermissions": "Role Permissions",
    "backup.plantImages": "Plant Images",
    "backup.siteName": "Site Name",
    "backup.siteNameDesc": "Identifies this installation in backup filenames",
    "backup.siteNamePlaceholder": "e.g. Refinery-North",
    "ftp.title": "Scheduled FTP Backup",
    "ftp.description": "Automatically send backups to an external FTP server at regular intervals.",
    "ftp.enabled": "Enable Scheduled FTP Backup",
    "ftp.host": "FTP Host",
    "ftp.port": "Port",
    "ftp.user": "Username",
    "ftp.password": "Password",
    "ftp.remotePath": "Remote Path",
    "ftp.secure": "Use FTPS (Secure)",
    "ftp.interval": "Backup Interval (hours)",
    "ftp.testConnection": "Test Connection",
    "ftp.testing": "Testing...",
    "ftp.testSuccess": "Connection successful",
    "ftp.testFailed": "Connection failed",
    "ftp.backupNow": "Send Backup Now",
    "ftp.sending": "Sending...",
    "ftp.lastBackup": "Last FTP Backup",
    "ftp.lastResult": "Last Result",
    "ftp.schedulerActive": "Scheduler Active",
    "ftp.saveSettings": "Save FTP Settings",
    "ftp.saving": "Saving...",
    "ftp.saved": "Settings saved",
    "ftp.never": "Never",
    "ftp.success": "Success",
    "ftp.error": "Error",
    "ftp.yes": "Yes",
    "ftp.no": "No",
    "settings.license": "License",
    "settings.activeUsers": "ACTIVE USERS",
    "settings.levelLegend": "LEVELS LEGEND",
    "settings.userAccounts": "User Accounts",
    "settings.language": "Language",
    "settings.languageDesc": "Select the interface language",
    "users.accessDenied": "Access Denied",
    "users.superAdminRequired": "Super Admin level (Lv.5) required to manage users.",
    "users.backToSettings": "BACK TO SETTINGS",
    "users.userManagement": "User Management",
    "users.accountAdmin": "Account Administration",
    "users.editUser": "Edit User",
    "users.displayName": "DISPLAY NAME",
    "users.role": "ROLE",
    "users.level": "LEVEL",
    "users.deactivateUser": "Deactivate this user?",
    "users.newPassword": "NEW PASSWORD",
    "users.minChars": "Minimum 4 characters",
    "users.change": "CHANGE",
    "users.addUser": "ADD USER",
    "users.newUser": "New User",
    "roles.viewer": "Viewer",
    "roles.operator": "Operator",
    "roles.supervisor": "Supervisor",
    "roles.admin": "Administrator",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Page Not Found",
    "notFound.hint": "Did you forget to add the page to the router?",
    "settings.roles": "Roles & Permissions",
    "settings.rolesDesc": "Configure which permissions each user level has. Changes take effect immediately for all users.",
    "settings.resetDefaults": "RESET DEFAULTS",
    "settings.rolesLevel5Note": "Level 5 (Super Admin) permissions cannot be modified — full access is always guaranteed.",
    "settings.permission": "PERMISSION",
    "settings.level": "LVL",
    "settings.saving": "SAVING...",
    "perm.acknowledgeAlarms": "Acknowledge Alarms",
    "perm.controlPtz": "PTZ Camera Controls",
    "perm.recordTraces": "Record PTZ Traces",
    "perm.accessSettings": "Access Settings",
    "perm.manageClusters": "Manage Clusters",
    "perm.accessStreaming": "Streaming Management",
    "perm.managePlantImages": "Manage Plant Images",
    "perm.deleteTraces": "Delete PTZ Traces",
    "perm.manageUsers": "User Management",
    "perm.changeLanguage": "Change Language",
    "perm.viewEmissions": "View Emissions Data",
    "perm.exportReports": "Export PDF Reports",
    "perm.manageAlarms": "Manage Alarms",
    "perm.manageSystem": "Manage System",
    "perm.deleteSystemLog": "Delete System Log",
    "access.restricted": "Access Restricted",
    "access.ptzRestricted": "PTZ controls require Operator level or higher",
    "access.settingsRestricted": "Settings require Supervisor level or higher",
    "access.readOnlyMode": "Read-only mode — Admin level required for changes",
    "access.ackRestricted": "Alarm acknowledgement requires Operator level or higher",
    "alarm.state.UNACK": "UNACKNOWLEDGED",
    "alarm.state.ACKED": "ACKNOWLEDGED",
    "alarm.state.RTNUN": "RETURNED TO NORMAL",
    "alarm.state.SHLVD": "SHELVED",
    "alarm.priority.HIGH": "HIGH",
    "alarm.priority.MEDIUM": "MEDIUM",
    "alarm.priority.LOW": "LOW",
    "alarm.shelve": "SHELVE",
    "alarm.unshelve": "UNSHELVE",
    "alarm.shelveReason": "Shelve Reason",
    "alarm.shelvedUntil": "Shelved Until",
    "alarm.shelvedBy": "Shelved By",
    "alarm.outOfService": "OUT OF SERVICE",
    "alarm.oosReason": "OOS Reason",
    "alarm.oosBy": "Set OOS By",
    "alarm.kpi.alarmRate": "Alarm Rate",
    "alarm.kpi.floodDetected": "Flood Detected",
    "alarm.kpi.staleAlarms": "Stale Alarms",
    "alarm.kpi.priorityDistribution": "Priority Distribution",
    "alarm.kpi.topBadActors": "Top Bad Actors",
    "alarm.kpi.avgAckTime": "Avg. Acknowledge Time",
    "alarm.kpi.unacknowledged": "Unacknowledged",
    "alarm.audit.title": "Audit Trail",
    "alarm.audit.action": "Action",
    "alarm.audit.performedBy": "Performed By",
    "alarm.audit.details": "Details",
    "settings.deadband": "Deadband (%)",
    "settings.onDelay": "On-Delay (s)",
    "settings.offDelay": "Off-Delay (s)",
    "emissions.title": "Emissions",
    "emissions.selectCluster": "Select cluster",
    "emissions.totalEmissions": "Total Emissions",
    "emissions.uncertainty": "Uncertainty",
    "emissions.coverage": "Data Coverage",
    "emissions.partial": "Partial",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "No emission data available",
    "emissions.noCluster": "Select a cluster to view emissions",
    "emissions.totalHours": "Total Hours",
    "emissions.completeHours": "Complete",
    "emissions.gapHours": "Data Gaps",
    "emissions.quality.good": "Good",
    "emissions.quality.moderate": "Moderate",
    "emissions.quality.poor": "Poor",
    "emissions.viewDetail": "View full detail",
    "emissions.last24h": "24h",
    "emissions.last7d": "7d",
    "emissions.last30d": "30d",
    "emissions.lastYear": "1y",
    "emissions.customRange": "Custom",
    "emissions.allClusters": "All Clusters",
    "analytics": "Analytics",
    "analytics.totalSiteEmissions": "Total Site Emissions",
    "analytics.activeLeaks": "Active Leaks",
    "analytics.siteUncertainty": "Site Uncertainty",
    "analytics.emissionsByCluster": "Emissions by Cluster",
    "analytics.windVsEmissions": "Wind vs Emissions",
    "analytics.assetStatus": "Asset Status",
    "analytics.dataCoverage": "Data Coverage",
    "analytics.lastPeak": "Last Peak",
    "analytics.lastReading": "Last Reading",
    "analytics.allClusters": "All Clusters",
    "analytics.windSpeed": "Wind Speed",
    "analytics.emissionRate": "Emission Rate",
    "companyInfo": "Company Info",
    "companyName": "Company Name",
    "companyAddress": "Address",
    "companyContact": "Contact",
    "companyLogo": "Logo",
    "uploadLogo": "Upload Logo",
    "exportPdf": "Export PDF",
    "generatingPdf": "Generating...",
    "siteReport": "Site Report",
    "clusterReport": "Cluster Report",
    "pdfBranding": "PDF Branding",
  },
  de: {
    "rep.qGood": "Gut",
    "rep.qModerate": "Mäßig",
    "rep.qPoor": "Schlecht",
    "rep.totalEmissions": "Gesamtemissionen",
    "rep.totalSiteEmissions": "Gesamtemissionen Standort",
    "rep.uncertainty": "Unsicherheit",
    "rep.dataCoverage": "Datenabdeckung",
    "rep.period": "Zeitraum",
    "rep.generated": "Erstellt",
    "rep.confidential": "Vertraulich",
    "rep.pageOf": "Seite {n} von {m}",
    "rep.subtitle": "Gasleck-Überwachung",
    "rep.daily": "Täglich",
    "rep.weekly": "Wöchentlich",
    "rep.monthly": "Monatlich",
    "rep.annual": "Jährlich",
    "rep.quarterly": "Vierteljährlich",
    "rep.halfYearly": "Halbjährlich",
    "rep.emissionReport": "EMISSIONSBERICHT",
    "rep.siteEmissionReport": "STANDORT-EMISSIONSBERICHT",
    "rep.dataQuality": "Datenqualität",
    "rep.colPeriod": "Zeitraum",
    "rep.colMass": "Masse",
    "rep.colQuality": "Qualität",
    "rep.colReadings": "Messwerte",
    "rep.colCluster": "Cluster",
    "rep.colCoverage": "Abdeckung",
    "rep.dailyLeakReport": "TÄGLICHER LECKAGEBERICHT",
    "rep.site": "Standort",
    "rep.area": "Bereich",
    "rep.reportDate": "Berichtsdatum",
    "rep.leakEvents": "Leckage-Ereignisse",
    "rep.none": "Keine",
    "rep.l1Threshold": "L1-Alarmschwelle",
    "rep.generatedBy": "Erstellt von",
    "rep.internalDoc": "Internes Dokument — automatisch erstellt vom LMSmini-Überwachungssystem.",
    "rep.noDetections": "KEINE ERKENNUNGEN",
    "rep.noDetectionsBody": "Am {d} wurde keine Gaskonzentration über der L1-Alarmschwelle ({p} ppm·m) aufgezeichnet.",
    "rep.leakOf": "LECKAGE {n} VON {m}",
    "rep.colDate": "Datum",
    "rep.colTime": "Uhrzeit",
    "rep.colConcentration": "Konzentration",
    "rep.fig": "Abb.",
    "rep.capPlant": "Anlagenansicht, Position des Laserpunkts",
    "rep.capPlantNa": "Anlagenansicht nicht verfügbar",
    "rep.capCamera": "Kameraansicht",
    "rep.capCameraNa": "Kameraansicht nicht verfügbar",
    "rep.capAt": "{s} · {w} um {t}",
    "rep.noCameraImage": "KEIN KAMERABILD",
    "rep.noCameraBody": "Für dieses Ereignis wurde kein Standbild aufgenommen. Prüfen Sie, ob für den Cluster eine Kamera konfiguriert und deren RTSP-Stream erreichbar ist.",
    "rep.noCameraFile": "Die für dieses Ereignis aufgezeichnete Bilddatei ist nicht mehr auf dem Datenträger vorhanden.",
    "rep.noPlantView": "KEINE ANLAGENANSICHT",
    "rep.noPlantBody": "Für dieses Ereignis wurde keine PTZ-Position aufgezeichnet, daher lässt sich die Position des Laserpunkts nicht rekonstruieren.",
    "fld.opticalBaseline": "Optische Basislinie",
    "syslog.opticalBaseline": "Optische Basislinie geändert — {p}",
    "focus.report": "Tagesbericht",
    "focus.reportBusy": "ERSTELLEN...",
    "focus.reportSaved": "Bericht gespeichert — {p} Leckagen",
    "focus.reportSavedEmpty": "Bericht gespeichert — keine Erkennungen",
    "focus.reportFailed": "Berichterstellung fehlgeschlagen",
    "ptz.tabManual": "MANUELL",
    "ptz.tabAutomatic": "AUTOMATISCH",
    "ptz.resetDcs": "DCS-Relais zurücksetzen",
    "ptz.threshold": "SCHWELLE",
    "ptz.zoomAlwaysOn": "IMMER AKTIV",
    "ptz.recordPath": "ROUTE AUFNEHMEN",
    "ptz.recordWaypoint": "WEGPUNKT AUFNEHMEN",
    "ptz.pointsRecorded": "Punkte aufgenommen",
    "ptz.savedTraces": "GESPEICHERTE ROUTEN",
    "ptz.autoShutoff": "AUTOM. ABSCHALTUNG",
    "ptz.autoStopPatrol": "Patrouille autom. stoppen",
    "ptz.startPatrol": "PATROUILLE STARTEN",
    "ptz.stopPatrol": "PATROUILLE STOPPEN",
    "syslog.dcsRelayReset": "DCS-Relais zurückgesetzt: {p}",
    "fld.laserPointer": "Laserpointer",
    "btn.laserOn": "EIN",
    "btn.laserOff": "AUS",
    "btn.saveFirst": "ERST SPEICHERN",
    "focus.laserDistance": "Zielentfernung",
    "focus.laserOffScreen": "LASER außerhalb · herauszoomen",
    "app.subtitle": "Überwachungssystem v1.1",
    "login.bootstrapTitle": "Administrator erstellen",
    "login.bootstrapHint": "Erster Start — erstellen Sie das Administratorkonto.",
    "login.confirmPassword": "Passwort bestätigen",
    "login.bootstrapMismatch": "Passwörter stimmen nicht überein",
    "login.bootstrapTooShort": "Passwort muss mindestens 8 Zeichen haben",
    "hdr.emissionMetrics": "EMISSIONSMETRIKEN",
    "hdr.emissionsOverTime": "EMISSIONEN ÜBER ZEIT",
    "hdr.windVsEmission": "WIND VS EMISSION",
    "hdr.assetStatus": "ANLAGENSTATUS",
    "hdr.eventLog": "EREIGNISPROTOKOLL",
    "hdr.performanceMetrics": "LEISTUNGSMETRIKEN",
    "hdr.priorityDistribution": "PRIORITÄTSVERTEILUNG",
    "hdr.ptzMode": "PTZ-MODUS",
    "hdr.runtimeResources": "LAUFZEITRESSOURCEN",
    "hdr.operationalControls": "BETRIEBSSTEUERUNG",
    "hdr.ptzTransport": "PTZ-TRANSPORT",
    "hdr.sensorTransport": "SENSOR-TRANSPORT",
    "hdr.laserBeamPointer": "LASERSTRAHL-ZEIGER",
    "hdr.laserMarkerVideo": "LASER-MARKIERUNG (VIDEO)",
    "hdr.deadbandDelay": "TOTBAND & VERZÖGERUNG",
    "hdr.noSignal": "KEIN SIGNAL",
    "hdr.cameraIp": "KAMERA-IP",
    "hdr.sensorIp": "SENSOR-IP",
    "hdr.dcsIp": "DCS-IP",
    "fld.cameraIp": "Kamera-IP",
    "fld.sensorIp": "Sensor-IP",
    "fld.enableDcs": "DCS aktivieren",
    "fld.moxaIp": "MOXA-IP",
    "fld.homeDuration": "Home-Dauer (ms)",
    "fld.ptzIpNport": "PTZ-IP (NPort)",
    "fld.ptzIpOwn": "PTZ-IP (eigene Adresse)",
    "focus.ir": "IR",
    "hdr.irCamera": "IR-KAMERA (zweite Videoquelle)",
    "settings.irCameraHint": "Eigenständiges Netzwerkgerät mit eigener IP und Zugangsdaten. Wenn gesetzt, erhält der Fokusmodus einen dritten Reiter zum Umschalten; es wird immer nur ein Stream dekodiert. Die Lasermarkierung bleibt nur auf der Hauptkamera, da sie aus deren Bildwinkel berechnet wird.",
    "fld.irCameraIp": "IR-Kamera-IP",
    "fld.irCameraUsername": "IR-Kamera-Benutzer",
    "fld.irCameraPassword": "IR-Kamera-Passwort (leer = unverändert)",
    "fld.irRtspUrl": "IR-Stream-URL-Override (rtsp://)",
    "fld.ptzPort": "PTZ-Port",
    "fld.deviceAddress": "Geräteadresse",
    "fld.sensorPort": "Sensor-Port",
    "fld.pathLength": "Pfadlänge (m)",
    "fld.enableWind": "Wind aktivieren",
    "fld.windSensorIp": "Windsensor-IP",
    "fld.windSensorPort": "Windsensor-Port",
    "fld.sensorX": "Sensor X",
    "fld.sensorY": "Sensor Y",
    "fld.laserEndX": "Laser-Ende X",
    "fld.laserEndY": "Laser-Ende Y",
    "fld.enableLaser": "Laser aktivieren",
    "fld.hOffset": "H-Versatz",
    "fld.vOffset": "V-Versatz",
    "fld.showOnVideo": "Im Video anzeigen",
    "fld.baseLaserCamera": "Basis Laser↔Kamera (m)",
    "fld.verticalOffset": "Vertikaler Versatz (m)",
    "fld.laserSide": "Laserseite",
    "fld.defaultDistance": "Standardentfernung (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, max. 500 KB",
    "msg.noEmissionPeriod": "Keine Emissionsdaten für diesen Zeitraum",
    "calib.title": "PTZ-Kalibrierung",
    "settings.laserMarkerHint": "Der Marker schätzt anhand von Zoom + Entfernung, wohin der Laser zeigt (Laser und Kamera bewegen sich gemeinsam auf der PTZ). FOV Weit/Tele auf das Kameramodell und den Boresight-Offset bei bekannter Entfernung abstimmen.",
    "calTL": "1: Oben-Links",
    "calTR": "2: Oben-Rechts",
    "calBL": "3: Unten-Links",
    "calBR": "4: Unten-Rechts",
    "settings.addCalNode": "Knoten hinzufügen",
    "calib.noPlantImage": "Kein Anlagenbild konfiguriert",
    "calib.configureFirst": "Konfigurieren Sie vor der Kalibrierung ein Anlagenbild in den Einstellungen.",
    "calib.backToSettings": "Zurück zu Einstellungen",
    "calib.clickToPlace": "Klicken Sie auf das Bild, um die Punkte zu platzieren. Aktiver Punkt:",
    "logs.noEvents": "Keine Ereignisse aufgezeichnet",
    "settings.calInterpHint": "Lineare Interpolation zwischen Zoom→Offset-Knoten",
    "nav.gridView": "RASTERANSICHT",
    "nav.siteMap": "LAGEPLAN",
    "nav.logout": "Abmelden",
    "nav.level": "Stufe",
    "home.activeClusters": "AKTIVE CLUSTER",
    "home.normal": "NORMAL",
    "home.warnings": "WARNUNGEN",
    "home.critical": "KRITISCH",
    "home.initializing": "INITIALISIERUNG...",
    "home.notifications": "Benachrichtigungen",
    "home.unread": "ungelesen",
    "home.noAlarms": "KEINE ALARME",
    "home.ack": "BEST.",
    "home.ackAll": "ALLE BEST.",
    "sitemap.status": "STATUS",
    "sitemap.cluster": "CLUSTER",
    "sitemap.area": "BEREICH",
    "sitemap.thresholds": "SCHWELLENWERTE",
    "sitemap.focus": "FOKUS",
    "login.supervisorySystem": "Überwachungssystem",
    "login.operatorAccess": "Bediener-Zugang",
    "login.username": "BENUTZERNAME",
    "login.systemStatusOk": "ALLE SYSTEME BETRIEBSBEREIT",
    "login.systemStatusOffline": "HARDWARE OFFLINE",
    "login.systemStatusProbing": "SYSTEMPRÜFUNG…",
    "login.systemStatusPartial": "HARDWARE TEILWEISE ONLINE",
    "login.systemStatusUnconfigured": "HARDWARE NICHT VERBUNDEN",
    "login.systemStatusNoClusters": "Keine Cluster konfiguriert",
    "login.cluster": "Cluster",
    "login.clusters": "Cluster",
    "login.devicesOnline": "online",
    "login.devicesOffline": "offline",
    "login.password": "PASSWORT",
    "login.loggingIn": "ANMELDEN...",
    "login.login": "ANMELDEN",
    "login.authError": "Authentifizierungsfehler",
    "focus.loading": "LADEN...",
    "focus.hlsStream": "HLS Stream",
    "focus.clusterPlant": "Anlagenplan",
    "focus.video": "VIDEO",
    "focus.plant": "ANLAGE",
    "focus.live": "LIVE",
    "focus.noFeed": "KEIN SIGNAL",
    "focus.noPlantConfigured": "KEIN ANLAGENPLAN KONFIGURIERT",
    "focus.uploadPlantHint": "Laden Sie ein Anlagenbild in den Clustereinstellungen hoch",
    "focus.criticalLeak": "KRITISCHES LECK ERKANNT",
    "focus.warningThreshold": "WARNSCHWELLE ÜBERSCHRITTEN",
    "focus.concentrationAt": "Konzentration bei",
    "focus.limit": "Grenzwert",
    "focus.acknowledge": "BESTÄTIGEN",
    "focus.alarmAcked": "Alarm von Admin bestätigt",
    "focus.realtimeConcentration": "ECHTZEIT-KONZENTRATION",
    "focus.cameraControl": "Kamerasteuerung",
    "focus.noAlarmEvents": "Keine Alarmereignisse aufgezeichnet",
    "focus.sensorReading":  "Sensormessung",
    "syslog.appStarted":    "Anwendung gestartet",
    "syslog.cameraOffline": "Kamera offline: {p}",
    "syslog.cameraOnline":  "Kamera online: {p}",
    "syslog.hwSensorOffline": "Laser-Sensor offline: {p}",
    "syslog.hwSensorOnline":  "Laser-Sensor online: {p}",
    "syslog.ptzOffline":    "PTZ offline: {p}",
    "syslog.ptzOnline":     "PTZ online: {p}",
    "syslog.sensorOffline": "Sensor offline: {p}",
    "syslog.sensorOnline":  "Sensor online: {p}",
    "syslog.tracesEncoderMigration": "{p} alte PTZ-Spur(en) archiviert — neu aufzeichnen für Encoder-Feedback",
    "syslog.patrolStarted": "Auto-Patrol gestartet — {p}",
    "syslog.patrolStopped": "Auto-Patrol gestoppt — {p}",
    "syslog.patrolStoppedAlarm": "Auto-Patrol bei KRITISCHEM Alarm gestoppt — {p}",
    "syslog.patrolFault": "Auto-Patrol gestoppt — Verbindung verloren — {p}",
    "syslog.patrolAutoResumeArmed": "Auto-Wiederaufnahme aktiviert — warte auf Verbindung — {p}",
    "syslog.patrolAutoResumed": "Auto-Patrol automatisch wieder aufgenommen — {p}",
    "syslog.ptzGotoAlarm": "PTZ auf Alarmposition gerichtet — {p}",
    "evt.goToLeak": "ZUM LECK",
    "syslog.ptzGotoNoMove": "PTZ hat sich nicht zur Alarmposition bewegt — {p}",
    "syslog.ptzZeroCalibrated": "PTZ-Nullpunkt kalibriert — {p}",
    "syslog.videoLost":     "Videosignal verloren — {p}",
    "syslog.logsCleared":   "Systemprotokoll vom Bediener gelöscht ({p} Einträge entfernt)",
    "logs.deleteBtn":       "PROTOKOLLE LÖSCHEN",
    "logs.downloadBtn":     "HERUNTERLADEN",
    "logs.confirmTitle":    "Alle Protokolle löschen?",
    "logs.confirmMsg":      "Dies entfernt dauerhaft {p} Protokolleinträge. Ein AUDIT-Eintrag, der diese Aktion aufzeichnet, bleibt erhalten. Fortfahren?",
    "logs.cancel":          "Abbrechen",
    "logs.confirm":         "Löschen",
    "logs.noPermission":    "Unzureichende Berechtigung",
    "focus.operationTime": "Betriebszeit",
      "focus.systemStatus": "Systemstatus",
      "focus.laserSensor": "Sensor",
      "focus.ptzCamera": "Kamera",
      "focus.online": "ONLINE",
      "focus.offline": "OFFLINE",
      "focus.horizSpeed": "Horiz. Geschw.",
      "focus.vertSpeed": "Vert. Geschw.",
      "focus.parking": "Parkposition",
    "focus.home": "Home",
    "syslog.ptzParking": "Transport-Parkposition (Pan 0, Tilt oben) — {p}",
      "focus.wiper": "Kamera-Wischer",
      "focus.operatorControls": "Bediensteuerung",
      "focus.scanControls": "Scan-Steuerung",
      "focus.eventDate": "Datum",
      "focus.eventTime": "Zeit",
      "focus.eventSource": "Quelle",
      "focus.eventDescription": "Ereignis",
      "focus.gasDetection": "Gaserkennungssystem",
      "focus.userAction": "Benutzeraktion",
      "focus.systemLms": "System LMS",
      "focus.alarmTriggeredEvent": "Alarm ausgelöst",
      "focus.alarmAckedEvent": "Alarm bestätigt",
      "focus.alarmClearedEvent": "Alarm gelöscht",
      "focus.alarmShelvedEvent": "Alarm zurückgestellt",
    "ptz.controls": "PTZ STEUERUNG",
    "ptz.wide": "WEIT",
    "ptz.tele": "TELE",
    "ptz.rec": "AUFN.",
    "ptz.points": "PUNKTE",
    "ptz.cancel": "ABBRECHEN",
    "ptz.point": "PUNKT",
    "ptz.save": "SPEICHERN",
    "ptz.traceName": "SPURNAME",
    "ptz.traceNamePlaceholder": "z.B. Nordscan",
    "ptz.presets": "VOREINSTELLUNGEN",
    "ptz.recordTrace": "SPUR AUFNEHMEN",
    "ptz.modePoints": "Punkte",
    "ptz.mode360": "360°-Schwenk",
    "ptz.ringHint": "Neige die Kamera auf die gewünschte Höhe und drücke „Band hinzufügen“. Jedes Band = ein voller 360°-Schwenk bei dieser Neigung (12 Punkte).",
    "ptz.ringNoEncoder": "Dieses Rig meldet seinen Rohencoder nicht: Der 360°-Bandmodus kann die Neigung nicht erfassen.",
    "ptz.ringBand": "Neigung {p}° · 360°",
    "ptz.addBand": "Band T{p} hinzufügen",
    "ptz.bandsCount": "{p} Bänder",
    "ptz.autoStop.off": "AUS",
    "ptz.autoStop.tooltip": "Patrouille nach der gewählten Dauer automatisch stoppen",
    "ptz.stopAuto": "PATROUILLE STOPP",
    "ptz.autoMode": "PATROUILLE START",
    "ptz.homing": "KALIBRIERUNG...",
    "ptz.noTrace": "KEINE SPUR",
    "ptz.noTracesSaved": "Keine gespeicherten Spuren",
    "card.streamLost": "PTZ-VERBINDUNG VERLOREN",
    "card.live": "LIVE",
    "card.standby": "STANDBY",
    "card.focusMode": "FOKUS MODUS",
    "settings.title": "Einstellungen",
    "settings.systemConfig": "Systemkonfiguration",
    "settings.clusterSettings": "Cluster Einstellungen",
    "settings.streaming": "Streaming",
    "settings.system": "System",
    "settings.administration": "Verwaltung",
    "settings.activeClusters": "AKTIVE CLUSTER",
    "settings.totalAlarms": "ALARME GESAMT",
    "settings.unacknowledged": "UNBESTÄTIGT",
    "settings.clusterManagement": "Cluster-Verwaltung",
    "settings.loading": "LADEN...",
    "settings.editCluster": "Cluster bearbeiten",
    "settings.name": "Name",
    "settings.areaCode": "Bereichscode",
    "settings.thresholdL1": "Schwelle L1 (Warnung)",
    "settings.thresholdL2": "Schwelle L2 (Kritisch)",
    "settings.ptzLimits": "PTZ GRENZEN",
    "settings.ptzAutoSpeed": "AUTO PAN/TILT GESCHW.",
    "settings.ptzAutoSpeedHint": "Pelco-D Geschwindigkeit (1–63) für Auto-Patrouille und Wegpunkt-Routen.",
    "settings.ptzPatrolAutoResume": "AUTO-WIEDERAUFNAHME PATROUILLE",
    "settings.ptzPatrolAutoResumeHint": "Wenn EIN, kehrt der Kopf nach einem Verbindungs- oder Keepalive-Fehler in die Ausgangsposition zurück und nimmt die Patrouille automatisch wieder auf. Wenn AUS, bleibt er gestoppt, bis ein Bediener ihn neu startet.",
    "settings.clusterPlant": "ANLAGENPLAN",
    "settings.replace": "ERSETZEN",
    "settings.remove": "ENTFERNEN",
    "settings.removePlant": "Anlagenplan entfernen?",
    "settings.uploading": "HOCHLADEN...",
    "settings.uploadPlant": "PLAN HOCHLADEN",
    "settings.cancel": "ABBRECHEN",
    "settings.save": "SPEICHERN",
    "settings.ptzTraces": "PTZ SPUREN",
    "settings.noTraceRecorded": "Keine Spur aufgenommen. Verwenden Sie die PTZ-Steuerung im Fokus-Modus.",
    "settings.deactivate": "DEAKTIVIEREN",
    "settings.select": "AUSWÄHLEN",
    "settings.deleteTrace": "Diese Spur löschen?",
    "settings.addCluster": "CLUSTER HINZUFÜGEN",
    "settings.newCluster": "Neuer Cluster",
    "settings.create": "ERSTELLEN",
    "settings.deactivateCluster": "Diesen Cluster deaktivieren?",
    "settings.plant": "Anlage",
    "settings.ptzTrace": "PTZ Spur",
    "settings.noHardwareIp": "Keine Hardware-IP konfiguriert",
    "settings.totalClusters": "CLUSTER GESAMT",
    "settings.activeStreams": "AKTIVE STREAMS",
    "settings.rtspConfigured": "RTSP KONFIGURIERT",
    "settings.converterTitle": "Konverter RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • 2s Segmente",
    "settings.starting": "STARTEN...",
    "settings.active": "AKTIV",
    "settings.error": "FEHLER",
    "settings.rtspUrl": "RTSP URL",
    "settings.start": "STARTEN",
    "settings.stop": "STOPP",
    "settings.startedAt": "Gestartet:",
    "settings.loadingDiag": "DIAGNOSE LADEN...",
    "settings.ramMemory": "RAM SPEICHER",
    "settings.totalRequests": "Anfragen gesamt",
    "settings.wsClients": "WebSocket Clients",
    "settings.database": "Datenbank",
    "settings.latency": "LATENZ",
    "settings.apiHealth": "API Gesundheit",
    "settings.systemInfo": "Systeminformationen",
    "settings.softwareVersion": "Softwareversion",
    "settings.cameraProtocol": "Kameraprotokoll",
    "settings.ptzModel": "PTZ-MODELL",
    "settings.ptzModelLabel": "Rig-Modell",
    "settings.ptzModelHint": "Wählt den Rig-Typ: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D über NPort) oder BIK-INFORM (erweitertes Pelco-D über NPort, Festobjektiv, kein Zoom) — setzt Protokoll und Transport automatisch. Custom = manuelle Felder.",
    "settings.telemetryFreq": "Telemetriefrequenz",
    "settings.defaultThresholdL1": "Standard-Schwelle L1",
    "settings.defaultThresholdL2": "Standard-Schwelle L2",
    "settings.alarmManagement": "Alarmverwaltung",
    "settings.simulationMode": "Demo-Modus (Simulation)",
    "settings.simulationDesc": "Wenn aktiviert, werden simulierte Sensordaten für Demonstrations- und Messezwecke generiert. Deaktivieren für realen Hardwarebetrieb.",
    "settings.simulationEnabled": "Simulation Aktiv",
    "settings.simulationDisabled": "Realer Hardwarebetrieb",
    "alarm.hero.allClear": "ALLES BEREIT",
    "alarm.hero.unacked": "{n} NICHT BESTÄTIGT",
    "alarm.hero.stale": "{n} VERALTETE ALARME",
    "alarm.hero.flood": "ALARMFLUT ERKANNT",
    "alarm.hero.disabled": "ALARME DEAKTIVIERT",
    "alarm.hero.warmingUp": "Metriken werden geladen…",
    "alarm.toggle.label": "Erzeugung",
    "alarm.stopPatrol.label": "Patrol bei L2 stoppen",
    "alarm.audioAlert.label": "Akustischer Alarm",
    "alarm.toggle.on": "AKTIVIERT",
    "alarm.toggle.off": "DEAKTIVIERT",
    "system.titleOk": "ALLE SYSTEME BETRIEBSBEREIT",
    "system.titleDemo": "DEMO-MODUS AKTIV",
    "system.titleWarning": "ERHÖHTE RESSOURCENNUTZUNG",
    "system.titleCritical": "DATENBANKFEHLER",
    "system.cores": "Kerne",
    "system.warmingUp": "Initialisierung…",
    "settings.backupRestore": "Sicherung & Wiederherstellung",
    "backup.title": "Sicherung & Wiederherstellung",
    "backup.description": "Erstellen Sie vollständige Systemsicherungen und stellen Sie aus früheren Snapshots wieder her. Sicherungen umfassen alle Cluster, Benutzer, Alarme, Audit-Protokolle, Berechtigungen und Anlagenbilder.",
    "backup.createBackup": "Sicherung erstellen",
    "backup.creating": "Sicherung wird erstellt...",
    "backup.restoring": "Wiederherstellung...",
    "backup.restore": "Wiederherstellen",
    "backup.restoreFailed": "Wiederherstellung fehlgeschlagen",
    "backup.download": "Herunterladen",
    "backup.delete": "Löschen",
    "backup.upload": "Sicherung hochladen",
    "backup.uploadSuccess": "Sicherung hochgeladen: {f}",
    "backup.uploadFailed": "Hochladen fehlgeschlagen",
    "backup.uploadDesc": "Laden Sie eine zuvor heruntergeladene Sicherungsdatei hoch.",
    "backup.confirmRestore": "Möchten Sie diese Sicherung wirklich wiederherstellen? Aktuelle Daten werden überschrieben.",
    "backup.confirmDelete": "Möchten Sie diese Sicherung wirklich löschen?",
    "backup.noBackups": "Keine Sicherungen gefunden. Erstellen Sie oben Ihre erste Sicherung.",
    "backup.lastBackup": "Letzte Sicherung",
    "backup.totalBackups": "Sicherungen gesamt",
    "backup.createdBy": "Erstellt von",
    "backup.createdAt": "Erstellt am",
    "backup.fileSize": "Dateigröße",
    "backup.contents": "Inhalt",
    "backup.selectTables": "Tabellen zur Wiederherstellung auswählen",
    "backup.restoreSuccess": "Sicherung erfolgreich wiederhergestellt",
    "backup.createSuccess": "Sicherung erfolgreich erstellt",
    "backup.clusters": "Cluster",
    "backup.users": "Benutzer",
    "backup.ptzTraces": "PTZ-Traces",
    "backup.alarmEvents": "Alarmereignisse",
    "backup.auditLog": "Audit-Protokoll",
    "backup.rolePermissions": "Rollenberechtigungen",
    "backup.plantImages": "Anlagenbilder",
    "backup.siteName": "Standortname",
    "backup.siteNameDesc": "Identifiziert diese Installation in Backup-Dateinamen",
    "backup.siteNamePlaceholder": "z.B. Raffinerie-Nord",
    "ftp.title": "Geplantes FTP-Backup",
    "ftp.description": "Backups automatisch in regelmäßigen Abständen an einen externen FTP-Server senden.",
    "ftp.enabled": "Geplantes FTP-Backup aktivieren",
    "ftp.host": "FTP-Host",
    "ftp.port": "Port",
    "ftp.user": "Benutzername",
    "ftp.password": "Passwort",
    "ftp.remotePath": "Remote-Pfad",
    "ftp.secure": "FTPS verwenden (Sicher)",
    "ftp.interval": "Backup-Intervall (Stunden)",
    "ftp.testConnection": "Verbindung testen",
    "ftp.testing": "Teste...",
    "ftp.testSuccess": "Verbindung erfolgreich",
    "ftp.testFailed": "Verbindung fehlgeschlagen",
    "ftp.backupNow": "Backup jetzt senden",
    "ftp.sending": "Sende...",
    "ftp.lastBackup": "Letztes FTP-Backup",
    "ftp.lastResult": "Letztes Ergebnis",
    "ftp.schedulerActive": "Planer aktiv",
    "ftp.saveSettings": "FTP-Einstellungen speichern",
    "ftp.saving": "Speichere...",
    "ftp.saved": "Einstellungen gespeichert",
    "ftp.never": "Nie",
    "ftp.success": "Erfolgreich",
    "ftp.error": "Fehler",
    "ftp.yes": "Ja",
    "ftp.no": "Nein",
    "settings.license": "Lizenz",
    "settings.activeUsers": "AKTIVE BENUTZER",
    "settings.levelLegend": "STUFENLEGENDE",
    "settings.userAccounts": "Benutzerkonten",
    "settings.language": "Sprache",
    "settings.languageDesc": "Sprache der Benutzeroberfläche auswählen",
    "users.accessDenied": "Zugriff verweigert",
    "users.superAdminRequired": "Super Admin Stufe (Lv.5) zum Verwalten von Benutzern erforderlich.",
    "users.backToSettings": "ZURÜCK ZU EINSTELLUNGEN",
    "users.userManagement": "Benutzerverwaltung",
    "users.accountAdmin": "Kontoverwaltung",
    "users.editUser": "Benutzer bearbeiten",
    "users.displayName": "ANZEIGENAME",
    "users.role": "ROLLE",
    "users.level": "STUFE",
    "users.deactivateUser": "Diesen Benutzer deaktivieren?",
    "users.newPassword": "NEUES PASSWORT",
    "users.minChars": "Mindestens 4 Zeichen",
    "users.change": "ÄNDERN",
    "users.addUser": "BENUTZER HINZUFÜGEN",
    "users.newUser": "Neuer Benutzer",
    "roles.viewer": "Betrachter",
    "roles.operator": "Bediener",
    "roles.supervisor": "Aufseher",
    "roles.admin": "Administrator",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Seite nicht gefunden",
    "notFound.hint": "Haben Sie vergessen, die Seite dem Router hinzuzufügen?",
    "settings.roles": "Rollen & Berechtigungen",
    "settings.rolesDesc": "Konfigurieren Sie die Berechtigungen für jede Benutzerstufe. Änderungen werden sofort für alle Benutzer wirksam.",
    "settings.resetDefaults": "STANDARDS ZURÜCKSETZEN",
    "settings.rolesLevel5Note": "Berechtigungen für Stufe 5 (Super Admin) können nicht geändert werden — voller Zugriff ist immer garantiert.",
    "settings.permission": "BERECHTIGUNG",
    "settings.level": "STF",
    "settings.saving": "SPEICHERN...",
    "perm.acknowledgeAlarms": "Alarme quittieren",
    "perm.controlPtz": "PTZ-Kamerasteuerung",
    "perm.recordTraces": "PTZ-Traces aufzeichnen",
    "perm.accessSettings": "Einstellungen öffnen",
    "perm.manageClusters": "Cluster verwalten",
    "perm.accessStreaming": "Streaming-Verwaltung",
    "perm.managePlantImages": "Anlagenbilder verwalten",
    "perm.deleteTraces": "PTZ-Traces löschen",
    "perm.manageUsers": "Benutzerverwaltung",
    "perm.changeLanguage": "Sprache ändern",
    "perm.viewEmissions": "Emissionsdaten anzeigen",
    "perm.exportReports": "PDF-Berichte exportieren",
    "perm.manageAlarms": "Alarme verwalten",
    "perm.manageSystem": "System verwalten",
    "perm.deleteSystemLog": "Systemprotokoll löschen",
    "access.restricted": "Zugriff beschränkt",
    "access.ptzRestricted": "PTZ-Steuerung erfordert Bediener-Level oder höher",
    "access.settingsRestricted": "Einstellungen erfordern Supervisor-Level oder höher",
    "access.readOnlyMode": "Nur-Lesen-Modus — Admin-Level für Änderungen erforderlich",
    "access.ackRestricted": "Alarmbestätigung erfordert Bediener-Level oder höher",
    "alarm.state.UNACK": "UNBESTÄTIGT",
    "alarm.state.ACKED": "BESTÄTIGT",
    "alarm.state.RTNUN": "ZUM NORMALZUSTAND ZURÜCKGEKEHRT",
    "alarm.state.SHLVD": "ZURÜCKGESTELLT",
    "alarm.priority.HIGH": "HOCH",
    "alarm.priority.MEDIUM": "MITTEL",
    "alarm.priority.LOW": "NIEDRIG",
    "alarm.shelve": "ZURÜCKSTELLEN",
    "alarm.unshelve": "WIEDERHERSTELLEN",
    "alarm.shelveReason": "Grund der Zurückstellung",
    "alarm.shelvedUntil": "Zurückgestellt bis",
    "alarm.shelvedBy": "Zurückgestellt von",
    "alarm.outOfService": "AUSSER BETRIEB",
    "alarm.oosReason": "Grund für Außerbetriebnahme",
    "alarm.oosBy": "Außer Betrieb gesetzt von",
    "alarm.kpi.alarmRate": "Alarmrate",
    "alarm.kpi.floodDetected": "Alarmflut erkannt",
    "alarm.kpi.staleAlarms": "Veraltete Alarme",
    "alarm.kpi.priorityDistribution": "Prioritätsverteilung",
    "alarm.kpi.topBadActors": "Top Problemmelder",
    "alarm.kpi.avgAckTime": "Durchschn. Bestätigungszeit",
    "alarm.kpi.unacknowledged": "Unbestätigt",
    "alarm.audit.title": "Prüfprotokoll",
    "alarm.audit.action": "Aktion",
    "alarm.audit.performedBy": "Durchgeführt von",
    "alarm.audit.details": "Details",
    "settings.deadband": "Totzone (%)",
    "settings.onDelay": "Einschaltverzögerung (s)",
    "settings.offDelay": "Ausschaltverzögerung (s)",
    "emissions.title": "Emissionen",
    "emissions.selectCluster": "Cluster auswählen",
    "emissions.totalEmissions": "Gesamtemissionen",
    "emissions.uncertainty": "Unsicherheit",
    "emissions.coverage": "Datenabdeckung",
    "emissions.partial": "Teilweise",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "Keine Emissionsdaten verfügbar",
    "emissions.noCluster": "Cluster auswählen um Emissionen anzuzeigen",
    "emissions.totalHours": "Gesamtstunden",
    "emissions.completeHours": "Vollständig",
    "emissions.gapHours": "Datenlücken",
    "emissions.quality.good": "Gut",
    "emissions.quality.moderate": "Mäßig",
    "emissions.quality.poor": "Schlecht",
    "emissions.viewDetail": "Vollständige Details anzeigen",
    "emissions.last24h": "24h",
    "emissions.last7d": "7d",
    "emissions.last30d": "30d",
    "emissions.lastYear": "1y",
    "emissions.customRange": "Benutzerdefiniert",
    "emissions.allClusters": "Alle Cluster",
    "analytics": "Analytik",
    "analytics.totalSiteEmissions": "Gesamtemissionen Standort",
    "analytics.activeLeaks": "Aktive Leckagen",
    "analytics.siteUncertainty": "Standort Unsicherheit",
    "analytics.emissionsByCluster": "Emissionen nach Cluster",
    "analytics.windVsEmissions": "Wind vs Emissionen",
    "analytics.assetStatus": "Anlagenstatus",
    "analytics.dataCoverage": "Datenabdeckung",
    "analytics.lastPeak": "Letzter Spitzenwert",
    "analytics.lastReading": "Letzte Messung",
    "analytics.allClusters": "Alle Cluster",
    "analytics.windSpeed": "Windgeschwindigkeit",
    "analytics.emissionRate": "Emissionsrate",
    "companyInfo": "Firmeninfo",
    "companyName": "Firmenname",
    "companyAddress": "Adresse",
    "companyContact": "Kontakt",
    "companyLogo": "Logo",
    "uploadLogo": "Logo Hochladen",
    "exportPdf": "PDF Export",
    "generatingPdf": "Generierung...",
    "siteReport": "Standortbericht",
    "clusterReport": "Clusterbericht",
    "pdfBranding": "PDF Branding",
  },
  fr: {
    "rep.qGood": "Bon",
    "rep.qModerate": "Modéré",
    "rep.qPoor": "Mauvais",
    "rep.totalEmissions": "Émissions Totales",
    "rep.totalSiteEmissions": "Emissions Totales du Site",
    "rep.uncertainty": "Incertitude",
    "rep.dataCoverage": "Couverture des Données",
    "rep.period": "Période",
    "rep.generated": "Généré",
    "rep.confidential": "Confidentiel",
    "rep.pageOf": "Page {n} sur {m}",
    "rep.subtitle": "Surveillance des fuites de gaz",
    "rep.daily": "Quotidien",
    "rep.weekly": "Hebdomadaire",
    "rep.monthly": "Mensuel",
    "rep.annual": "Annuel",
    "rep.quarterly": "Trimestriel",
    "rep.halfYearly": "Semestriel",
    "rep.emissionReport": "RAPPORT D'ÉMISSIONS",
    "rep.siteEmissionReport": "RAPPORT D'ÉMISSIONS DU SITE",
    "rep.dataQuality": "Qualité des données",
    "rep.colPeriod": "Période",
    "rep.colMass": "Masse",
    "rep.colQuality": "Qualité",
    "rep.colReadings": "Mesures",
    "rep.colCluster": "Cluster",
    "rep.colCoverage": "Couverture",
    "rep.dailyLeakReport": "RAPPORT QUOTIDIEN DES FUITES",
    "rep.site": "Site",
    "rep.area": "Zone",
    "rep.reportDate": "Date du rapport",
    "rep.leakEvents": "Événements de fuite",
    "rep.none": "Aucun",
    "rep.l1Threshold": "Seuil d'alarme L1",
    "rep.generatedBy": "Généré par",
    "rep.internalDoc": "Document interne — généré automatiquement par le système de surveillance LMSmini.",
    "rep.noDetections": "AUCUNE DÉTECTION",
    "rep.noDetectionsBody": "Aucune concentration de gaz supérieure au seuil d'alarme L1 ({p} ppm·m) n'a été enregistrée le {d}.",
    "rep.leakOf": "FUITE {n} SUR {m}",
    "rep.colDate": "Date",
    "rep.colTime": "Heure",
    "rep.colConcentration": "Concentration",
    "rep.fig": "Fig.",
    "rep.capPlant": "vue de l'installation, position du pointeur laser",
    "rep.capPlantNa": "vue de l'installation non disponible",
    "rep.capCamera": "vue caméra",
    "rep.capCameraNa": "vue caméra non disponible",
    "rep.capAt": "{s} · {w} à {t}",
    "rep.noCameraImage": "AUCUNE IMAGE CAMÉRA",
    "rep.noCameraBody": "Aucune capture n'a été réalisée pour cet événement. Vérifiez qu'une caméra est configurée pour le cluster et que son flux RTSP est joignable.",
    "rep.noCameraFile": "Le fichier de capture enregistré pour cet événement n'est plus présent sur le disque.",
    "rep.noPlantView": "AUCUNE VUE DE L'INSTALLATION",
    "rep.noPlantBody": "Aucune position PTZ n'a été enregistrée pour cet événement : la position du pointeur laser ne peut pas être reconstituée.",
    "fld.opticalBaseline": "Ligne de base optique",
    "syslog.opticalBaseline": "Ligne de base optique modifiée — {p}",
    "focus.report": "Rapport quotidien",
    "focus.reportBusy": "GÉNÉRATION...",
    "focus.reportSaved": "Rapport enregistré — {p} fuites",
    "focus.reportSavedEmpty": "Rapport enregistré — aucune détection",
    "focus.reportFailed": "Échec de la génération du rapport",
    "ptz.tabManual": "MANUEL",
    "ptz.tabAutomatic": "AUTOMATIQUE",
    "ptz.resetDcs": "Réinitialiser le relais DCS",
    "ptz.threshold": "SEUIL",
    "ptz.zoomAlwaysOn": "TOUJOURS ACTIF",
    "ptz.recordPath": "ENREGISTRER PARCOURS",
    "ptz.recordWaypoint": "ENREGISTRER POINT",
    "ptz.pointsRecorded": "points enregistrés",
    "ptz.savedTraces": "PARCOURS ENREGISTRÉS",
    "ptz.autoShutoff": "ARRÊT AUTOMATIQUE",
    "ptz.autoStopPatrol": "Arrêt auto patrouille",
    "ptz.startPatrol": "DÉMARRER PATROUILLE",
    "ptz.stopPatrol": "ARRÊTER PATROUILLE",
    "syslog.dcsRelayReset": "Relais DCS réinitialisé : {p}",
    "fld.laserPointer": "Pointeur laser",
    "btn.laserOn": "ALLUMER",
    "btn.laserOff": "ÉTEINDRE",
    "btn.saveFirst": "ENREGISTRER D’ABORD",
    "focus.laserDistance": "Distance cible",
    "focus.laserOffScreen": "LASER hors champ · dézoomer",
    "app.subtitle": "Système de Supervision v1.1",
    "login.bootstrapTitle": "Créer un administrateur",
    "login.bootstrapHint": "Premier démarrage — créez le compte administrateur.",
    "login.confirmPassword": "Confirmer le mot de passe",
    "login.bootstrapMismatch": "Les mots de passe ne correspondent pas",
    "login.bootstrapTooShort": "Le mot de passe doit comporter au moins 8 caractères",
    "hdr.emissionMetrics": "MÉTRIQUES D'ÉMISSION",
    "hdr.emissionsOverTime": "ÉMISSIONS DANS LE TEMPS",
    "hdr.windVsEmission": "VENT VS ÉMISSION",
    "hdr.assetStatus": "ÉTAT DES ÉQUIPEMENTS",
    "hdr.eventLog": "JOURNAL D'ÉVÉNEMENTS",
    "hdr.performanceMetrics": "MÉTRIQUES DE PERFORMANCE",
    "hdr.priorityDistribution": "DISTRIBUTION DES PRIORITÉS",
    "hdr.ptzMode": "MODE PTZ",
    "hdr.runtimeResources": "RESSOURCES D'EXÉCUTION",
    "hdr.operationalControls": "COMMANDES OPÉRATIONNELLES",
    "hdr.ptzTransport": "TRANSPORT PTZ",
    "hdr.sensorTransport": "TRANSPORT CAPTEUR",
    "hdr.laserBeamPointer": "POINTEUR LASER",
    "hdr.laserMarkerVideo": "MARQUEUR LASER (VIDÉO)",
    "hdr.deadbandDelay": "BANDE MORTE ET DÉLAI",
    "hdr.noSignal": "AUCUN SIGNAL",
    "hdr.cameraIp": "IP CAMÉRA",
    "hdr.sensorIp": "IP CAPTEUR",
    "hdr.dcsIp": "IP DCS",
    "fld.cameraIp": "IP caméra",
    "fld.sensorIp": "IP capteur",
    "fld.enableDcs": "Activer DCS",
    "fld.moxaIp": "IP MOXA",
    "fld.homeDuration": "Durée Home (ms)",
    "fld.ptzIpNport": "IP PTZ (NPort)",
    "fld.ptzIpOwn": "IP PTZ (adresse propre)",
    "focus.ir": "IR",
    "hdr.irCamera": "CAMÉRA IR (deuxième source vidéo)",
    "settings.irCameraHint": "Appareil réseau distinct, avec IP et identifiants propres. Une fois renseigné, le mode Focus affiche un troisième onglet pour basculer ; un seul flux est décodé à la fois. Le marqueur laser reste sur la caméra principale, car il est calculé à partir de son champ de vision.",
    "fld.irCameraIp": "IP caméra IR",
    "fld.irCameraUsername": "Utilisateur caméra IR",
    "fld.irCameraPassword": "Mot de passe caméra IR (vide = inchangé)",
    "fld.irRtspUrl": "URL de flux IR (rtsp://)",
    "fld.ptzPort": "Port PTZ",
    "fld.deviceAddress": "Adresse appareil",
    "fld.sensorPort": "Port capteur",
    "fld.pathLength": "Longueur du chemin (m)",
    "fld.enableWind": "Activer le vent",
    "fld.windSensorIp": "IP capteur vent",
    "fld.windSensorPort": "Port capteur vent",
    "fld.sensorX": "Capteur X",
    "fld.sensorY": "Capteur Y",
    "fld.laserEndX": "Fin laser X",
    "fld.laserEndY": "Fin laser Y",
    "fld.enableLaser": "Activer le laser",
    "fld.hOffset": "Décalage H",
    "fld.vOffset": "Décalage V",
    "fld.showOnVideo": "Afficher sur la vidéo",
    "fld.baseLaserCamera": "Base laser↔caméra (m)",
    "fld.verticalOffset": "Décalage vertical (m)",
    "fld.laserSide": "Côté laser",
    "fld.defaultDistance": "Distance par défaut (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, max 500 Ko",
    "msg.noEmissionPeriod": "Aucune donnée d'émission pour cette période",
    "calib.title": "Calibration PTZ",
    "settings.laserMarkerHint": "Le marqueur estime où pointe le laser à partir du zoom + distance (le laser et la caméra sont solidaires sur la PTZ). Réglez le FOV large/télé selon le modèle de caméra et l'offset boresight à une distance connue.",
    "calTL": "1: Haut-Gauche",
    "calTR": "2: Haut-Droite",
    "calBL": "3: Bas-Gauche",
    "calBR": "4: Bas-Droite",
    "settings.addCalNode": "Ajouter un nœud",
    "calib.noPlantImage": "Aucune image d'installation configurée",
    "calib.configureFirst": "Configurez une image d'installation dans les paramètres avant de calibrer.",
    "calib.backToSettings": "Retour aux paramètres",
    "calib.clickToPlace": "Cliquez sur l'image pour placer les points. Point actif :",
    "logs.noEvents": "Aucun événement enregistré",
    "settings.calInterpHint": "Interpolation linéaire entre les nœuds zoom→décalage",
    "nav.gridView": "VUE GRILLE",
    "nav.siteMap": "PLAN DU SITE",
    "nav.logout": "Déconnexion",
    "nav.level": "Niveau",
    "home.activeClusters": "CLUSTERS ACTIFS",
    "home.normal": "NORMAL",
    "home.warnings": "AVERTISSEMENTS",
    "home.critical": "CRITIQUE",
    "home.initializing": "INITIALISATION...",
    "home.notifications": "Notifications",
    "home.unread": "non lus",
    "home.noAlarms": "AUCUNE ALARME",
    "home.ack": "ACQ.",
    "home.ackAll": "ACQ. TOUT",
    "sitemap.status": "ÉTAT",
    "sitemap.cluster": "CLUSTER",
    "sitemap.area": "ZONE",
    "sitemap.thresholds": "SEUILS",
    "sitemap.focus": "FOCUS",
    "login.supervisorySystem": "Système de Supervision",
    "login.operatorAccess": "Accès Opérateur",
    "login.username": "IDENTIFIANT",
    "login.systemStatusOk": "TOUS LES SYSTÈMES OPÉRATIONNELS",
    "login.systemStatusOffline": "MATÉRIEL HORS LIGNE",
    "login.systemStatusProbing": "TEST DU SYSTÈME…",
    "login.systemStatusPartial": "MATÉRIEL PARTIELLEMENT EN LIGNE",
    "login.systemStatusUnconfigured": "MATÉRIEL NON CONNECTÉ",
    "login.systemStatusNoClusters": "Aucun cluster configuré",
    "login.cluster": "cluster",
    "login.clusters": "clusters",
    "login.devicesOnline": "en ligne",
    "login.devicesOffline": "hors ligne",
    "login.password": "MOT DE PASSE",
    "login.loggingIn": "CONNEXION...",
    "login.login": "CONNEXION",
    "login.authError": "Erreur d'authentification",
    "focus.loading": "CHARGEMENT...",
    "focus.hlsStream": "Flux HLS",
    "focus.clusterPlant": "Plan du Cluster",
    "focus.video": "VIDÉO",
    "focus.plant": "PLAN",
    "focus.live": "EN DIRECT",
    "focus.noFeed": "PAS DE SIGNAL",
    "focus.noPlantConfigured": "AUCUN PLAN CONFIGURÉ",
    "focus.uploadPlantHint": "Téléchargez une image du plan dans les paramètres du cluster",
    "focus.criticalLeak": "FUITE CRITIQUE DÉTECTÉE",
    "focus.warningThreshold": "SEUIL D'AVERTISSEMENT DÉPASSÉ",
    "focus.concentrationAt": "Concentration à",
    "focus.limit": "Limite",
    "focus.acknowledge": "ACQUITTER",
    "focus.alarmAcked": "Alarme acquittée par l'Admin",
    "focus.realtimeConcentration": "CONCENTRATION EN TEMPS RÉEL",
    "focus.cameraControl": "Contrôle Caméra",
    "focus.noAlarmEvents": "Aucun événement d'alarme enregistré",
    "focus.sensorReading":  "Lecture capteur",
    "syslog.appStarted":    "Application démarrée",
    "syslog.cameraOffline": "Caméra hors ligne : {p}",
    "syslog.cameraOnline":  "Caméra en ligne : {p}",
    "syslog.hwSensorOffline": "Capteur laser hors ligne : {p}",
    "syslog.hwSensorOnline":  "Capteur laser en ligne : {p}",
    "syslog.ptzOffline":    "PTZ hors ligne : {p}",
    "syslog.ptzOnline":     "PTZ en ligne : {p}",
    "syslog.sensorOffline": "Capteur hors ligne : {p}",
    "syslog.sensorOnline":  "Capteur en ligne : {p}",
    "syslog.tracesEncoderMigration": "{p} ancienne(s) trace(s) PTZ archivée(s) — réenregistrer pour utiliser le retour encodeur",
    "syslog.patrolStarted": "Patrouille auto démarrée — {p}",
    "syslog.patrolStopped": "Patrouille auto arrêtée — {p}",
    "syslog.patrolStoppedAlarm": "Patrouille auto arrêtée sur alarme CRITIQUE — {p}",
    "syslog.patrolFault": "Patrouille auto arrêtée — connexion perdue — {p}",
    "syslog.patrolAutoResumeArmed": "Reprise auto activée — en attente de liaison — {p}",
    "syslog.patrolAutoResumed": "Patrouille auto reprise automatiquement — {p}",
    "syslog.ptzGotoAlarm": "PTZ pointé sur la zone de l’alarme — {p}",
    "evt.goToLeak": "ALLER À LA FUITE",
    "syslog.ptzGotoNoMove": "Le PTZ ne s’est pas déplacé vers la zone de l’alarme — {p}",
    "syslog.ptzZeroCalibrated": "Point zéro PTZ calibré — {p}",
    "syslog.videoLost":     "Signal vidéo perdu — {p}",
    "syslog.logsCleared":   "Journal système effacé par l'opérateur ({p} entrées supprimées)",
    "logs.deleteBtn":       "EFFACER LES JOURNAUX",
    "logs.downloadBtn":     "TÉLÉCHARGER",
    "logs.confirmTitle":    "Effacer tous les journaux ?",
    "logs.confirmMsg":      "Cela supprimera définitivement {p} entrées du journal. Une entrée AUDIT enregistrant cette action sera conservée. Continuer ?",
    "logs.cancel":          "Annuler",
    "logs.confirm":         "Effacer",
    "logs.noPermission":    "Permission insuffisante",
    "focus.operationTime": "Temps de fonctionnement",
      "focus.systemStatus": "État du système",
      "focus.laserSensor": "Capteur",
      "focus.ptzCamera": "Caméra",
      "focus.online": "EN LIGNE",
      "focus.offline": "HORS LIGNE",
      "focus.horizSpeed": "Vit. horiz.",
      "focus.vertSpeed": "Vit. vert.",
      "focus.parking": "Parking",
    "focus.home": "Home",
    "syslog.ptzParking": "Parking transport (pan 0, tilt haut) — {p}",
      "focus.wiper": "Essuie caméra",
      "focus.operatorControls": "Commandes opérateur",
      "focus.scanControls": "Commandes de scan",
      "focus.eventDate": "Date",
      "focus.eventTime": "Heure",
      "focus.eventSource": "Source",
      "focus.eventDescription": "Événement",
      "focus.gasDetection": "Système de détection de gaz",
      "focus.userAction": "Action utilisateur",
      "focus.systemLms": "Système LMS",
      "focus.alarmTriggeredEvent": "Alarme déclenchée",
      "focus.alarmAckedEvent": "Alarme acquittée",
      "focus.alarmClearedEvent": "Alarme effacée",
      "focus.alarmShelvedEvent": "Alarme mise en attente",
    "ptz.controls": "CONTRÔLES PTZ",
    "ptz.wide": "LARGE",
    "ptz.tele": "TÉLE",
    "ptz.rec": "ENR.",
    "ptz.points": "POINTS",
    "ptz.cancel": "ANNULER",
    "ptz.point": "POINT",
    "ptz.save": "ENREGISTRER",
    "ptz.traceName": "NOM DE LA TRACE",
    "ptz.traceNamePlaceholder": "ex. Balayage Nord",
    "ptz.presets": "PRÉRÉGLAGES",
    "ptz.recordTrace": "ENREGISTRER TRACE",
    "ptz.modePoints": "Points",
    "ptz.mode360": "Balayage 360°",
    "ptz.ringHint": "Inclinez la caméra à la hauteur voulue et appuyez sur « Ajouter une bande ». Chaque bande = un balayage 360° complet à cette inclinaison (12 points).",
    "ptz.ringNoEncoder": "Ce rig ne renvoie pas son codeur brut : le mode 360° par bandes ne peut pas capturer l’inclinaison.",
    "ptz.ringBand": "inclin. {p}° · 360°",
    "ptz.addBand": "Ajouter bande T{p}",
    "ptz.bandsCount": "{p} bandes",
    "ptz.autoStop.off": "OFF",
    "ptz.autoStop.tooltip": "Arrêt automatique de la patrouille après la durée sélectionnée",
    "ptz.stopAuto": "ARRÊT PATROUILLE",
    "ptz.autoMode": "DÉMARRER PATROUILLE",
    "ptz.homing": "CALIBRAGE...",
    "ptz.noTrace": "PAS DE TRACE",
    "ptz.noTracesSaved": "Aucun trajet enregistré",
    "card.streamLost": "CONNEXION PTZ PERDUE",
    "card.live": "EN DIRECT",
    "card.standby": "VEILLE",
    "card.focusMode": "MODE FOCUS",
    "settings.title": "Paramètres",
    "settings.systemConfig": "Configuration Système",
    "settings.clusterSettings": "Paramètres Cluster",
    "settings.streaming": "Streaming",
    "settings.system": "Système",
    "settings.administration": "Administration",
    "settings.activeClusters": "CLUSTERS ACTIFS",
    "settings.totalAlarms": "ALARMES TOTALES",
    "settings.unacknowledged": "NON ACQUITTÉES",
    "settings.clusterManagement": "Gestion des Clusters",
    "settings.loading": "CHARGEMENT...",
    "settings.editCluster": "Modifier le Cluster",
    "settings.name": "Nom",
    "settings.areaCode": "Code Zone",
    "settings.thresholdL1": "Seuil L1 (Avertissement)",
    "settings.thresholdL2": "Seuil L2 (Critique)",
    "settings.ptzLimits": "LIMITES PTZ",
    "settings.ptzAutoSpeed": "VITESSE AUTO PAN/TILT",
    "settings.ptzAutoSpeedHint": "Vitesse Pelco-D (1–63) utilisée pendant l'auto-patrouille et les routes waypoints.",
    "settings.ptzPatrolAutoResume": "REPRISE AUTO DE LA PATROUILLE",
    "settings.ptzPatrolAutoResumeHint": "Si ACTIVÉ, après une panne de liaison ou de keepalive, la tête se réinitialise et reprend la patrouille automatiquement. Si DÉSACTIVÉ, elle reste arrêtée jusqu'au redémarrage par un opérateur.",
    "settings.clusterPlant": "PLAN DU CLUSTER",
    "settings.replace": "REMPLACER",
    "settings.remove": "SUPPRIMER",
    "settings.removePlant": "Supprimer le plan ?",
    "settings.uploading": "TÉLÉCHARGEMENT...",
    "settings.uploadPlant": "TÉLÉCHARGER PLAN",
    "settings.cancel": "ANNULER",
    "settings.save": "ENREGISTRER",
    "settings.ptzTraces": "TRACES PTZ",
    "settings.noTraceRecorded": "Aucune trace enregistrée. Utilisez les contrôles PTZ en mode Focus.",
    "settings.deactivate": "DÉSACTIVER",
    "settings.select": "SÉLECTIONNER",
    "settings.deleteTrace": "Supprimer cette trace ?",
    "settings.addCluster": "AJOUTER CLUSTER",
    "settings.newCluster": "Nouveau Cluster",
    "settings.create": "CRÉER",
    "settings.deactivateCluster": "Désactiver ce cluster ?",
    "settings.plant": "Plan",
    "settings.ptzTrace": "Trace PTZ",
    "settings.noHardwareIp": "Aucune IP matérielle configurée",
    "settings.totalClusters": "CLUSTERS TOTAUX",
    "settings.activeStreams": "STREAMS ACTIFS",
    "settings.rtspConfigured": "RTSP CONFIGURÉS",
    "settings.converterTitle": "Convertisseur RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • Segments 2s",
    "settings.starting": "DÉMARRAGE...",
    "settings.active": "ACTIF",
    "settings.error": "ERREUR",
    "settings.rtspUrl": "URL RTSP",
    "settings.start": "DÉMARRER",
    "settings.stop": "ARRÊTER",
    "settings.startedAt": "Démarré :",
    "settings.loadingDiag": "CHARGEMENT DIAGNOSTICS...",
    "settings.ramMemory": "MÉMOIRE RAM",
    "settings.totalRequests": "requêtes totales",
    "settings.wsClients": "clients WebSocket",
    "settings.database": "Base de données",
    "settings.latency": "LATENCE",
    "settings.apiHealth": "Santé API",
    "settings.systemInfo": "Informations Système",
    "settings.softwareVersion": "Version Logicielle",
    "settings.cameraProtocol": "Protocole Caméra",
    "settings.ptzModel": "MODÈLE PTZ",
    "settings.ptzModelLabel": "Modèle de rig",
    "settings.ptzModelHint": "Sélectionne le type de rig : INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D via NPort) ou BIK-INFORM (Pelco-D étendu via NPort, focale fixe, sans zoom) — définit le protocole et le transport automatiquement. Custom = champs manuels.",
    "settings.telemetryFreq": "Fréquence Télémétrie",
    "settings.defaultThresholdL1": "Seuil L1 par défaut",
    "settings.defaultThresholdL2": "Seuil L2 par défaut",
    "settings.alarmManagement": "Gestion des Alarmes",
    "settings.simulationMode": "Mode Démo (Simulation)",
    "settings.simulationDesc": "Lorsqu'activé, génère des données de capteur simulées pour les démonstrations et salons professionnels. Désactiver pour le fonctionnement avec matériel réel.",
    "settings.simulationEnabled": "Simulation Active",
    "settings.simulationDisabled": "Mode Matériel Réel",
    "alarm.hero.allClear": "TOUT EST CLAIR",
    "alarm.hero.unacked": "{n} NON ACQUITTÉS",
    "alarm.hero.stale": "{n} ALARMES OBSOLÈTES",
    "alarm.hero.flood": "INONDATION D'ALARMES",
    "alarm.hero.disabled": "ALARMES DÉSACTIVÉES",
    "alarm.hero.warmingUp": "Chargement des métriques…",
    "alarm.toggle.label": "Génération",
    "alarm.stopPatrol.label": "Arrêter patrouille en L2",
    "alarm.audioAlert.label": "Alerte sonore",
    "alarm.toggle.on": "ACTIVÉ",
    "alarm.toggle.off": "DÉSACTIVÉ",
    "system.titleOk": "TOUS LES SYSTÈMES OPÉRATIONNELS",
    "system.titleDemo": "MODE DÉMO ACTIF",
    "system.titleWarning": "UTILISATION ÉLEVÉE DES RESSOURCES",
    "system.titleCritical": "ERREUR BASE DE DONNÉES",
    "system.cores": "cœurs",
    "system.warmingUp": "Initialisation…",
    "settings.backupRestore": "Sauvegarde & Restauration",
    "backup.title": "Sauvegarde & Restauration",
    "backup.description": "Créez des sauvegardes complètes du système et restaurez à partir de snapshots précédents. Les sauvegardes incluent tous les clusters, utilisateurs, alarmes, journaux d'audit, permissions et images d'installation.",
    "backup.createBackup": "Créer une sauvegarde",
    "backup.creating": "Création en cours...",
    "backup.restoring": "Restauration...",
    "backup.restore": "Restaurer",
    "backup.restoreFailed": "Échec de la restauration",
    "backup.download": "Télécharger",
    "backup.delete": "Supprimer",
    "backup.upload": "Importer une sauvegarde",
    "backup.uploadSuccess": "Sauvegarde importée : {f}",
    "backup.uploadFailed": "Échec de l'importation",
    "backup.uploadDesc": "Importez un fichier de sauvegarde précédemment téléchargé.",
    "backup.confirmRestore": "Êtes-vous sûr de vouloir restaurer cette sauvegarde ? Les données actuelles seront écrasées.",
    "backup.confirmDelete": "Êtes-vous sûr de vouloir supprimer cette sauvegarde ?",
    "backup.noBackups": "Aucune sauvegarde trouvée. Créez votre première sauvegarde ci-dessus.",
    "backup.lastBackup": "Dernière sauvegarde",
    "backup.totalBackups": "Total sauvegardes",
    "backup.createdBy": "Créé par",
    "backup.createdAt": "Créé le",
    "backup.fileSize": "Taille du fichier",
    "backup.contents": "Contenu",
    "backup.selectTables": "Sélectionner les tables à restaurer",
    "backup.restoreSuccess": "Sauvegarde restaurée avec succès",
    "backup.createSuccess": "Sauvegarde créée avec succès",
    "backup.clusters": "Clusters",
    "backup.users": "Utilisateurs",
    "backup.ptzTraces": "Traces PTZ",
    "backup.alarmEvents": "Événements d'alarme",
    "backup.auditLog": "Journal d'audit",
    "backup.rolePermissions": "Permissions des rôles",
    "backup.plantImages": "Images d'installation",
    "backup.siteName": "Nom du site",
    "backup.siteNameDesc": "Identifie cette installation dans les noms de fichiers de sauvegarde",
    "backup.siteNamePlaceholder": "ex. Raffinerie-Nord",
    "ftp.title": "Sauvegarde FTP programmée",
    "ftp.description": "Envoyer automatiquement des sauvegardes vers un serveur FTP externe à intervalles réguliers.",
    "ftp.enabled": "Activer la sauvegarde FTP programmée",
    "ftp.host": "Hôte FTP",
    "ftp.port": "Port",
    "ftp.user": "Nom d'utilisateur",
    "ftp.password": "Mot de passe",
    "ftp.remotePath": "Chemin distant",
    "ftp.secure": "Utiliser FTPS (Sécurisé)",
    "ftp.interval": "Intervalle de sauvegarde (heures)",
    "ftp.testConnection": "Tester la connexion",
    "ftp.testing": "Test en cours...",
    "ftp.testSuccess": "Connexion réussie",
    "ftp.testFailed": "Échec de connexion",
    "ftp.backupNow": "Envoyer la sauvegarde maintenant",
    "ftp.sending": "Envoi...",
    "ftp.lastBackup": "Dernière sauvegarde FTP",
    "ftp.lastResult": "Dernier résultat",
    "ftp.schedulerActive": "Planificateur actif",
    "ftp.saveSettings": "Enregistrer les paramètres FTP",
    "ftp.saving": "Enregistrement...",
    "ftp.saved": "Paramètres enregistrés",
    "ftp.never": "Jamais",
    "ftp.success": "Succès",
    "ftp.error": "Erreur",
    "ftp.yes": "Oui",
    "ftp.no": "Non",
    "settings.license": "Licence",
    "settings.activeUsers": "UTILISATEURS ACTIFS",
    "settings.levelLegend": "LÉGENDE DES NIVEAUX",
    "settings.userAccounts": "Comptes Utilisateurs",
    "settings.language": "Langue",
    "settings.languageDesc": "Sélectionnez la langue de l'interface",
    "users.accessDenied": "Accès Refusé",
    "users.superAdminRequired": "Niveau Super Admin (Lv.5) requis pour gérer les utilisateurs.",
    "users.backToSettings": "RETOUR AUX PARAMÈTRES",
    "users.userManagement": "Gestion des Utilisateurs",
    "users.accountAdmin": "Administration des Comptes",
    "users.editUser": "Modifier l'Utilisateur",
    "users.displayName": "NOM D'AFFICHAGE",
    "users.role": "RÔLE",
    "users.level": "NIVEAU",
    "users.deactivateUser": "Désactiver cet utilisateur ?",
    "users.newPassword": "NOUVEAU MOT DE PASSE",
    "users.minChars": "4 caractères minimum",
    "users.change": "MODIFIER",
    "users.addUser": "AJOUTER UTILISATEUR",
    "users.newUser": "Nouvel Utilisateur",
    "roles.viewer": "Observateur",
    "roles.operator": "Opérateur",
    "roles.supervisor": "Superviseur",
    "roles.admin": "Administrateur",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Page non trouvée",
    "notFound.hint": "Avez-vous oublié d'ajouter la page au routeur ?",
    "settings.roles": "Rôles & Permissions",
    "settings.rolesDesc": "Configurez les permissions pour chaque niveau d'utilisateur. Les changements prennent effet immédiatement.",
    "settings.resetDefaults": "RÉINITIALISER",
    "settings.rolesLevel5Note": "Les permissions du niveau 5 (Super Admin) ne peuvent pas être modifiées — l'accès complet est toujours garanti.",
    "settings.permission": "PERMISSION",
    "settings.level": "NIV",
    "settings.saving": "ENREGISTREMENT...",
    "perm.acknowledgeAlarms": "Acquitter les alarmes",
    "perm.controlPtz": "Contrôles caméra PTZ",
    "perm.recordTraces": "Enregistrer les traces PTZ",
    "perm.accessSettings": "Accéder aux paramètres",
    "perm.manageClusters": "Gérer les clusters",
    "perm.accessStreaming": "Gestion du streaming",
    "perm.managePlantImages": "Gérer les images usine",
    "perm.deleteTraces": "Supprimer les traces PTZ",
    "perm.manageUsers": "Gestion des utilisateurs",
    "perm.changeLanguage": "Changer la langue",
    "perm.viewEmissions": "Voir les données d'émissions",
    "perm.exportReports": "Exporter les rapports PDF",
    "perm.manageAlarms": "Gérer les alarmes",
    "perm.manageSystem": "Gérer le système",
    "perm.deleteSystemLog": "Supprimer le journal système",
    "access.restricted": "Accès restreint",
    "access.ptzRestricted": "Les contrôles PTZ nécessitent le niveau Opérateur ou supérieur",
    "access.settingsRestricted": "Les paramètres nécessitent le niveau Superviseur ou supérieur",
    "access.readOnlyMode": "Mode lecture seule — Niveau Admin requis pour les modifications",
    "access.ackRestricted": "L'acquittement d'alarme nécessite le niveau Opérateur ou supérieur",
    "alarm.state.UNACK": "NON ACQUITTÉE",
    "alarm.state.ACKED": "ACQUITTÉE",
    "alarm.state.RTNUN": "RETOUR À LA NORMALE",
    "alarm.state.SHLVD": "MISE EN ATTENTE",
    "alarm.priority.HIGH": "HAUTE",
    "alarm.priority.MEDIUM": "MOYENNE",
    "alarm.priority.LOW": "BASSE",
    "alarm.shelve": "METTRE EN ATTENTE",
    "alarm.unshelve": "RÉTABLIR",
    "alarm.shelveReason": "Raison de mise en attente",
    "alarm.shelvedUntil": "En attente jusqu'à",
    "alarm.shelvedBy": "Mis en attente par",
    "alarm.outOfService": "HORS SERVICE",
    "alarm.oosReason": "Raison hors service",
    "alarm.oosBy": "Mis hors service par",
    "alarm.kpi.alarmRate": "Taux d'alarmes",
    "alarm.kpi.floodDetected": "Inondation détectée",
    "alarm.kpi.staleAlarms": "Alarmes obsolètes",
    "alarm.kpi.priorityDistribution": "Distribution des priorités",
    "alarm.kpi.topBadActors": "Principaux perturbateurs",
    "alarm.kpi.avgAckTime": "Temps moyen d'acquittement",
    "alarm.kpi.unacknowledged": "Non acquittées",
    "alarm.audit.title": "Journal d'audit",
    "alarm.audit.action": "Action",
    "alarm.audit.performedBy": "Effectué par",
    "alarm.audit.details": "Détails",
    "settings.deadband": "Bande morte (%)",
    "settings.onDelay": "Délai d'activation (s)",
    "settings.offDelay": "Délai de désactivation (s)",
    "emissions.title": "Émissions",
    "emissions.selectCluster": "Sélectionner un cluster",
    "emissions.totalEmissions": "Émissions Totales",
    "emissions.uncertainty": "Incertitude",
    "emissions.coverage": "Couverture des Données",
    "emissions.partial": "Partiel",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "Aucune donnée d'émissions disponible",
    "emissions.noCluster": "Sélectionnez un cluster pour voir les émissions",
    "emissions.totalHours": "Heures Totales",
    "emissions.completeHours": "Complètes",
    "emissions.gapHours": "Lacunes de Données",
    "emissions.quality.good": "Bon",
    "emissions.quality.moderate": "Modéré",
    "emissions.quality.poor": "Mauvais",
    "emissions.viewDetail": "Voir le détail complet",
    "emissions.last24h": "24h",
    "emissions.last7d": "7j",
    "emissions.last30d": "30j",
    "emissions.lastYear": "1a",
    "emissions.customRange": "Personnalisé",
    "emissions.allClusters": "Tous les Clusters",
    "analytics": "Analytique",
    "analytics.totalSiteEmissions": "Emissions Totales du Site",
    "analytics.activeLeaks": "Fuites Actives",
    "analytics.siteUncertainty": "Incertitude du Site",
    "analytics.emissionsByCluster": "Emissions par Cluster",
    "analytics.windVsEmissions": "Vent vs Emissions",
    "analytics.assetStatus": "Etat des Actifs",
    "analytics.dataCoverage": "Couverture des Donnees",
    "analytics.lastPeak": "Dernier Pic",
    "analytics.lastReading": "Derniere Lecture",
    "analytics.allClusters": "Tous les Clusters",
    "analytics.windSpeed": "Vitesse du Vent",
    "analytics.emissionRate": "Taux d'Emission",
    "companyInfo": "Info Entreprise",
    "companyName": "Nom Entreprise",
    "companyAddress": "Adresse",
    "companyContact": "Contact",
    "companyLogo": "Logo",
    "uploadLogo": "Charger Logo",
    "exportPdf": "Exporter PDF",
    "generatingPdf": "Generation...",
    "siteReport": "Rapport Site",
    "clusterReport": "Rapport Cluster",
    "pdfBranding": "Branding PDF",
  },
  es: {
    "rep.qGood": "Bueno",
    "rep.qModerate": "Moderado",
    "rep.qPoor": "Deficiente",
    "rep.totalEmissions": "Emisiones Totales",
    "rep.totalSiteEmissions": "Emisiones Totales del Sitio",
    "rep.uncertainty": "Incertidumbre",
    "rep.dataCoverage": "Cobertura de Datos",
    "rep.period": "Periodo",
    "rep.generated": "Generado",
    "rep.confidential": "Confidencial",
    "rep.pageOf": "Página {n} de {m}",
    "rep.subtitle": "Monitorización de fugas de gas",
    "rep.daily": "Diario",
    "rep.weekly": "Semanal",
    "rep.monthly": "Mensual",
    "rep.annual": "Anual",
    "rep.quarterly": "Trimestral",
    "rep.halfYearly": "Semestral",
    "rep.emissionReport": "INFORME DE EMISIONES",
    "rep.siteEmissionReport": "INFORME DE EMISIONES DEL SITIO",
    "rep.dataQuality": "Calidad de datos",
    "rep.colPeriod": "Periodo",
    "rep.colMass": "Masa",
    "rep.colQuality": "Calidad",
    "rep.colReadings": "Lecturas",
    "rep.colCluster": "Clúster",
    "rep.colCoverage": "Cobertura",
    "rep.dailyLeakReport": "INFORME DIARIO DE FUGAS",
    "rep.site": "Sitio",
    "rep.area": "Área",
    "rep.reportDate": "Fecha del informe",
    "rep.leakEvents": "Eventos de fuga",
    "rep.none": "Ninguno",
    "rep.l1Threshold": "Umbral de alarma L1",
    "rep.generatedBy": "Generado por",
    "rep.internalDoc": "Documento interno — generado automáticamente por el sistema de monitorización LMSmini.",
    "rep.noDetections": "SIN DETECCIONES",
    "rep.noDetectionsBody": "No se registró ninguna concentración de gas por encima del umbral de alarma L1 ({p} ppm·m) el {d}.",
    "rep.leakOf": "FUGA {n} DE {m}",
    "rep.colDate": "Fecha",
    "rep.colTime": "Hora",
    "rep.colConcentration": "Concentración",
    "rep.fig": "Fig.",
    "rep.capPlant": "vista de la planta, posición del puntero láser",
    "rep.capPlantNa": "vista de la planta no disponible",
    "rep.capCamera": "vista de la cámara",
    "rep.capCameraNa": "vista de la cámara no disponible",
    "rep.capAt": "{s} · {w} a las {t}",
    "rep.noCameraImage": "SIN IMAGEN DE CÁMARA",
    "rep.noCameraBody": "No se capturó ninguna imagen para este evento. Compruebe que el clúster tiene una cámara configurada y que su flujo RTSP es accesible.",
    "rep.noCameraFile": "El archivo de imagen registrado para este evento ya no está en el disco.",
    "rep.noPlantView": "SIN VISTA DE PLANTA",
    "rep.noPlantBody": "No se registró la posición PTZ de este evento, por lo que no se puede reconstruir la ubicación del puntero láser.",
    "fld.opticalBaseline": "Línea base óptica",
    "syslog.opticalBaseline": "Línea base óptica modificada — {p}",
    "focus.report": "Informe diario",
    "focus.reportBusy": "GENERANDO...",
    "focus.reportSaved": "Informe guardado — {p} fugas",
    "focus.reportSavedEmpty": "Informe guardado — sin detecciones",
    "focus.reportFailed": "Error al generar el informe",
    "ptz.tabManual": "MANUAL",
    "ptz.tabAutomatic": "AUTOMÁTICO",
    "ptz.resetDcs": "Restablecer relé DCS",
    "ptz.threshold": "UMBRAL",
    "ptz.zoomAlwaysOn": "SIEMPRE ACTIVO",
    "ptz.recordPath": "GRABAR RECORRIDO",
    "ptz.recordWaypoint": "GRABAR PUNTO",
    "ptz.pointsRecorded": "puntos grabados",
    "ptz.savedTraces": "RECORRIDOS GUARDADOS",
    "ptz.autoShutoff": "APAGADO AUTOMÁTICO",
    "ptz.autoStopPatrol": "Auto-parar patrulla",
    "ptz.startPatrol": "INICIAR PATRULLA",
    "ptz.stopPatrol": "DETENER PATRULLA",
    "syslog.dcsRelayReset": "Relé DCS restablecido: {p}",
    "fld.laserPointer": "Puntero láser",
    "btn.laserOn": "ENCENDER",
    "btn.laserOff": "APAGAR",
    "btn.saveFirst": "GUARDAR PRIMERO",
    "focus.laserDistance": "Distancia al objetivo",
    "focus.laserOffScreen": "LÁSER fuera de cuadro · alejar zoom",
    "app.subtitle": "Sistema de Supervisión v1.1",
    "login.bootstrapTitle": "Crear administrador",
    "login.bootstrapHint": "Primer inicio: cree la cuenta de administrador.",
    "login.confirmPassword": "Confirmar contraseña",
    "login.bootstrapMismatch": "Las contraseñas no coinciden",
    "login.bootstrapTooShort": "La contraseña debe tener al menos 8 caracteres",
    "hdr.emissionMetrics": "MÉTRICAS DE EMISIÓN",
    "hdr.emissionsOverTime": "EMISIONES EN EL TIEMPO",
    "hdr.windVsEmission": "VIENTO VS EMISIÓN",
    "hdr.assetStatus": "ESTADO DE ACTIVOS",
    "hdr.eventLog": "REGISTRO DE EVENTOS",
    "hdr.performanceMetrics": "MÉTRICAS DE RENDIMIENTO",
    "hdr.priorityDistribution": "DISTRIBUCIÓN DE PRIORIDADES",
    "hdr.ptzMode": "MODO PTZ",
    "hdr.runtimeResources": "RECURSOS DE EJECUCIÓN",
    "hdr.operationalControls": "CONTROLES OPERATIVOS",
    "hdr.ptzTransport": "TRANSPORTE PTZ",
    "hdr.sensorTransport": "TRANSPORTE SENSOR",
    "hdr.laserBeamPointer": "PUNTERO LÁSER",
    "hdr.laserMarkerVideo": "MARCADOR LÁSER (VÍDEO)",
    "hdr.deadbandDelay": "BANDA MUERTA Y RETARDO",
    "hdr.noSignal": "SIN SEÑAL",
    "hdr.cameraIp": "IP CÁMARA",
    "hdr.sensorIp": "IP SENSOR",
    "hdr.dcsIp": "IP DCS",
    "fld.cameraIp": "IP cámara",
    "fld.sensorIp": "IP sensor",
    "fld.enableDcs": "Activar DCS",
    "fld.moxaIp": "IP MOXA",
    "fld.homeDuration": "Duración Home (ms)",
    "fld.ptzIpNport": "IP PTZ (NPort)",
    "fld.ptzIpOwn": "IP PTZ (dirección propia)",
    "focus.ir": "IR",
    "hdr.irCamera": "CÁMARA IR (segunda fuente de vídeo)",
    "settings.irCameraHint": "Dispositivo de red independiente, con IP y credenciales propias. Al configurarlo, el modo Focus muestra una tercera pestaña para alternar; solo se decodifica un flujo a la vez. El marcador láser permanece en la cámara principal, porque se calcula con su campo de visión.",
    "fld.irCameraIp": "IP cámara IR",
    "fld.irCameraUsername": "Usuario cámara IR",
    "fld.irCameraPassword": "Contraseña cámara IR (vacío = sin cambios)",
    "fld.irRtspUrl": "URL de flujo IR (rtsp://)",
    "fld.ptzPort": "Puerto PTZ",
    "fld.deviceAddress": "Dirección dispositivo",
    "fld.sensorPort": "Puerto sensor",
    "fld.pathLength": "Longitud de ruta (m)",
    "fld.enableWind": "Activar viento",
    "fld.windSensorIp": "IP sensor viento",
    "fld.windSensorPort": "Puerto sensor viento",
    "fld.sensorX": "Sensor X",
    "fld.sensorY": "Sensor Y",
    "fld.laserEndX": "Fin láser X",
    "fld.laserEndY": "Fin láser Y",
    "fld.enableLaser": "Activar láser",
    "fld.hOffset": "Desplazamiento H",
    "fld.vOffset": "Desplazamiento V",
    "fld.showOnVideo": "Mostrar en vídeo",
    "fld.baseLaserCamera": "Base láser↔cámara (m)",
    "fld.verticalOffset": "Desplazamiento vertical (m)",
    "fld.laserSide": "Lado del láser",
    "fld.defaultDistance": "Distancia por defecto (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, máx 500 KB",
    "msg.noEmissionPeriod": "Sin datos de emisión para este período",
    "calib.title": "Calibración PTZ",
    "settings.laserMarkerHint": "El marcador estima dónde apunta el láser a partir del zoom + distancia (láser y cámara se mueven juntos en la PTZ). Ajuste el FOV gran angular/tele al modelo de cámara y el offset boresight a una distancia conocida.",
    "calTL": "1: Arriba-Izquierda",
    "calTR": "2: Arriba-Derecha",
    "calBL": "3: Abajo-Izquierda",
    "calBR": "4: Abajo-Derecha",
    "settings.addCalNode": "Añadir nodo",
    "calib.noPlantImage": "Ninguna imagen de planta configurada",
    "calib.configureFirst": "Configure una imagen de planta en los ajustes antes de calibrar.",
    "calib.backToSettings": "Volver a Ajustes",
    "calib.clickToPlace": "Haga clic en la imagen para colocar los puntos. Punto activo:",
    "logs.noEvents": "Ningún evento registrado",
    "settings.calInterpHint": "Interpolación lineal entre nodos zoom→desplazamiento",
    "nav.gridView": "VISTA CUADRÍCULA",
    "nav.siteMap": "MAPA DEL SITIO",
    "nav.logout": "Cerrar sesión",
    "nav.level": "Nivel",
    "home.activeClusters": "CLUSTERS ACTIVOS",
    "home.normal": "NORMAL",
    "home.warnings": "ADVERTENCIAS",
    "home.critical": "CRÍTICO",
    "home.initializing": "INICIALIZANDO...",
    "home.notifications": "Notificaciones",
    "home.unread": "sin leer",
    "home.noAlarms": "SIN ALARMAS",
    "home.ack": "CONF.",
    "home.ackAll": "CONF. TODO",
    "sitemap.status": "ESTADO",
    "sitemap.cluster": "CLUSTER",
    "sitemap.area": "ÁREA",
    "sitemap.thresholds": "UMBRALES",
    "sitemap.focus": "FOCO",
    "login.supervisorySystem": "Sistema de Supervisión",
    "login.operatorAccess": "Acceso de Operador",
    "login.username": "USUARIO",
    "login.systemStatusOk": "TODOS LOS SISTEMAS OPERATIVOS",
    "login.systemStatusOffline": "HARDWARE FUERA DE LÍNEA",
    "login.systemStatusProbing": "COMPROBANDO SISTEMA…",
    "login.systemStatusPartial": "HARDWARE PARCIALMENTE EN LÍNEA",
    "login.systemStatusUnconfigured": "HARDWARE NO CONECTADO",
    "login.systemStatusNoClusters": "Sin clusters configurados",
    "login.cluster": "cluster",
    "login.clusters": "clusters",
    "login.devicesOnline": "en línea",
    "login.devicesOffline": "fuera de línea",
    "login.password": "CONTRASEÑA",
    "login.loggingIn": "ACCEDIENDO...",
    "login.login": "ACCEDER",
    "login.authError": "Error de autenticación",
    "focus.loading": "CARGANDO...",
    "focus.hlsStream": "Flujo HLS",
    "focus.clusterPlant": "Planta del Cluster",
    "focus.video": "VÍDEO",
    "focus.plant": "PLANTA",
    "focus.live": "EN VIVO",
    "focus.noFeed": "SIN SEÑAL",
    "focus.noPlantConfigured": "SIN PLANTA CONFIGURADA",
    "focus.uploadPlantHint": "Suba una imagen de planta en la configuración del cluster",
    "focus.criticalLeak": "FUGA CRÍTICA DETECTADA",
    "focus.warningThreshold": "UMBRAL DE ADVERTENCIA SUPERADO",
    "focus.concentrationAt": "Concentración en",
    "focus.limit": "Límite",
    "focus.acknowledge": "CONFIRMAR",
    "focus.alarmAcked": "Alarma confirmada por Admin",
    "focus.realtimeConcentration": "CONCENTRACIÓN EN TIEMPO REAL",
    "focus.cameraControl": "Control de Cámara",
    "focus.noAlarmEvents": "Sin eventos de alarma registrados",
    "focus.sensorReading":  "Lectura del sensor",
    "syslog.appStarted":    "Aplicación iniciada",
    "syslog.cameraOffline": "Cámara sin conexión: {p}",
    "syslog.cameraOnline":  "Cámara en línea: {p}",
    "syslog.hwSensorOffline": "Sensor láser sin conexión: {p}",
    "syslog.hwSensorOnline":  "Sensor láser en línea: {p}",
    "syslog.ptzOffline":    "PTZ sin conexión: {p}",
    "syslog.ptzOnline":     "PTZ en línea: {p}",
    "syslog.sensorOffline": "Sensor sin conexión: {p}",
    "syslog.sensorOnline":  "Sensor en línea: {p}",
    "syslog.tracesEncoderMigration": "{p} traza(s) PTZ heredada(s) archivada(s) — vuelve a grabar para usar el feedback del encoder",
    "syslog.patrolStarted": "Patrulla automática iniciada — {p}",
    "syslog.patrolStopped": "Patrulla automática detenida — {p}",
    "syslog.patrolStoppedAlarm": "Patrulla automática detenida por alarma CRÍTICA — {p}",
    "syslog.patrolFault": "Patrulla automática detenida — conexión perdida — {p}",
    "syslog.patrolAutoResumeArmed": "Reanudación auto activada — esperando enlace — {p}",
    "syslog.patrolAutoResumed": "Patrulla automática reanudada automáticamente — {p}",
    "syslog.ptzGotoAlarm": "PTZ apuntado a la zona de la alarma — {p}",
    "evt.goToLeak": "IR A LA FUGA",
    "syslog.ptzGotoNoMove": "El PTZ no se movió a la zona de la alarma — {p}",
    "syslog.ptzZeroCalibrated": "Punto cero PTZ calibrado — {p}",
    "syslog.videoLost":     "Señal de vídeo perdida — {p}",
    "syslog.logsCleared":   "Registro del sistema borrado por el operador ({p} entradas eliminadas)",
    "logs.deleteBtn":       "ELIMINAR REGISTROS",
    "logs.downloadBtn":     "DESCARGAR",
    "logs.confirmTitle":    "¿Eliminar todos los registros?",
    "logs.confirmMsg":      "Esto eliminará permanentemente {p} entradas del registro. Una entrada AUDIT que registra esta acción permanecerá. ¿Continuar?",
    "logs.cancel":          "Cancelar",
    "logs.confirm":         "Eliminar",
    "logs.noPermission":    "Permiso insuficiente",
    "focus.operationTime": "Tiempo de operación",
      "focus.systemStatus": "Estado del sistema",
      "focus.laserSensor": "Sensor",
      "focus.ptzCamera": "Cámara",
      "focus.online": "EN LÍNEA",
      "focus.offline": "FUERA DE LÍNEA",
      "focus.horizSpeed": "Vel. horiz.",
      "focus.vertSpeed": "Vel. vert.",
      "focus.parking": "Estacionamiento",
    "focus.home": "Home",
    "syslog.ptzParking": "Aparcamiento transporte (pan 0, tilt arriba) — {p}",
      "focus.wiper": "Limpiador de cámara",
      "focus.operatorControls": "Controles del operador",
      "focus.scanControls": "Controles de escaneo",
      "focus.eventDate": "Fecha",
      "focus.eventTime": "Hora",
      "focus.eventSource": "Fuente",
      "focus.eventDescription": "Evento",
      "focus.gasDetection": "Sistema de detección de gas",
      "focus.userAction": "Acción de usuario",
      "focus.systemLms": "Sistema LMS",
      "focus.alarmTriggeredEvent": "Alarma activada",
      "focus.alarmAckedEvent": "Alarma confirmada",
      "focus.alarmClearedEvent": "Alarma eliminada",
      "focus.alarmShelvedEvent": "Alarma suspendida",
    "ptz.controls": "CONTROLES PTZ",
    "ptz.wide": "ANCHO",
    "ptz.tele": "TELE",
    "ptz.rec": "GRAB.",
    "ptz.points": "PUNTOS",
    "ptz.cancel": "CANCELAR",
    "ptz.point": "PUNTO",
    "ptz.save": "GUARDAR",
    "ptz.traceName": "NOMBRE DE TRAZA",
    "ptz.traceNamePlaceholder": "ej. Escaneo Norte",
    "ptz.presets": "PREAJUSTES",
    "ptz.recordTrace": "GRABAR TRAZA",
    "ptz.modePoints": "Puntos",
    "ptz.mode360": "Barrido 360°",
    "ptz.ringHint": "Incline la cámara a la altura deseada y pulse «Añadir banda». Cada banda = un barrido 360° completo a esa inclinación (12 puntos).",
    "ptz.ringNoEncoder": "Este cabezal no publica su encoder en bruto: el modo 360° por bandas no puede capturar la inclinación.",
    "ptz.ringBand": "inclin. {p}° · 360°",
    "ptz.addBand": "Añadir banda T{p}",
    "ptz.bandsCount": "{p} bandas",
    "ptz.autoStop.off": "OFF",
    "ptz.autoStop.tooltip": "Parar la patrulla automáticamente después de la duración seleccionada",
    "ptz.stopAuto": "PARAR PATRULLA",
    "ptz.autoMode": "INICIAR PATRULLA",
    "ptz.homing": "CALIBRANDO...",
    "ptz.noTrace": "SIN TRAZA",
    "ptz.noTracesSaved": "Sin rutas guardadas",
    "card.streamLost": "CONEXIÓN PTZ PERDIDA",
    "card.live": "EN VIVO",
    "card.standby": "EN ESPERA",
    "card.focusMode": "MODO FOCO",
    "settings.title": "Configuración",
    "settings.systemConfig": "Configuración del Sistema",
    "settings.clusterSettings": "Configuración de Clusters",
    "settings.streaming": "Streaming",
    "settings.system": "Sistema",
    "settings.administration": "Administración",
    "settings.activeClusters": "CLUSTERS ACTIVOS",
    "settings.totalAlarms": "ALARMAS TOTALES",
    "settings.unacknowledged": "SIN CONFIRMAR",
    "settings.clusterManagement": "Gestión de Clusters",
    "settings.loading": "CARGANDO...",
    "settings.editCluster": "Editar Cluster",
    "settings.name": "Nombre",
    "settings.areaCode": "Código de Área",
    "settings.thresholdL1": "Umbral L1 (Advertencia)",
    "settings.thresholdL2": "Umbral L2 (Crítico)",
    "settings.ptzLimits": "LÍMITES PTZ",
    "settings.ptzAutoSpeed": "VELOCIDAD AUTO PAN/TILT",
    "settings.ptzAutoSpeedHint": "Velocidad Pelco-D (1–63) usada durante la patrulla automática y las rutas de waypoints.",
    "settings.ptzPatrolAutoResume": "REANUDAR PATRULLA AUTO",
    "settings.ptzPatrolAutoResumeHint": "Si está activado, tras un fallo de enlace o keepalive el cabezal vuelve a la posición inicial y reanuda la patrulla automáticamente. Si está desactivado, permanece detenido hasta que un operador lo reinicie.",
    "settings.clusterPlant": "PLANTA DEL CLUSTER",
    "settings.replace": "REEMPLAZAR",
    "settings.remove": "ELIMINAR",
    "settings.removePlant": "¿Eliminar la planta?",
    "settings.uploading": "SUBIENDO...",
    "settings.uploadPlant": "SUBIR PLANTA",
    "settings.cancel": "CANCELAR",
    "settings.save": "GUARDAR",
    "settings.ptzTraces": "TRAZAS PTZ",
    "settings.noTraceRecorded": "Sin trazas grabadas. Use los controles PTZ en Modo Foco para grabar una.",
    "settings.deactivate": "DESACTIVAR",
    "settings.select": "SELECCIONAR",
    "settings.deleteTrace": "¿Eliminar esta traza?",
    "settings.addCluster": "AÑADIR CLUSTER",
    "settings.newCluster": "Nuevo Cluster",
    "settings.create": "CREAR",
    "settings.deactivateCluster": "¿Desactivar este cluster?",
    "settings.plant": "Planta",
    "settings.ptzTrace": "Traza PTZ",
    "settings.noHardwareIp": "Sin IP de hardware configurada",
    "settings.totalClusters": "CLUSTERS TOTALES",
    "settings.activeStreams": "STREAMS ACTIVOS",
    "settings.rtspConfigured": "RTSP CONFIGURADOS",
    "settings.converterTitle": "Convertidor RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • Segmentos 2s",
    "settings.starting": "INICIANDO...",
    "settings.active": "ACTIVO",
    "settings.error": "ERROR",
    "settings.rtspUrl": "URL RTSP",
    "settings.start": "INICIAR",
    "settings.stop": "DETENER",
    "settings.startedAt": "Iniciado:",
    "settings.loadingDiag": "CARGANDO DIAGNÓSTICOS...",
    "settings.ramMemory": "MEMORIA RAM",
    "settings.totalRequests": "peticiones totales",
    "settings.wsClients": "clientes WebSocket",
    "settings.database": "Base de Datos",
    "settings.latency": "LATENCIA",
    "settings.apiHealth": "Salud de la API",
    "settings.systemInfo": "Información del Sistema",
    "settings.softwareVersion": "Versión del Software",
    "settings.cameraProtocol": "Protocolo de Cámara",
    "settings.ptzModel": "MODELO PTZ",
    "settings.ptzModelLabel": "Modelo de equipo",
    "settings.ptzModelHint": "Selecciona el tipo de equipo: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D vía NPort) o BIK-INFORM (Pelco-D extendido vía NPort, óptica fija, sin zoom) — configura protocolo y transporte automáticamente. Custom = campos manuales.",
    "settings.telemetryFreq": "Frecuencia de Telemetría",
    "settings.defaultThresholdL1": "Umbral L1 por defecto",
    "settings.defaultThresholdL2": "Umbral L2 por defecto",
    "settings.alarmManagement": "Gestión de Alarmas",
    "settings.simulationMode": "Modo Demo (Simulación)",
    "settings.simulationDesc": "Cuando está habilitado, genera datos de sensores simulados para demostraciones y ferias. Deshabilitar para operación con hardware real.",
    "settings.simulationEnabled": "Simulación Activa",
    "settings.simulationDisabled": "Modo Hardware Real",
    "alarm.hero.allClear": "TODO DESPEJADO",
    "alarm.hero.unacked": "{n} SIN RECONOCER",
    "alarm.hero.stale": "{n} ALARMAS OBSOLETAS",
    "alarm.hero.flood": "INUNDACIÓN DE ALARMAS",
    "alarm.hero.disabled": "ALARMAS DESACTIVADAS",
    "alarm.hero.warmingUp": "Cargando métricas…",
    "alarm.toggle.label": "Generación",
    "alarm.stopPatrol.label": "Detener patrulla en L2",
    "alarm.audioAlert.label": "Alerta sonora",
    "alarm.toggle.on": "ACTIVADO",
    "alarm.toggle.off": "DESACTIVADO",
    "system.titleOk": "TODOS LOS SISTEMAS OPERATIVOS",
    "system.titleDemo": "MODO DEMO ACTIVO",
    "system.titleWarning": "USO ELEVADO DE RECURSOS",
    "system.titleCritical": "ERROR DE BASE DE DATOS",
    "system.cores": "núcleos",
    "system.warmingUp": "Inicializando…",
    "settings.backupRestore": "Copia de Seguridad y Restauración",
    "backup.title": "Copia de Seguridad y Restauración",
    "backup.description": "Cree copias de seguridad completas del sistema y restaure desde instantáneas anteriores. Las copias incluyen todos los clusters, usuarios, alarmas, registros de auditoría, permisos e imágenes de planta.",
    "backup.createBackup": "Crear copia de seguridad",
    "backup.creating": "Creando copia...",
    "backup.restoring": "Restaurando...",
    "backup.restore": "Restaurar",
    "backup.restoreFailed": "Error en la restauración",
    "backup.download": "Descargar",
    "backup.delete": "Eliminar",
    "backup.upload": "Subir copia de seguridad",
    "backup.uploadSuccess": "Copia subida: {f}",
    "backup.uploadFailed": "Error al subir",
    "backup.uploadDesc": "Suba un archivo de copia de seguridad previamente descargado.",
    "backup.confirmRestore": "¿Está seguro de que desea restaurar esta copia? Los datos actuales se sobrescribirán.",
    "backup.confirmDelete": "¿Está seguro de que desea eliminar esta copia de seguridad?",
    "backup.noBackups": "No se encontraron copias de seguridad. Cree su primera copia arriba.",
    "backup.lastBackup": "Última copia",
    "backup.totalBackups": "Total de copias",
    "backup.createdBy": "Creado por",
    "backup.createdAt": "Creado el",
    "backup.fileSize": "Tamaño del archivo",
    "backup.contents": "Contenido",
    "backup.selectTables": "Seleccionar tablas a restaurar",
    "backup.restoreSuccess": "Copia restaurada correctamente",
    "backup.createSuccess": "Copia de seguridad creada correctamente",
    "backup.clusters": "Clusters",
    "backup.users": "Usuarios",
    "backup.ptzTraces": "Trazas PTZ",
    "backup.alarmEvents": "Eventos de alarma",
    "backup.auditLog": "Registro de auditoría",
    "backup.rolePermissions": "Permisos de roles",
    "backup.plantImages": "Imágenes de planta",
    "backup.siteName": "Nombre del sitio",
    "backup.siteNameDesc": "Identifica esta instalación en los nombres de archivo de copia de seguridad",
    "backup.siteNamePlaceholder": "ej. Refinería-Norte",
    "ftp.title": "Copia de seguridad FTP programada",
    "ftp.description": "Enviar automáticamente copias de seguridad a un servidor FTP externo a intervalos regulares.",
    "ftp.enabled": "Activar copia de seguridad FTP programada",
    "ftp.host": "Host FTP",
    "ftp.port": "Puerto",
    "ftp.user": "Usuario",
    "ftp.password": "Contraseña",
    "ftp.remotePath": "Ruta remota",
    "ftp.secure": "Usar FTPS (Seguro)",
    "ftp.interval": "Intervalo de copia (horas)",
    "ftp.testConnection": "Probar conexión",
    "ftp.testing": "Probando...",
    "ftp.testSuccess": "Conexión exitosa",
    "ftp.testFailed": "Conexión fallida",
    "ftp.backupNow": "Enviar copia ahora",
    "ftp.sending": "Enviando...",
    "ftp.lastBackup": "Última copia FTP",
    "ftp.lastResult": "Último resultado",
    "ftp.schedulerActive": "Programador activo",
    "ftp.saveSettings": "Guardar configuración FTP",
    "ftp.saving": "Guardando...",
    "ftp.saved": "Configuración guardada",
    "ftp.never": "Nunca",
    "ftp.success": "Éxito",
    "ftp.error": "Error",
    "ftp.yes": "Sí",
    "ftp.no": "No",
    "settings.license": "Licencia",
    "settings.activeUsers": "USUARIOS ACTIVOS",
    "settings.levelLegend": "LEYENDA DE NIVELES",
    "settings.userAccounts": "Cuentas de Usuario",
    "settings.language": "Idioma",
    "settings.languageDesc": "Seleccione el idioma de la interfaz",
    "users.accessDenied": "Acceso Denegado",
    "users.superAdminRequired": "Se requiere nivel Super Admin (Lv.5) para gestionar usuarios.",
    "users.backToSettings": "VOLVER A CONFIGURACIÓN",
    "users.userManagement": "Gestión de Usuarios",
    "users.accountAdmin": "Administración de Cuentas",
    "users.editUser": "Editar Usuario",
    "users.displayName": "NOMBRE VISIBLE",
    "users.role": "ROL",
    "users.level": "NIVEL",
    "users.deactivateUser": "¿Desactivar este usuario?",
    "users.newPassword": "NUEVA CONTRASEÑA",
    "users.minChars": "Mínimo 4 caracteres",
    "users.change": "CAMBIAR",
    "users.addUser": "AÑADIR USUARIO",
    "users.newUser": "Nuevo Usuario",
    "roles.viewer": "Visor",
    "roles.operator": "Operador",
    "roles.supervisor": "Supervisor",
    "roles.admin": "Administrador",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Página no encontrada",
    "notFound.hint": "¿Olvidó agregar la página al enrutador?",
    "settings.roles": "Roles y Permisos",
    "settings.rolesDesc": "Configure los permisos para cada nivel de usuario. Los cambios surten efecto inmediatamente.",
    "settings.resetDefaults": "RESTABLECER",
    "settings.rolesLevel5Note": "Los permisos del nivel 5 (Super Admin) no se pueden modificar — el acceso completo está siempre garantizado.",
    "settings.permission": "PERMISO",
    "settings.level": "NIV",
    "settings.saving": "GUARDANDO...",
    "perm.acknowledgeAlarms": "Reconocer alarmas",
    "perm.controlPtz": "Controles de cámara PTZ",
    "perm.recordTraces": "Grabar trazas PTZ",
    "perm.accessSettings": "Acceder a configuración",
    "perm.manageClusters": "Gestionar clusters",
    "perm.accessStreaming": "Gestión de streaming",
    "perm.managePlantImages": "Gestionar imágenes de planta",
    "perm.deleteTraces": "Eliminar trazas PTZ",
    "perm.manageUsers": "Gestión de usuarios",
    "perm.changeLanguage": "Cambiar idioma",
    "perm.viewEmissions": "Ver datos de emisiones",
    "perm.exportReports": "Exportar informes PDF",
    "perm.manageAlarms": "Gestionar alarmas",
    "perm.manageSystem": "Gestionar sistema",
    "perm.deleteSystemLog": "Eliminar registro del sistema",
    "access.restricted": "Acceso restringido",
    "access.ptzRestricted": "Los controles PTZ requieren nivel Operador o superior",
    "access.settingsRestricted": "La configuración requiere nivel Supervisor o superior",
    "access.readOnlyMode": "Modo solo lectura — Se requiere nivel Admin para cambios",
    "access.ackRestricted": "El reconocimiento de alarmas requiere nivel Operador o superior",
    "alarm.state.UNACK": "SIN CONFIRMAR",
    "alarm.state.ACKED": "CONFIRMADA",
    "alarm.state.RTNUN": "RETORNO A NORMAL",
    "alarm.state.SHLVD": "APLAZADA",
    "alarm.priority.HIGH": "ALTA",
    "alarm.priority.MEDIUM": "MEDIA",
    "alarm.priority.LOW": "BAJA",
    "alarm.shelve": "APLAZAR",
    "alarm.unshelve": "RESTABLECER",
    "alarm.shelveReason": "Motivo del aplazamiento",
    "alarm.shelvedUntil": "Aplazada hasta",
    "alarm.shelvedBy": "Aplazada por",
    "alarm.outOfService": "FUERA DE SERVICIO",
    "alarm.oosReason": "Motivo fuera de servicio",
    "alarm.oosBy": "Puesto fuera de servicio por",
    "alarm.kpi.alarmRate": "Tasa de alarmas",
    "alarm.kpi.floodDetected": "Inundación detectada",
    "alarm.kpi.staleAlarms": "Alarmas obsoletas",
    "alarm.kpi.priorityDistribution": "Distribución de prioridades",
    "alarm.kpi.topBadActors": "Principales problemáticos",
    "alarm.kpi.avgAckTime": "Tiempo promedio de confirmación",
    "alarm.kpi.unacknowledged": "Sin confirmar",
    "alarm.audit.title": "Registro de auditoría",
    "alarm.audit.action": "Acción",
    "alarm.audit.performedBy": "Realizado por",
    "alarm.audit.details": "Detalles",
    "settings.deadband": "Banda muerta (%)",
    "settings.onDelay": "Retardo de activación (s)",
    "settings.offDelay": "Retardo de desactivación (s)",
    "emissions.title": "Emisiones",
    "emissions.selectCluster": "Seleccionar cluster",
    "emissions.totalEmissions": "Emisiones Totales",
    "emissions.uncertainty": "Incertidumbre",
    "emissions.coverage": "Cobertura de Datos",
    "emissions.partial": "Parcial",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "No hay datos de emisiones disponibles",
    "emissions.noCluster": "Seleccione un cluster para ver las emisiones",
    "emissions.totalHours": "Horas Totales",
    "emissions.completeHours": "Completas",
    "emissions.gapHours": "Brechas de Datos",
    "emissions.quality.good": "Bueno",
    "emissions.quality.moderate": "Moderado",
    "emissions.quality.poor": "Deficiente",
    "emissions.viewDetail": "Ver detalle completo",
    "emissions.last24h": "24h",
    "emissions.last7d": "7d",
    "emissions.last30d": "30d",
    "emissions.lastYear": "1a",
    "emissions.customRange": "Personalizado",
    "emissions.allClusters": "Todos los Clusters",
    "analytics": "Analitica",
    "analytics.totalSiteEmissions": "Emisiones Totales del Sitio",
    "analytics.activeLeaks": "Fugas Activas",
    "analytics.siteUncertainty": "Incertidumbre del Sitio",
    "analytics.emissionsByCluster": "Emisiones por Cluster",
    "analytics.windVsEmissions": "Viento vs Emisiones",
    "analytics.assetStatus": "Estado de Activos",
    "analytics.dataCoverage": "Cobertura de Datos",
    "analytics.lastPeak": "Ultimo Pico",
    "analytics.lastReading": "Ultima Lectura",
    "analytics.allClusters": "Todos los Clusters",
    "analytics.windSpeed": "Velocidad del Viento",
    "analytics.emissionRate": "Tasa de Emision",
    "companyInfo": "Info Empresa",
    "companyName": "Nombre Empresa",
    "companyAddress": "Direccion",
    "companyContact": "Contacto",
    "companyLogo": "Logo",
    "uploadLogo": "Cargar Logo",
    "exportPdf": "Exportar PDF",
    "generatingPdf": "Generando...",
    "siteReport": "Informe Sitio",
    "clusterReport": "Informe Cluster",
    "pdfBranding": "Branding PDF",
  },
  it: {
    "rep.qGood": "Buono",
    "rep.qModerate": "Moderato",
    "rep.qPoor": "Scarso",
    "rep.totalEmissions": "Emissioni Totali",
    "rep.totalSiteEmissions": "Emissioni Totali Sito",
    "rep.uncertainty": "Incertezza",
    "rep.dataCoverage": "Copertura Dati",
    "rep.period": "Periodo",
    "rep.generated": "Generato",
    "rep.confidential": "Riservato",
    "rep.pageOf": "Pagina {n} di {m}",
    "rep.subtitle": "Monitoraggio fughe di gas",
    "rep.daily": "Giornaliero",
    "rep.weekly": "Settimanale",
    "rep.monthly": "Mensile",
    "rep.annual": "Annuale",
    "rep.quarterly": "Trimestrale",
    "rep.halfYearly": "Semestrale",
    "rep.emissionReport": "REPORT EMISSIONI",
    "rep.siteEmissionReport": "REPORT EMISSIONI SITO",
    "rep.dataQuality": "Qualità dati",
    "rep.colPeriod": "Periodo",
    "rep.colMass": "Massa",
    "rep.colQuality": "Qualità",
    "rep.colReadings": "Letture",
    "rep.colCluster": "Cluster",
    "rep.colCoverage": "Copertura",
    "rep.dailyLeakReport": "REPORT GIORNALIERO FUGHE",
    "rep.site": "Sito",
    "rep.area": "Area",
    "rep.reportDate": "Data del report",
    "rep.leakEvents": "Eventi di fuga",
    "rep.none": "Nessuno",
    "rep.l1Threshold": "Soglia allarme L1",
    "rep.generatedBy": "Generato da",
    "rep.internalDoc": "Documento interno — generato automaticamente dal sistema di monitoraggio LMSmini.",
    "rep.noDetections": "NESSUNA RILEVAZIONE",
    "rep.noDetectionsBody": "Il {d} non è stata registrata alcuna concentrazione di gas superiore alla soglia di allarme L1 ({p} ppm·m).",
    "rep.leakOf": "FUGA {n} DI {m}",
    "rep.colDate": "Data",
    "rep.colTime": "Ora",
    "rep.colConcentration": "Concentrazione",
    "rep.fig": "Fig.",
    "rep.capPlant": "vista impianto, posizione del puntatore laser",
    "rep.capPlantNa": "vista impianto non disponibile",
    "rep.capCamera": "vista camera",
    "rep.capCameraNa": "vista camera non disponibile",
    "rep.capAt": "{s} · {w} alle {t}",
    "rep.noCameraImage": "NESSUNA IMMAGINE CAMERA",
    "rep.noCameraBody": "Per questo evento non è stata catturata alcuna immagine. Verificare che il cluster abbia una camera configurata e che il suo stream RTSP sia raggiungibile.",
    "rep.noCameraFile": "Il file immagine registrato per questo evento non è più presente su disco.",
    "rep.noPlantView": "NESSUNA VISTA IMPIANTO",
    "rep.noPlantBody": "Per questo evento non è stata registrata la posizione PTZ, quindi la posizione del puntatore laser non è ricostruibile.",
    "fld.opticalBaseline": "Baseline ottica",
    "syslog.opticalBaseline": "Baseline ottica modificata — {p}",
    "focus.report": "Report giornaliero",
    "focus.reportBusy": "GENERAZIONE...",
    "focus.reportSaved": "Report salvato — {p} leak",
    "focus.reportSavedEmpty": "Report salvato — nessuna rilevazione",
    "focus.reportFailed": "Generazione report fallita",
    "ptz.tabManual": "MANUALE",
    "ptz.tabAutomatic": "AUTOMATICO",
    "ptz.resetDcs": "Reset relay DCS",
    "ptz.threshold": "SOGLIA",
    "ptz.zoomAlwaysOn": "SEMPRE ATTIVO",
    "ptz.recordPath": "REGISTRAZIONE PERCORSO",
    "ptz.recordWaypoint": "REGISTRA WAYPOINT",
    "ptz.pointsRecorded": "punti registrati",
    "ptz.savedTraces": "TRACCE SALVATE",
    "ptz.autoShutoff": "SPEGNIMENTO AUTOMATICO",
    "ptz.autoStopPatrol": "Auto-stop patrol",
    "ptz.startPatrol": "AVVIA PATROL",
    "ptz.stopPatrol": "FERMA PATROL",
    "syslog.dcsRelayReset": "Relay DCS resettato: {p}",
    "fld.laserPointer": "Puntatore laser",
    "btn.laserOn": "ACCENDI",
    "btn.laserOff": "SPEGNI",
    "btn.saveFirst": "SALVA PRIMA",
    "focus.laserDistance": "Distanza target",
    "focus.laserOffScreen": "LASER fuori campo · allarga lo zoom",
    "app.subtitle": "Sistema di Supervisione v1.1",
    "login.bootstrapTitle": "Crea amministratore",
    "login.bootstrapHint": "Primo avvio — crea l'account amministratore.",
    "login.confirmPassword": "Conferma password",
    "login.bootstrapMismatch": "Le password non coincidono",
    "login.bootstrapTooShort": "La password deve avere almeno 8 caratteri",
    "hdr.emissionMetrics": "METRICHE EMISSIONI",
    "hdr.emissionsOverTime": "EMISSIONI NEL TEMPO",
    "hdr.windVsEmission": "VENTO VS EMISSIONE",
    "hdr.assetStatus": "STATO ASSET",
    "hdr.eventLog": "REGISTRO EVENTI",
    "hdr.performanceMetrics": "METRICHE PRESTAZIONI",
    "hdr.priorityDistribution": "DISTRIBUZIONE PRIORITÀ",
    "hdr.ptzMode": "MODALITÀ PTZ",
    "hdr.runtimeResources": "RISORSE RUNTIME",
    "hdr.operationalControls": "CONTROLLI OPERATIVI",
    "hdr.ptzTransport": "TRASPORTO PTZ",
    "hdr.sensorTransport": "TRASPORTO SENSORE",
    "hdr.laserBeamPointer": "PUNTATORE LASER",
    "hdr.laserMarkerVideo": "MARKER LASER (VIDEO)",
    "hdr.deadbandDelay": "BANDA MORTA & RITARDO",
    "hdr.noSignal": "NESSUN SEGNALE",
    "hdr.cameraIp": "IP TELECAMERA",
    "hdr.sensorIp": "IP SENSORE",
    "hdr.dcsIp": "IP DCS",
    "fld.cameraIp": "IP telecamera",
    "fld.sensorIp": "IP sensore",
    "fld.enableDcs": "Abilita DCS",
    "fld.moxaIp": "IP MOXA",
    "fld.homeDuration": "Durata Home (ms)",
    "fld.ptzIpNport": "IP PTZ (NPort)",
    "fld.ptzIpOwn": "IP PTZ (indirizzo proprio)",
    "focus.ir": "IR",
    "hdr.irCamera": "CAMERA IR (seconda sorgente video)",
    "settings.irCameraHint": "Dispositivo di rete a sé, con IP e credenziali proprie. Se configurata, in Focus compare un terzo tab per commutare fra i due video; si decodifica un solo flusso alla volta. Il marker laser resta solo sulla camera principale, perché è calcolato sul suo campo visivo.",
    "fld.irCameraIp": "IP camera IR",
    "fld.irCameraUsername": "Utente camera IR",
    "fld.irCameraPassword": "Password camera IR (vuoto = invariata)",
    "fld.irRtspUrl": "Stream URL camera IR (rtsp://)",
    "fld.ptzPort": "Porta PTZ",
    "fld.deviceAddress": "Indirizzo dispositivo",
    "fld.sensorPort": "Porta sensore",
    "fld.pathLength": "Lunghezza percorso (m)",
    "fld.enableWind": "Abilita vento",
    "fld.windSensorIp": "IP sensore vento",
    "fld.windSensorPort": "Porta sensore vento",
    "fld.sensorX": "Sensore X",
    "fld.sensorY": "Sensore Y",
    "fld.laserEndX": "Fine laser X",
    "fld.laserEndY": "Fine laser Y",
    "fld.enableLaser": "Abilita laser",
    "fld.hOffset": "Offset H",
    "fld.vOffset": "Offset V",
    "fld.showOnVideo": "Mostra sul video",
    "fld.baseLaserCamera": "Base laser↔camera (m)",
    "fld.verticalOffset": "Offset verticale (m)",
    "fld.laserSide": "Lato laser",
    "fld.defaultDistance": "Distanza predefinita (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, max 500 KB",
    "msg.noEmissionPeriod": "Nessun dato di emissione per questo periodo",
    "calib.title": "Calibrazione PTZ",
    "settings.laserMarkerHint": "Il marker stima dove punta il laser da zoom + distanza (laser e camera sono solidali sul PTZ). Tarare FOV wide/tele sul modello camera e l'offset boresight a distanza nota.",
    "calTL": "1: Alto-Sinistra",
    "calTR": "2: Alto-Destra",
    "calBL": "3: Basso-Sinistra",
    "calBR": "4: Basso-Destra",
    "settings.addCalNode": "Aggiungi nodo",
    "calib.noPlantImage": "Nessuna immagine impianto configurata",
    "calib.configureFirst": "Configura un'immagine impianto nelle impostazioni prima di calibrare.",
    "calib.backToSettings": "Torna alle Impostazioni",
    "calib.clickToPlace": "Clicca sull'immagine per posizionare i punti. Punto attivo:",
    "logs.noEvents": "Nessun evento registrato",
    "settings.calInterpHint": "Interpolazione lineare tra nodi zoom→offset",
    "nav.gridView": "VISTA GRIGLIA",
    "nav.siteMap": "MAPPA SITO",
    "nav.logout": "Esci",
    "nav.level": "Livello",
    "home.activeClusters": "CLUSTER ATTIVI",
    "home.normal": "NORMALI",
    "home.warnings": "AVVISI",
    "home.critical": "CRITICI",
    "home.initializing": "INIZIALIZZAZIONE...",
    "home.notifications": "Notifiche",
    "home.unread": "non letti",
    "home.noAlarms": "NESSUN ALLARME",
    "home.ack": "CONF.",
    "home.ackAll": "CONF. TUTTI",
    "sitemap.status": "STATO",
    "sitemap.cluster": "CLUSTER",
    "sitemap.area": "AREA",
    "sitemap.thresholds": "SOGLIE",
    "sitemap.focus": "FOCUS",
    "login.supervisorySystem": "Sistema di Supervisione",
    "login.operatorAccess": "Accesso Operatore",
    "login.username": "NOME UTENTE",
    "login.systemStatusOk": "TUTTI I SISTEMI OPERATIVI",
    "login.systemStatusOffline": "HARDWARE OFFLINE",
    "login.systemStatusProbing": "VERIFICA SISTEMA…",
    "login.systemStatusPartial": "HARDWARE PARZIALMENTE ONLINE",
    "login.systemStatusUnconfigured": "HARDWARE NON COLLEGATO",
    "login.systemStatusNoClusters": "Nessun cluster configurato",
    "login.cluster": "cluster",
    "login.clusters": "cluster",
    "login.devicesOnline": "online",
    "login.devicesOffline": "offline",
    "login.password": "PASSWORD",
    "login.loggingIn": "ACCESSO...",
    "login.login": "ACCEDI",
    "login.authError": "Errore di autenticazione",
    "focus.loading": "CARICAMENTO...",
    "focus.hlsStream": "Stream HLS",
    "focus.clusterPlant": "Pianta Cluster",
    "focus.video": "VIDEO",
    "focus.plant": "PIANTA",
    "focus.live": "LIVE",
    "focus.noFeed": "NESSUN SEGNALE",
    "focus.noPlantConfigured": "NESSUNA PIANTA CONFIGURATA",
    "focus.uploadPlantHint": "Carica un'immagine pianta nelle impostazioni del cluster",
    "focus.criticalLeak": "PERDITA CRITICA RILEVATA",
    "focus.warningThreshold": "SOGLIA DI AVVISO SUPERATA",
    "focus.concentrationAt": "Concentrazione a",
    "focus.limit": "Limite",
    "focus.acknowledge": "CONFERMA",
    "focus.alarmAcked": "Allarme confermato dall'Admin",
    "focus.realtimeConcentration": "CONCENTRAZIONE IN TEMPO REALE",
    "focus.cameraControl": "Controllo Camera",
    "focus.noAlarmEvents": "Nessun evento di allarme registrato",
    "focus.sensorReading":  "Lettura sensore",
    "syslog.appStarted":    "Applicazione avviata",
    "syslog.cameraOffline": "Camera offline: {p}",
    "syslog.cameraOnline":  "Camera online: {p}",
    "syslog.hwSensorOffline": "Sensore laser offline: {p}",
    "syslog.hwSensorOnline":  "Sensore laser online: {p}",
    "syslog.ptzOffline":    "PTZ offline: {p}",
    "syslog.ptzOnline":     "PTZ online: {p}",
    "syslog.sensorOffline": "Sensore offline: {p}",
    "syslog.sensorOnline":  "Sensore online: {p}",
    "syslog.tracesEncoderMigration": "{p} traccia/e PTZ legacy archiviata/e — ri-registrare per usare il feedback dell'encoder",
    "syslog.patrolStarted": "Auto patrol avviato — {p}",
    "syslog.patrolStopped": "Auto patrol fermato — {p}",
    "syslog.patrolStoppedAlarm": "Auto patrol fermato per allarme CRITICO — {p}",
    "syslog.patrolFault": "Auto patrol fermato — connessione persa — {p}",
    "syslog.patrolAutoResumeArmed": "Auto-resume armato — attendo il link — {p}",
    "syslog.patrolAutoResumed": "Auto patrol ripreso automaticamente — {p}",
    "syslog.ptzGotoAlarm": "PTZ puntato sulla zona dell’allarme — {p}",
    "evt.goToLeak": "VAI AL LEAK",
    "syslog.ptzGotoNoMove": "Il PTZ non si è mosso verso la zona dell’allarme — {p}",
    "syslog.ptzZeroCalibrated": "Posizione 0° del PTZ calibrata — {p}",
    "syslog.videoLost":     "Segnale video perso — {p}",
    "syslog.logsCleared":   "Log di sistema cancellati dall'operatore ({p} voci rimosse)",
    "logs.deleteBtn":       "CANCELLA LOG",
    "logs.downloadBtn":     "SCARICA",
    "logs.confirmTitle":    "Cancellare tutti i log?",
    "logs.confirmMsg":      "Verranno rimosse permanentemente {p} voci di log. Una entry AUDIT che registra questa operazione rimarrà nel sistema. Continuare?",
    "logs.cancel":          "Annulla",
    "logs.confirm":         "Cancella",
    "logs.noPermission":    "Permesso insufficiente",
    "focus.operationTime": "Tempo di funzionamento",
      "focus.systemStatus": "Stato del sistema",
      "focus.laserSensor": "Sensore",
      "focus.ptzCamera": "Telecamera",
      "focus.online": "ONLINE",
      "focus.offline": "OFFLINE",
      "focus.horizSpeed": "Vel. orizz.",
      "focus.vertSpeed": "Vel. vert.",
      "focus.parking": "Parcheggio",
    "focus.home": "Home",
    "syslog.ptzParking": "Parcheggio trasporto (pan 0, tilt su) — {p}",
      "focus.wiper": "Tergi telecamera",
      "focus.operatorControls": "Controlli operatore",
      "focus.scanControls": "Controlli scansione",
      "focus.eventDate": "Data",
      "focus.eventTime": "Ora",
      "focus.eventSource": "Sorgente",
      "focus.eventDescription": "Evento",
      "focus.gasDetection": "Sistema rilevamento gas",
      "focus.userAction": "Azione utente",
      "focus.systemLms": "Sistema LMS",
      "focus.alarmTriggeredEvent": "Allarme attivato",
      "focus.alarmAckedEvent": "Allarme confermato",
      "focus.alarmClearedEvent": "Allarme cancellato",
      "focus.alarmShelvedEvent": "Allarme sospeso",
    "ptz.controls": "CONTROLLI PTZ",
    "ptz.wide": "GRANDANGOLO",
    "ptz.tele": "TELE",
    "ptz.rec": "REG.",
    "ptz.points": "PUNTI",
    "ptz.cancel": "ANNULLA",
    "ptz.point": "PUNTO",
    "ptz.save": "SALVA",
    "ptz.traceName": "NOME TRACCIA",
    "ptz.traceNamePlaceholder": "es. Scansione Nord",
    "ptz.presets": "PRESET",
    "ptz.recordTrace": "REGISTRA TRACCIA",
    "ptz.modePoints": "Punti",
    "ptz.mode360": "Giro 360°",
    "ptz.ringHint": "Inclina la camera all’altezza voluta e premi «Aggiungi fascia». Ogni fascia = un giro 360° completo a quel tilt (12 punti).",
    "ptz.ringNoEncoder": "Questo rig non pubblica l’encoder grezzo: il giro 360° a fasce non può catturare il livello di tilt.",
    "ptz.ringBand": "tilt {p}° · giro 360°",
    "ptz.addBand": "Aggiungi fascia T{p}",
    "ptz.bandsCount": "{p} fasce",
    "ptz.autoStop.off": "OFF",
    "ptz.autoStop.tooltip": "Stop automatico del patrol dopo la durata selezionata",
    "ptz.stopAuto": "FERMA PATTUGLIAMENTO",
    "ptz.autoMode": "AVVIA PATTUGLIAMENTO",
    "ptz.homing": "CALIBRAZIONE...",
    "ptz.noTrace": "NESSUNA TRACCIA",
    "ptz.noTracesSaved": "Nessuna traccia salvata",
    "card.streamLost": "CONNESSIONE PTZ PERSA",
    "card.live": "LIVE",
    "card.standby": "STANDBY",
    "card.focusMode": "MODALITÀ FOCUS",
    "settings.title": "Impostazioni",
    "settings.systemConfig": "Configurazione Sistema",
    "settings.clusterSettings": "Impostazioni Cluster",
    "settings.streaming": "Streaming",
    "settings.system": "Sistema",
    "settings.administration": "Amministrazione",
    "settings.activeClusters": "CLUSTER ATTIVI",
    "settings.totalAlarms": "ALLARMI TOTALI",
    "settings.unacknowledged": "NON CONFERMATI",
    "settings.clusterManagement": "Gestione Cluster",
    "settings.loading": "CARICAMENTO...",
    "settings.editCluster": "Modifica Cluster",
    "settings.name": "Nome",
    "settings.areaCode": "Codice Area",
    "settings.thresholdL1": "Soglia L1 (Avviso)",
    "settings.thresholdL2": "Soglia L2 (Critico)",
    "settings.ptzLimits": "LIMITI PTZ",
    "settings.ptzAutoSpeed": "VELOCITÀ AUTO PAN/TILT",
    "settings.ptzAutoSpeedHint": "Velocità Pelco-D (1–63) usata durante la scansione automatica e i percorsi a waypoint.",
    "settings.ptzPatrolAutoResume": "RIPRESA AUTO PATTUGLIA",
    "settings.ptzPatrolAutoResumeHint": "Se attivo, dopo un guasto del collegamento o del keepalive la testa torna in home e riprende la scansione automaticamente. Se disattivo, resta ferma finché un operatore non la riavvia.",
    "settings.clusterPlant": "PIANTA CLUSTER",
    "settings.replace": "SOSTITUISCI",
    "settings.remove": "RIMUOVI",
    "settings.removePlant": "Rimuovere la pianta?",
    "settings.uploading": "CARICAMENTO...",
    "settings.uploadPlant": "CARICA PIANTA",
    "settings.cancel": "ANNULLA",
    "settings.save": "SALVA",
    "settings.ptzTraces": "TRACCE PTZ",
    "settings.noTraceRecorded": "Nessuna traccia registrata. Usa i controlli PTZ nella Focus Mode per registrarne una.",
    "settings.deactivate": "DISATTIVA",
    "settings.select": "SELEZIONA",
    "settings.deleteTrace": "Eliminare questa traccia?",
    "settings.addCluster": "AGGIUNGI CLUSTER",
    "settings.newCluster": "Nuovo Cluster",
    "settings.create": "CREA",
    "settings.deactivateCluster": "Disattivare questo cluster?",
    "settings.plant": "Pianta",
    "settings.ptzTrace": "Traccia PTZ",
    "settings.noHardwareIp": "Nessun IP hardware configurato",
    "settings.totalClusters": "CLUSTER TOTALI",
    "settings.activeStreams": "STREAM ATTIVI",
    "settings.rtspConfigured": "RTSP CONFIGURATI",
    "settings.converterTitle": "Converter RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • Segmenti 2s",
    "settings.starting": "AVVIO...",
    "settings.active": "ATTIVO",
    "settings.error": "ERRORE",
    "settings.rtspUrl": "URL RTSP",
    "settings.start": "AVVIA",
    "settings.stop": "FERMA",
    "settings.startedAt": "Avviato:",
    "settings.loadingDiag": "CARICAMENTO DIAGNOSTICA...",
    "settings.ramMemory": "MEMORIA RAM",
    "settings.totalRequests": "richieste totali",
    "settings.wsClients": "client WebSocket",
    "settings.database": "Database",
    "settings.latency": "LATENZA",
    "settings.apiHealth": "Salute API",
    "settings.systemInfo": "Informazioni Sistema",
    "settings.softwareVersion": "Versione Software",
    "settings.cameraProtocol": "Protocollo Camera",
    "settings.ptzModel": "MODELLO PTZ",
    "settings.ptzModelLabel": "Modello rig",
    "settings.ptzModelHint": "Seleziona il tipo di rig: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D via NPort) o BIK-INFORM (Pelco-D esteso via NPort, ottica fissa, senza zoom) — imposta protocollo e transport automaticamente. Custom = campi manuali.",
    "settings.telemetryFreq": "Frequenza Telemetria",
    "settings.defaultThresholdL1": "Soglia Default L1",
    "settings.defaultThresholdL2": "Soglia Default L2",
    "settings.alarmManagement": "Gestione Allarmi",
    "settings.simulationMode": "Modalità Demo (Simulazione)",
    "settings.simulationDesc": "Se abilitata, genera dati sensore simulati per dimostrazioni e fiere. Disabilitare per il funzionamento con hardware reale.",
    "settings.simulationEnabled": "Simulazione Attiva",
    "settings.simulationDisabled": "Modalità Hardware Reale",
    "alarm.hero.allClear": "NESSUN ALLARME ATTIVO",
    "alarm.hero.unacked": "{n} DA RICONOSCERE",
    "alarm.hero.stale": "{n} ALLARMI OBSOLETI",
    "alarm.hero.flood": "FLUSSO ALLARMI ELEVATO",
    "alarm.hero.disabled": "ALLARMI DISATTIVATI",
    "alarm.hero.warmingUp": "Caricamento metriche…",
    "alarm.toggle.label": "Generazione",
    "alarm.stopPatrol.label": "Ferma patrol su L2",
    "alarm.audioAlert.label": "Avviso sonoro",
    "alarm.toggle.on": "ATTIVA",
    "alarm.toggle.off": "DISATTIVA",
    "system.titleOk": "TUTTI I SISTEMI OPERATIVI",
    "system.titleDemo": "MODALITÀ DEMO ATTIVA",
    "system.titleWarning": "USO RISORSE ELEVATO",
    "system.titleCritical": "ERRORE DATABASE",
    "system.cores": "core",
    "system.warmingUp": "Inizializzazione…",
    "settings.backupRestore": "Backup e Ripristino",
    "backup.title": "Backup e Ripristino",
    "backup.description": "Crea backup completi del sistema e ripristina da snapshot precedenti. I backup includono tutti i cluster, utenti, allarmi, log di audit, permessi e immagini dell'impianto.",
    "backup.createBackup": "Crea Backup",
    "backup.creating": "Creazione in corso...",
    "backup.restoring": "Ripristino...",
    "backup.restore": "Ripristina",
    "backup.restoreFailed": "Ripristino fallito",
    "backup.download": "Scarica",
    "backup.delete": "Elimina",
    "backup.upload": "Carica Backup",
    "backup.uploadSuccess": "Backup caricato: {f}",
    "backup.uploadFailed": "Caricamento fallito",
    "backup.uploadDesc": "Carica un file di backup precedentemente scaricato.",
    "backup.confirmRestore": "Sei sicuro di voler ripristinare questo backup? I dati attuali verranno sovrascritti.",
    "backup.confirmDelete": "Sei sicuro di voler eliminare questo backup?",
    "backup.noBackups": "Nessun backup trovato. Crea il tuo primo backup sopra.",
    "backup.lastBackup": "Ultimo Backup",
    "backup.totalBackups": "Backup totali",
    "backup.createdBy": "Creato da",
    "backup.createdAt": "Creato il",
    "backup.fileSize": "Dimensione file",
    "backup.contents": "Contenuto",
    "backup.selectTables": "Seleziona tabelle da ripristinare",
    "backup.restoreSuccess": "Backup ripristinato con successo",
    "backup.createSuccess": "Backup creato con successo",
    "backup.clusters": "Cluster",
    "backup.users": "Utenti",
    "backup.ptzTraces": "Tracce PTZ",
    "backup.alarmEvents": "Eventi allarme",
    "backup.auditLog": "Log di audit",
    "backup.rolePermissions": "Permessi dei ruoli",
    "backup.plantImages": "Immagini impianto",
    "backup.siteName": "Nome del sito",
    "backup.siteNameDesc": "Identifica questa installazione nei nomi dei file di backup",
    "backup.siteNamePlaceholder": "es. Raffineria-Nord",
    "ftp.title": "Backup FTP programmato",
    "ftp.description": "Invia automaticamente i backup a un server FTP esterno a intervalli regolari.",
    "ftp.enabled": "Abilita backup FTP programmato",
    "ftp.host": "Host FTP",
    "ftp.port": "Porta",
    "ftp.user": "Nome utente",
    "ftp.password": "Password",
    "ftp.remotePath": "Percorso remoto",
    "ftp.secure": "Usa FTPS (Sicuro)",
    "ftp.interval": "Intervallo backup (ore)",
    "ftp.testConnection": "Test connessione",
    "ftp.testing": "Test in corso...",
    "ftp.testSuccess": "Connessione riuscita",
    "ftp.testFailed": "Connessione fallita",
    "ftp.backupNow": "Invia backup adesso",
    "ftp.sending": "Invio...",
    "ftp.lastBackup": "Ultimo backup FTP",
    "ftp.lastResult": "Ultimo risultato",
    "ftp.schedulerActive": "Pianificatore attivo",
    "ftp.saveSettings": "Salva impostazioni FTP",
    "ftp.saving": "Salvataggio...",
    "ftp.saved": "Impostazioni salvate",
    "ftp.never": "Mai",
    "ftp.success": "Successo",
    "ftp.error": "Errore",
    "ftp.yes": "Sì",
    "ftp.no": "No",
    "settings.license": "Licenza",
    "settings.activeUsers": "UTENTI ATTIVI",
    "settings.levelLegend": "LEGENDA LIVELLI",
    "settings.userAccounts": "Account Utenti",
    "settings.language": "Lingua",
    "settings.languageDesc": "Seleziona la lingua dell'interfaccia",
    "users.accessDenied": "Accesso Negato",
    "users.superAdminRequired": "Serve il livello Super Admin (Lv.5) per gestire gli utenti.",
    "users.backToSettings": "TORNA ALLE IMPOSTAZIONI",
    "users.userManagement": "Gestione Utenti",
    "users.accountAdmin": "Amministrazione Account",
    "users.editUser": "Modifica Utente",
    "users.displayName": "NOME VISUALIZZATO",
    "users.role": "RUOLO",
    "users.level": "LIVELLO",
    "users.deactivateUser": "Disattivare questo utente?",
    "users.newPassword": "NUOVA PASSWORD",
    "users.minChars": "Minimo 4 caratteri",
    "users.change": "CAMBIA",
    "users.addUser": "AGGIUNGI UTENTE",
    "users.newUser": "Nuovo Utente",
    "roles.viewer": "Viewer",
    "roles.operator": "Operatore",
    "roles.supervisor": "Supervisore",
    "roles.admin": "Amministratore",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Pagina non trovata",
    "notFound.hint": "Hai dimenticato di aggiungere la pagina al router?",
    "settings.roles": "Ruoli e Permessi",
    "settings.rolesDesc": "Configura i permessi per ogni livello utente. Le modifiche hanno effetto immediato per tutti gli utenti.",
    "settings.resetDefaults": "RIPRISTINA PREDEFINITI",
    "settings.rolesLevel5Note": "I permessi del livello 5 (Super Admin) non possono essere modificati — l'accesso completo è sempre garantito.",
    "settings.permission": "PERMESSO",
    "settings.level": "LIV",
    "settings.saving": "SALVATAGGIO...",
    "perm.acknowledgeAlarms": "Conferma allarmi",
    "perm.controlPtz": "Controlli telecamera PTZ",
    "perm.recordTraces": "Registra tracce PTZ",
    "perm.accessSettings": "Accedi alle impostazioni",
    "perm.manageClusters": "Gestisci cluster",
    "perm.accessStreaming": "Gestione streaming",
    "perm.managePlantImages": "Gestisci immagini impianto",
    "perm.deleteTraces": "Elimina tracce PTZ",
    "perm.manageUsers": "Gestione utenti",
    "perm.changeLanguage": "Cambia lingua",
    "perm.viewEmissions": "Visualizza dati emissioni",
    "perm.exportReports": "Esporta report PDF",
    "perm.manageAlarms": "Gestisci allarmi",
    "perm.manageSystem": "Gestisci sistema",
    "perm.deleteSystemLog": "Elimina log di sistema",
    "access.restricted": "Accesso limitato",
    "access.ptzRestricted": "I controlli PTZ richiedono il livello Operatore o superiore",
    "access.settingsRestricted": "Le impostazioni richiedono il livello Supervisore o superiore",
    "access.readOnlyMode": "Modalità sola lettura — Livello Admin richiesto per le modifiche",
    "access.ackRestricted": "La conferma allarmi richiede il livello Operatore o superiore",
    "alarm.state.UNACK": "NON CONFERMATO",
    "alarm.state.ACKED": "CONFERMATO",
    "alarm.state.RTNUN": "RITORNO ALLA NORMALITÀ",
    "alarm.state.SHLVD": "SOSPESO",
    "alarm.priority.HIGH": "ALTA",
    "alarm.priority.MEDIUM": "MEDIA",
    "alarm.priority.LOW": "BASSA",
    "alarm.shelve": "SOSPENDI",
    "alarm.unshelve": "RIPRISTINA",
    "alarm.shelveReason": "Motivo sospensione",
    "alarm.shelvedUntil": "Sospeso fino a",
    "alarm.shelvedBy": "Sospeso da",
    "alarm.outOfService": "FUORI SERVIZIO",
    "alarm.oosReason": "Motivo fuori servizio",
    "alarm.oosBy": "Messo fuori servizio da",
    "alarm.kpi.alarmRate": "Tasso di allarmi",
    "alarm.kpi.floodDetected": "Inondazione rilevata",
    "alarm.kpi.staleAlarms": "Allarmi obsoleti",
    "alarm.kpi.priorityDistribution": "Distribuzione priorità",
    "alarm.kpi.topBadActors": "Principali problematici",
    "alarm.kpi.avgAckTime": "Tempo medio di conferma",
    "alarm.kpi.unacknowledged": "Non confermati",
    "alarm.audit.title": "Registro di audit",
    "alarm.audit.action": "Azione",
    "alarm.audit.performedBy": "Eseguito da",
    "alarm.audit.details": "Dettagli",
    "settings.deadband": "Banda morta (%)",
    "settings.onDelay": "Ritardo attivazione (s)",
    "settings.offDelay": "Ritardo disattivazione (s)",
    "emissions.title": "Emissioni",
    "emissions.selectCluster": "Seleziona cluster",
    "emissions.totalEmissions": "Emissioni Totali",
    "emissions.uncertainty": "Incertezza",
    "emissions.coverage": "Copertura Dati",
    "emissions.partial": "Parziale",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "Nessun dato emissioni disponibile",
    "emissions.noCluster": "Seleziona un cluster per vedere le emissioni",
    "emissions.totalHours": "Ore Totali",
    "emissions.completeHours": "Complete",
    "emissions.gapHours": "Gap Dati",
    "emissions.quality.good": "Buono",
    "emissions.quality.moderate": "Moderato",
    "emissions.quality.poor": "Scarso",
    "emissions.viewDetail": "Vedi dettaglio completo",
    "emissions.last24h": "24h",
    "emissions.last7d": "7g",
    "emissions.last30d": "30g",
    "emissions.lastYear": "1a",
    "emissions.customRange": "Personalizzato",
    "emissions.allClusters": "Tutti i Cluster",
    "analytics": "Analisi",
    "analytics.totalSiteEmissions": "Emissioni Totali Sito",
    "analytics.activeLeaks": "Perdite Attive",
    "analytics.siteUncertainty": "Incertezza Sito",
    "analytics.emissionsByCluster": "Emissioni per Cluster",
    "analytics.windVsEmissions": "Vento vs Emissioni",
    "analytics.assetStatus": "Stato Asset",
    "analytics.dataCoverage": "Copertura Dati",
    "analytics.lastPeak": "Ultimo Picco",
    "analytics.lastReading": "Ultima Lettura",
    "analytics.allClusters": "Tutti i Cluster",
    "analytics.windSpeed": "Velocita' Vento",
    "analytics.emissionRate": "Tasso Emissione",
    "companyInfo": "Info Azienda",
    "companyName": "Nome Azienda",
    "companyAddress": "Indirizzo",
    "companyContact": "Contatto",
    "companyLogo": "Logo",
    "uploadLogo": "Carica Logo",
    "exportPdf": "Esporta PDF",
    "generatingPdf": "Generazione...",
    "siteReport": "Report Sito",
    "clusterReport": "Report Cluster",
    "pdfBranding": "Branding PDF",
  },
  hu: {
    "rep.qGood": "Jó",
    "rep.qModerate": "Közepes",
    "rep.qPoor": "Gyenge",
    "rep.totalEmissions": "Összes Kibocsátás",
    "rep.totalSiteEmissions": "Teljes Telephely Kibocsatas",
    "rep.uncertainty": "Bizonytalanság",
    "rep.dataCoverage": "Adatlefedettség",
    "rep.period": "Időszak",
    "rep.generated": "Létrehozva",
    "rep.confidential": "Bizalmas",
    "rep.pageOf": "{n}. oldal / {m}",
    "rep.subtitle": "Gázszivárgás-felügyelet",
    "rep.daily": "Napi",
    "rep.weekly": "Heti",
    "rep.monthly": "Havi",
    "rep.annual": "Éves",
    "rep.quarterly": "Negyedéves",
    "rep.halfYearly": "Féléves",
    "rep.emissionReport": "KIBOCSÁTÁSI JELENTÉS",
    "rep.siteEmissionReport": "TELEPHELYI KIBOCSÁTÁSI JELENTÉS",
    "rep.dataQuality": "Adatminőség",
    "rep.colPeriod": "Időszak",
    "rep.colMass": "Tömeg",
    "rep.colQuality": "Minőség",
    "rep.colReadings": "Mérések",
    "rep.colCluster": "Klaszter",
    "rep.colCoverage": "Lefedettség",
    "rep.dailyLeakReport": "NAPI SZIVÁRGÁSI JELENTÉS",
    "rep.site": "Telephely",
    "rep.area": "Terület",
    "rep.reportDate": "Jelentés dátuma",
    "rep.leakEvents": "Szivárgási események",
    "rep.none": "Nincs",
    "rep.l1Threshold": "L1 riasztási küszöb",
    "rep.generatedBy": "Létrehozta",
    "rep.internalDoc": "Belső dokumentum — az LMSmini felügyeleti rendszer automatikusan készítette.",
    "rep.noDetections": "NINCS ÉSZLELÉS",
    "rep.noDetectionsBody": "{d} napon nem került rögzítésre az L1 riasztási küszöböt ({p} ppm·m) meghaladó gázkoncentráció.",
    "rep.leakOf": "{m} SZIVÁRGÁSBÓL {n}.",
    "rep.colDate": "Dátum",
    "rep.colTime": "Idő",
    "rep.colConcentration": "Koncentráció",
    "rep.fig": "ábra",
    "rep.capPlant": "üzemi nézet, lézermutató pozíciója",
    "rep.capPlantNa": "üzemi nézet nem érhető el",
    "rep.capCamera": "kameranézet",
    "rep.capCameraNa": "kameranézet nem érhető el",
    "rep.capAt": "{s} · {w} — {t}",
    "rep.noCameraImage": "NINCS KAMERAKÉP",
    "rep.noCameraBody": "Ehhez az eseményhez nem készült felvétel. Ellenőrizze, hogy a klaszterhez van-e kamera beállítva, és hogy az RTSP-adatfolyam elérhető-e.",
    "rep.noCameraFile": "Az eseményhez rögzített képfájl már nem található a lemezen.",
    "rep.noPlantView": "NINCS ÜZEMI NÉZET",
    "rep.noPlantBody": "Ehhez az eseményhez nem került rögzítésre PTZ-pozíció, ezért a lézermutató helye nem állítható vissza.",
    "fld.opticalBaseline": "Optikai alapvonal",
    "syslog.opticalBaseline": "Optikai alapvonal módosítva — {p}",
    "focus.report": "Napi jelentés",
    "focus.reportBusy": "KÉSZÍTÉS...",
    "focus.reportSaved": "Jelentés mentve — {p} szivárgás",
    "focus.reportSavedEmpty": "Jelentés mentve — nincs észlelés",
    "focus.reportFailed": "A jelentés készítése sikertelen",
    "ptz.tabManual": "KÉZI",
    "ptz.tabAutomatic": "AUTOMATA",
    "ptz.resetDcs": "DCS relé visszaállítása",
    "ptz.threshold": "KÜSZÖB",
    "ptz.zoomAlwaysOn": "MINDIG AKTÍV",
    "ptz.recordPath": "ÚTVONAL RÖGZÍTÉSE",
    "ptz.recordWaypoint": "PONT RÖGZÍTÉSE",
    "ptz.pointsRecorded": "rögzített pont",
    "ptz.savedTraces": "MENTETT ÚTVONALAK",
    "ptz.autoShutoff": "AUTOMATIKUS LEÁLLÁS",
    "ptz.autoStopPatrol": "Járőr auto-leállítás",
    "ptz.startPatrol": "JÁRŐR INDÍTÁSA",
    "ptz.stopPatrol": "JÁRŐR LEÁLLÍTÁSA",
    "syslog.dcsRelayReset": "DCS relé visszaállítva: {p}",
    "fld.laserPointer": "Lézermutató",
    "btn.laserOn": "BE",
    "btn.laserOff": "KI",
    "btn.saveFirst": "ELŐBB MENTSE",
    "focus.laserDistance": "Céltávolság",
    "focus.laserOffScreen": "LÉZER a képen kívül · kicsinyíts",
    "app.subtitle": "Felügyeleti Rendszer v1.1",
    "login.bootstrapTitle": "Rendszergazda létrehozása",
    "login.bootstrapHint": "Első indítás — hozza létre a rendszergazdai fiókot.",
    "login.confirmPassword": "Jelszó megerősítése",
    "login.bootstrapMismatch": "A jelszavak nem egyeznek",
    "login.bootstrapTooShort": "A jelszónak legalább 8 karakterből kell állnia",
    "hdr.emissionMetrics": "KIBOCSÁTÁSI MUTATÓK",
    "hdr.emissionsOverTime": "KIBOCSÁTÁS IDŐBEN",
    "hdr.windVsEmission": "SZÉL VS KIBOCSÁTÁS",
    "hdr.assetStatus": "ESZKÖZ ÁLLAPOT",
    "hdr.eventLog": "ESEMÉNYNAPLÓ",
    "hdr.performanceMetrics": "TELJESÍTMÉNYMUTATÓK",
    "hdr.priorityDistribution": "PRIORITÁS ELOSZLÁS",
    "hdr.ptzMode": "PTZ MÓD",
    "hdr.runtimeResources": "FUTÁSIDEJŰ ERŐFORRÁSOK",
    "hdr.operationalControls": "ÜZEMI VEZÉRLŐK",
    "hdr.ptzTransport": "PTZ ÁTVITEL",
    "hdr.sensorTransport": "ÉRZÉKELŐ ÁTVITEL",
    "hdr.laserBeamPointer": "LÉZERSUGÁR MUTATÓ",
    "hdr.laserMarkerVideo": "LÉZERJELÖLŐ (VIDEÓ)",
    "hdr.deadbandDelay": "HOLTSÁV ÉS KÉSLELTETÉS",
    "hdr.noSignal": "NINCS JEL",
    "hdr.cameraIp": "KAMERA IP",
    "hdr.sensorIp": "ÉRZÉKELŐ IP",
    "hdr.dcsIp": "DCS IP",
    "fld.cameraIp": "Kamera IP",
    "fld.sensorIp": "Érzékelő IP",
    "fld.enableDcs": "DCS engedélyezése",
    "fld.moxaIp": "MOXA IP",
    "fld.homeDuration": "Home időtartam (ms)",
    "fld.ptzIpNport": "PTZ IP (NPort)",
    "fld.ptzIpOwn": "PTZ IP (saját cím)",
    "focus.ir": "IR",
    "hdr.irCamera": "IR KAMERA (második videóforrás)",
    "settings.irCameraHint": "Önálló hálózati eszköz, saját IP-vel és belépési adatokkal. Beállítva a Fókusz nézet harmadik fület kap a váltáshoz; egyszerre csak egy stream dekódol. A lézerjelölő csak a fő kamerán marad, mert annak látószögéből számoljuk.",
    "fld.irCameraIp": "IR kamera IP",
    "fld.irCameraUsername": "IR kamera felhasználó",
    "fld.irCameraPassword": "IR kamera jelszó (üres = változatlan)",
    "fld.irRtspUrl": "IR stream URL felülbírálás (rtsp://)",
    "fld.ptzPort": "PTZ port",
    "fld.deviceAddress": "Eszközcím",
    "fld.sensorPort": "Érzékelő port",
    "fld.pathLength": "Úthossz (m)",
    "fld.enableWind": "Szél engedélyezése",
    "fld.windSensorIp": "Szélérzékelő IP",
    "fld.windSensorPort": "Szélérzékelő port",
    "fld.sensorX": "Érzékelő X",
    "fld.sensorY": "Érzékelő Y",
    "fld.laserEndX": "Lézer vég X",
    "fld.laserEndY": "Lézer vég Y",
    "fld.enableLaser": "Lézer engedélyezése",
    "fld.hOffset": "H eltolás",
    "fld.vOffset": "V eltolás",
    "fld.showOnVideo": "Megjelenítés a videón",
    "fld.baseLaserCamera": "Lézer↔kamera alap (m)",
    "fld.verticalOffset": "Függőleges eltolás (m)",
    "fld.laserSide": "Lézer oldala",
    "fld.defaultDistance": "Alapért. távolság (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, max 500 KB",
    "msg.noEmissionPeriod": "Nincs kibocsátási adat erre az időszakra",
    "calib.title": "PTZ kalibráció",
    "settings.laserMarkerHint": "A jelölő a zoom + távolság alapján becsüli, hová mutat a lézer (a lézer és a kamera együtt mozog a PTZ-n). Hangolja a FOV nagylátószög/tele értéket a kameramodellhez és a boresight eltolást ismert távolságon.",
    "calTL": "1: Fent-Bal",
    "calTR": "2: Fent-Jobb",
    "calBL": "3: Lent-Bal",
    "calBR": "4: Lent-Jobb",
    "settings.addCalNode": "Csomópont hozzáadása",
    "calib.noPlantImage": "Nincs üzemi kép beállítva",
    "calib.configureFirst": "Kalibrálás előtt állítson be egy üzemi képet a beállításokban.",
    "calib.backToSettings": "Vissza a beállításokhoz",
    "calib.clickToPlace": "Kattintson a képre a pontok elhelyezéséhez. Aktív pont:",
    "logs.noEvents": "Nincs rögzített esemény",
    "settings.calInterpHint": "Lineáris interpoláció a zoom→eltolás csomópontok között",
    "nav.gridView": "RÁCS NÉZET",
    "nav.siteMap": "HELYSZÍNRAJZ",
    "nav.logout": "Kijelentkezés",
    "nav.level": "Szint",
    "home.activeClusters": "AKTÍV KLASZTEREK",
    "home.normal": "NORMÁL",
    "home.warnings": "FIGYELMEZTETÉSEK",
    "home.critical": "KRITIKUS",
    "home.initializing": "INICIALIZÁLÁS...",
    "home.notifications": "Értesítések",
    "home.unread": "olvasatlan",
    "home.noAlarms": "NINCS RIASZTÁS",
    "home.ack": "NYUGT.",
    "home.ackAll": "MIND NYUGT.",
    "sitemap.status": "ÁLLAPOT",
    "sitemap.cluster": "KLASZTER",
    "sitemap.area": "TERÜLET",
    "sitemap.thresholds": "KÜSZÖBÉRTÉKEK",
    "sitemap.focus": "FÓKUSZ",
    "login.supervisorySystem": "Felügyeleti Rendszer",
    "login.operatorAccess": "Kezelői Belépés",
    "login.username": "FELHASZNÁLÓNÉV",
    "login.systemStatusOk": "MINDEN RENDSZER MŰKÖDIK",
    "login.systemStatusOffline": "HARDVER OFFLINE",
    "login.systemStatusProbing": "RENDSZER ELLENŐRZÉSE…",
    "login.systemStatusPartial": "HARDVER RÉSZBEN ONLINE",
    "login.systemStatusUnconfigured": "HARDVER NINCS CSATLAKOZTATVA",
    "login.systemStatusNoClusters": "Nincs konfigurált cluster",
    "login.cluster": "cluster",
    "login.clusters": "cluster",
    "login.devicesOnline": "online",
    "login.devicesOffline": "offline",
    "login.password": "JELSZÓ",
    "login.loggingIn": "BEJELENTKEZÉS...",
    "login.login": "BELÉPÉS",
    "login.authError": "Hitelesítési hiba",
    "focus.loading": "BETÖLTÉS...",
    "focus.hlsStream": "HLS Adatfolyam",
    "focus.clusterPlant": "Klaszter Alaprajz",
    "focus.video": "VIDEÓ",
    "focus.plant": "ALAPRAJZ",
    "focus.live": "ÉLŐ",
    "focus.noFeed": "NINCS JEL",
    "focus.noPlantConfigured": "NINCS ALAPRAJZ BEÁLLÍTVA",
    "focus.uploadPlantHint": "Töltsön fel alaprajz képet a klaszter beállításokban",
    "focus.criticalLeak": "KRITIKUS SZIVÁRGÁS ÉSZLELVE",
    "focus.warningThreshold": "FIGYELMEZTETŐ KÜSZÖB TÚLLÉPVE",
    "focus.concentrationAt": "Koncentráció:",
    "focus.limit": "Határ",
    "focus.acknowledge": "NYUGTÁZÁS",
    "focus.alarmAcked": "Riasztás nyugtázva az Admin által",
    "focus.realtimeConcentration": "VALÓS IDEJŰ KONCENTRÁCIÓ",
    "focus.cameraControl": "Kamera Vezérlés",
    "focus.noAlarmEvents": "Nincs rögzített riasztási esemény",
    "focus.sensorReading":  "Érzékelő mérés",
    "syslog.appStarted":    "Alkalmazás elindult",
    "syslog.cameraOffline": "Kamera offline: {p}",
    "syslog.cameraOnline":  "Kamera online: {p}",
    "syslog.hwSensorOffline": "Lézeres érzékelő offline: {p}",
    "syslog.hwSensorOnline":  "Lézeres érzékelő online: {p}",
    "syslog.ptzOffline":    "PTZ offline: {p}",
    "syslog.ptzOnline":     "PTZ online: {p}",
    "syslog.sensorOffline": "Érzékelő offline: {p}",
    "syslog.sensorOnline":  "Érzékelő online: {p}",
    "syslog.tracesEncoderMigration": "{p} régi PTZ útvonal archiválva — rögzítsd újra az enkóder visszacsatolás használatához",
    "syslog.patrolStarted": "Auto patrol elindult — {p}",
    "syslog.patrolStopped": "Auto patrol leállt — {p}",
    "syslog.patrolStoppedAlarm": "Auto patrol leállt KRITIKUS riasztás miatt — {p}",
    "syslog.patrolFault": "Auto patrol leállt — kapcsolat megszakadt — {p}",
    "syslog.patrolAutoResumeArmed": "Auto-folytatás élesítve — várakozás a kapcsolatra — {p}",
    "syslog.patrolAutoResumed": "Auto patrol automatikusan folytatva — {p}",
    "syslog.ptzGotoAlarm": "PTZ a riasztási helyre irányítva — {p}",
    "evt.goToLeak": "UGRÁS A SZIVÁRGÁSHOZ",
    "syslog.ptzGotoNoMove": "A PTZ nem mozdult a riasztási helyre — {p}",
    "syslog.ptzZeroCalibrated": "PTZ nullpont kalibrálva — {p}",
    "syslog.videoLost":     "Videojel elveszett — {p}",
    "syslog.logsCleared":   "Rendszernapló a kezelő által törölve ({p} bejegyzés eltávolítva)",
    "logs.deleteBtn":       "NAPLÓK TÖRLÉSE",
    "logs.downloadBtn":     "LETÖLTÉS",
    "logs.confirmTitle":    "Töröljük az összes naplót?",
    "logs.confirmMsg":      "Ez véglegesen eltávolít {p} naplóbejegyzést. Egy AUDIT bejegyzés, amely ezt a műveletet rögzíti, megmarad. Folytatja?",
    "logs.cancel":          "Mégse",
    "logs.confirm":         "Törlés",
    "logs.noPermission":    "Nincs jogosultság",
    "focus.operationTime": "Üzemidő",
      "focus.systemStatus": "Rendszer állapot",
      "focus.laserSensor": "Szenzor",
      "focus.ptzCamera": "Kamera",
      "focus.online": "ONLINE",
      "focus.offline": "OFFLINE",
      "focus.horizSpeed": "Vízsz. sebesség",
      "focus.vertSpeed": "Függ. sebesség",
      "focus.parking": "Parkolás",
    "focus.home": "Home",
    "syslog.ptzParking": "Szállítási parkolás (pan 0, dőlés fel) — {p}",
      "focus.wiper": "Kamera-törlő",
      "focus.operatorControls": "Kezelői vezérlés",
      "focus.scanControls": "Pásztázás vezérlés",
      "focus.eventDate": "Dátum",
      "focus.eventTime": "Idő",
      "focus.eventSource": "Forrás",
      "focus.eventDescription": "Esemény",
      "focus.gasDetection": "Gázérzékelő rendszer",
      "focus.userAction": "Felhasználói művelet",
      "focus.systemLms": "LMS rendszer",
      "focus.alarmTriggeredEvent": "Riasztás kiváltva",
      "focus.alarmAckedEvent": "Riasztás nyugtázva",
      "focus.alarmClearedEvent": "Riasztás törölve",
      "focus.alarmShelvedEvent": "Riasztás felfüggesztve",
    "ptz.controls": "PTZ VEZÉRLÉS",
    "ptz.wide": "SZÉLES",
    "ptz.tele": "TELE",
    "ptz.rec": "FELV.",
    "ptz.points": "PONTOK",
    "ptz.cancel": "MÉGSE",
    "ptz.point": "PONT",
    "ptz.save": "MENTÉS",
    "ptz.traceName": "ÚTVONAL NEVE",
    "ptz.traceNamePlaceholder": "pl. Északi Pásztázás",
    "ptz.presets": "ELŐBEÁLLÍTÁSOK",
    "ptz.recordTrace": "ÚTVONAL RÖGZÍTÉS",
    "ptz.modePoints": "Pontok",
    "ptz.mode360": "360°-os körbejárás",
    "ptz.ringHint": "Döntsd a kamerát a kívánt magasságba, és nyomd meg a „Sáv hozzáadása“ gombot. Minden sáv = egy teljes 360°-os körbejárás azon a dőlésen (12 pont).",
    "ptz.ringNoEncoder": "Ez az egység nem adja meg a nyers enkódert: a 360°-os sávos mód nem tudja rögzíteni a dőlést.",
    "ptz.ringBand": "dőlés {p}° · 360°",
    "ptz.addBand": "T{p} sáv hozzáadása",
    "ptz.bandsCount": "{p} sáv",
    "ptz.autoStop.off": "KI",
    "ptz.autoStop.tooltip": "Az őrjárat automatikus leállítása a kiválasztott idő után",
    "ptz.stopAuto": "JÁRŐR STOP",
    "ptz.autoMode": "JÁRŐR INDÍTÁS",
    "ptz.homing": "KALIBRÁLÁS...",
    "ptz.noTrace": "NINCS ÚTVONAL",
    "ptz.noTracesSaved": "Nincs mentett útvonal",
    "card.streamLost": "PTZ KAPCSOLAT ELVESZETT",
    "card.live": "ÉLŐ",
    "card.standby": "KÉSZENLÉTI",
    "card.focusMode": "FÓKUSZ MÓD",
    "settings.title": "Beállítások",
    "settings.systemConfig": "Rendszer Konfiguráció",
    "settings.clusterSettings": "Klaszter Beállítások",
    "settings.streaming": "Streaming",
    "settings.system": "Rendszer",
    "settings.administration": "Adminisztráció",
    "settings.activeClusters": "AKTÍV KLASZTEREK",
    "settings.totalAlarms": "ÖSSZES RIASZTÁS",
    "settings.unacknowledged": "NEM NYUGTÁZOTT",
    "settings.clusterManagement": "Klaszter Kezelés",
    "settings.loading": "BETÖLTÉS...",
    "settings.editCluster": "Klaszter Szerkesztése",
    "settings.name": "Név",
    "settings.areaCode": "Terület Kód",
    "settings.thresholdL1": "Küszöb L1 (Figyelmeztetés)",
    "settings.thresholdL2": "Küszöb L2 (Kritikus)",
    "settings.ptzLimits": "PTZ KORLÁTOK",
    "settings.ptzAutoSpeed": "AUTOMATIKUS PAN/TILT SEBESSÉG",
    "settings.ptzAutoSpeedHint": "Pelco-D sebesség (1–63) az automatikus járőrözéshez és útvonalakhoz.",
    "settings.ptzPatrolAutoResume": "JÁRŐR AUTO. FOLYTATÁS",
    "settings.ptzPatrolAutoResumeHint": "Ha BE, kapcsolat- vagy keepalive-hiba után a fej visszaáll alaphelyzetbe és automatikusan folytatja a járőrözést. Ha KI, leállva marad, amíg a kezelő újra nem indítja.",
    "settings.clusterPlant": "KLASZTER ALAPRAJZ",
    "settings.replace": "CSERE",
    "settings.remove": "ELTÁVOLÍTÁS",
    "settings.removePlant": "Eltávolítja az alaprajzot?",
    "settings.uploading": "FELTÖLTÉS...",
    "settings.uploadPlant": "ALAPRAJZ FELTÖLTÉSE",
    "settings.cancel": "MÉGSE",
    "settings.save": "MENTÉS",
    "settings.ptzTraces": "PTZ ÚTVONALAK",
    "settings.noTraceRecorded": "Nincs rögzített útvonal. Használja a PTZ vezérlőket a Fókusz Módban.",
    "settings.deactivate": "DEAKTIVÁLÁS",
    "settings.select": "KIVÁLASZTÁS",
    "settings.deleteTrace": "Törli ezt az útvonalat?",
    "settings.addCluster": "KLASZTER HOZZÁADÁSA",
    "settings.newCluster": "Új Klaszter",
    "settings.create": "LÉTREHOZÁS",
    "settings.deactivateCluster": "Deaktiválja ezt a klasztert?",
    "settings.plant": "Alaprajz",
    "settings.ptzTrace": "PTZ Útvonal",
    "settings.noHardwareIp": "Nincs hardver IP beállítva",
    "settings.totalClusters": "ÖSSZES KLASZTER",
    "settings.activeStreams": "AKTÍV STREAMEK",
    "settings.rtspConfigured": "RTSP BEÁLLÍTVA",
    "settings.converterTitle": "Konverter RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • 2s Szegmensek",
    "settings.starting": "INDÍTÁS...",
    "settings.active": "AKTÍV",
    "settings.error": "HIBA",
    "settings.rtspUrl": "RTSP URL",
    "settings.start": "INDÍTÁS",
    "settings.stop": "LEÁLLÍTÁS",
    "settings.startedAt": "Indítva:",
    "settings.loadingDiag": "DIAGNOSZTIKA BETÖLTÉSE...",
    "settings.ramMemory": "RAM MEMÓRIA",
    "settings.totalRequests": "összes kérés",
    "settings.wsClients": "WebSocket kliensek",
    "settings.database": "Adatbázis",
    "settings.latency": "KÉSLELTETÉS",
    "settings.apiHealth": "API Állapot",
    "settings.systemInfo": "Rendszer Információ",
    "settings.softwareVersion": "Szoftver Verzió",
    "settings.cameraProtocol": "Kamera Protokoll",
    "settings.ptzModel": "PTZ MODELL",
    "settings.ptzModelLabel": "Rig modell",
    "settings.ptzModelHint": "Kiválasztja a rig típusát: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D NPort-on át) vagy BIK-INFORM (bővített Pelco-D NPort-on át, fix objektív, nincs zoom) — automatikusan beállítja a protokollt és az átvitelt. Custom = kézi mezők.",
    "settings.telemetryFreq": "Telemetria Frekvencia",
    "settings.defaultThresholdL1": "Alapértelmezett Küszöb L1",
    "settings.defaultThresholdL2": "Alapértelmezett Küszöb L2",
    "settings.alarmManagement": "Riasztás Kezelés",
    "settings.simulationMode": "Demo Mód (Szimuláció)",
    "settings.simulationDesc": "Ha engedélyezve van, szimulált szenzor adatokat generál bemutatókhoz és kiállításokhoz. Tiltsa le a valós hardveres üzemeltetéshez.",
    "settings.simulationEnabled": "Szimuláció Aktív",
    "settings.simulationDisabled": "Valós Hardver Mód",
    "alarm.hero.allClear": "NINCS AKTÍV RIASZTÁS",
    "alarm.hero.unacked": "{n} NYUGTÁZATLAN",
    "alarm.hero.stale": "{n} ELAVULT RIASZTÁS",
    "alarm.hero.flood": "RIASZTÁSÁRADAT",
    "alarm.hero.disabled": "RIASZTÁSOK LETILTVA",
    "alarm.hero.warmingUp": "Mérőszámok betöltése…",
    "alarm.toggle.label": "Generálás",
    "alarm.stopPatrol.label": "Patrol leállítása L2-nél",
    "alarm.audioAlert.label": "Hangjelzés",
    "alarm.toggle.on": "BEKAPCSOLVA",
    "alarm.toggle.off": "KIKAPCSOLVA",
    "system.titleOk": "MINDEN RENDSZER MŰKÖDIK",
    "system.titleDemo": "DEMÓ MÓD AKTÍV",
    "system.titleWarning": "MAGAS ERŐFORRÁS-HASZNÁLAT",
    "system.titleCritical": "ADATBÁZIS HIBA",
    "system.cores": "mag",
    "system.warmingUp": "Inicializálás…",
    "settings.backupRestore": "Mentés és Visszaállítás",
    "backup.title": "Mentés és Visszaállítás",
    "backup.description": "Készítsen teljes rendszermentéseket és állítson vissza korábbi pillanatképekből. A mentések tartalmazzák az összes klasztert, felhasználót, riasztást, audit naplót, jogosultságot és üzemi képet.",
    "backup.createBackup": "Mentés létrehozása",
    "backup.creating": "Mentés készítése...",
    "backup.restoring": "Visszaállítás...",
    "backup.restore": "Visszaállítás",
    "backup.restoreFailed": "Visszaállítás sikertelen",
    "backup.download": "Letöltés",
    "backup.delete": "Törlés",
    "backup.upload": "Mentés feltöltése",
    "backup.uploadSuccess": "Mentés feltöltve: {f}",
    "backup.uploadFailed": "Feltöltés sikertelen",
    "backup.uploadDesc": "Töltsön fel egy korábban letöltött mentési fájlt.",
    "backup.confirmRestore": "Biztosan vissza akarja állítani ezt a mentést? A jelenlegi adatok felülíródnak.",
    "backup.confirmDelete": "Biztosan törölni szeretné ezt a mentést?",
    "backup.noBackups": "Nem található mentés. Hozza létre az első mentést fent.",
    "backup.lastBackup": "Utolsó mentés",
    "backup.totalBackups": "Összes mentés",
    "backup.createdBy": "Készítette",
    "backup.createdAt": "Létrehozva",
    "backup.fileSize": "Fájlméret",
    "backup.contents": "Tartalom",
    "backup.selectTables": "Visszaállítandó táblák kiválasztása",
    "backup.restoreSuccess": "Mentés sikeresen visszaállítva",
    "backup.createSuccess": "Mentés sikeresen létrehozva",
    "backup.clusters": "Klaszterek",
    "backup.users": "Felhasználók",
    "backup.ptzTraces": "PTZ útvonalak",
    "backup.alarmEvents": "Riasztási események",
    "backup.auditLog": "Audit napló",
    "backup.rolePermissions": "Szerepkör jogosultságok",
    "backup.plantImages": "Üzemi képek",
    "backup.siteName": "Telephely neve",
    "backup.siteNameDesc": "Azonosítja ezt a telepítést a biztonsági mentés fájlneveiben",
    "backup.siteNamePlaceholder": "pl. Finomító-Észak",
    "ftp.title": "Ütemezett FTP biztonsági mentés",
    "ftp.description": "Automatikusan küld biztonsági mentéseket egy külső FTP szerverre rendszeres időközönként.",
    "ftp.enabled": "Ütemezett FTP mentés engedélyezése",
    "ftp.host": "FTP szerver",
    "ftp.port": "Port",
    "ftp.user": "Felhasználónév",
    "ftp.password": "Jelszó",
    "ftp.remotePath": "Távoli útvonal",
    "ftp.secure": "FTPS használata (Biztonságos)",
    "ftp.interval": "Mentési időköz (óra)",
    "ftp.testConnection": "Kapcsolat tesztelése",
    "ftp.testing": "Tesztelés...",
    "ftp.testSuccess": "Kapcsolat sikeres",
    "ftp.testFailed": "Kapcsolat sikertelen",
    "ftp.backupNow": "Mentés küldése most",
    "ftp.sending": "Küldés...",
    "ftp.lastBackup": "Utolsó FTP mentés",
    "ftp.lastResult": "Utolsó eredmény",
    "ftp.schedulerActive": "Ütemező aktív",
    "ftp.saveSettings": "FTP beállítások mentése",
    "ftp.saving": "Mentés...",
    "ftp.saved": "Beállítások mentve",
    "ftp.never": "Soha",
    "ftp.success": "Sikeres",
    "ftp.error": "Hiba",
    "ftp.yes": "Igen",
    "ftp.no": "Nem",
    "settings.license": "Licenc",
    "settings.activeUsers": "AKTÍV FELHASZNÁLÓK",
    "settings.levelLegend": "SZINT JELMAGYARÁZAT",
    "settings.userAccounts": "Felhasználói Fiókok",
    "settings.language": "Nyelv",
    "settings.languageDesc": "Válassza ki a felület nyelvét",
    "users.accessDenied": "Hozzáférés Megtagadva",
    "users.superAdminRequired": "Super Admin szint (Lv.5) szükséges a felhasználók kezeléséhez.",
    "users.backToSettings": "VISSZA A BEÁLLÍTÁSOKHOZ",
    "users.userManagement": "Felhasználó Kezelés",
    "users.accountAdmin": "Fiók Adminisztráció",
    "users.editUser": "Felhasználó Szerkesztése",
    "users.displayName": "MEGJELENÍTÉSI NÉV",
    "users.role": "SZEREP",
    "users.level": "SZINT",
    "users.deactivateUser": "Deaktiválja ezt a felhasználót?",
    "users.newPassword": "ÚJ JELSZÓ",
    "users.minChars": "Minimum 4 karakter",
    "users.change": "MÓDOSÍTÁS",
    "users.addUser": "FELHASZNÁLÓ HOZZÁADÁSA",
    "users.newUser": "Új Felhasználó",
    "roles.viewer": "Megfigyelő",
    "roles.operator": "Kezelő",
    "roles.supervisor": "Felügyelő",
    "roles.admin": "Adminisztrátor",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Az oldal nem található",
    "notFound.hint": "Elfelejtette hozzáadni az oldalt a routerhez?",
    "settings.roles": "Szerepkörök és Jogosultságok",
    "settings.rolesDesc": "Konfigurálja az egyes felhasználói szintek jogosultságait. A változások azonnal érvénybe lépnek.",
    "settings.resetDefaults": "ALAPÉRTÉKEK VISSZAÁLLÍTÁSA",
    "settings.rolesLevel5Note": "Az 5. szint (Super Admin) jogosultságai nem módosíthatók — a teljes hozzáférés mindig garantált.",
    "settings.permission": "JOGOSULTSÁG",
    "settings.level": "SZT",
    "settings.saving": "MENTÉS...",
    "perm.acknowledgeAlarms": "Riasztások nyugtázása",
    "perm.controlPtz": "PTZ kameravezérlés",
    "perm.recordTraces": "PTZ nyomvonalak rögzítése",
    "perm.accessSettings": "Beállítások elérése",
    "perm.manageClusters": "Klaszterek kezelése",
    "perm.accessStreaming": "Streaming kezelés",
    "perm.managePlantImages": "Üzemképek kezelése",
    "perm.deleteTraces": "PTZ nyomvonalak törlése",
    "perm.manageUsers": "Felhasználókezelés",
    "perm.changeLanguage": "Nyelv módosítása",
    "perm.viewEmissions": "Kibocsátási adatok megtekintése",
    "perm.exportReports": "PDF jelentések exportálása",
    "perm.manageAlarms": "Riasztások kezelése",
    "perm.manageSystem": "Rendszer kezelése",
    "perm.deleteSystemLog": "Rendszernapló törlése",
    "access.restricted": "Hozzáférés korlátozott",
    "access.ptzRestricted": "A PTZ vezérlés Kezelő szintet vagy magasabbat igényel",
    "access.settingsRestricted": "A beállítások Felügyelő szintet vagy magasabbat igényelnek",
    "access.readOnlyMode": "Csak olvasási mód — Admin szint szükséges a módosításokhoz",
    "access.ackRestricted": "A riasztás nyugtázás Kezelő szintet vagy magasabbat igényel",
    "alarm.state.UNACK": "NEM NYUGTÁZOTT",
    "alarm.state.ACKED": "NYUGTÁZOTT",
    "alarm.state.RTNUN": "VISSZATÉRT A NORMÁLBA",
    "alarm.state.SHLVD": "FELFÜGGESZTETT",
    "alarm.priority.HIGH": "MAGAS",
    "alarm.priority.MEDIUM": "KÖZEPES",
    "alarm.priority.LOW": "ALACSONY",
    "alarm.shelve": "FELFÜGGESZTÉS",
    "alarm.unshelve": "VISSZAÁLLÍTÁS",
    "alarm.shelveReason": "Felfüggesztés oka",
    "alarm.shelvedUntil": "Felfüggesztve eddig",
    "alarm.shelvedBy": "Felfüggesztette",
    "alarm.outOfService": "ÜZEMEN KÍVÜL",
    "alarm.oosReason": "Üzemen kívül helyezés oka",
    "alarm.oosBy": "Üzemen kívül helyezte",
    "alarm.kpi.alarmRate": "Riasztási ráta",
    "alarm.kpi.floodDetected": "Riasztás-áradat észlelve",
    "alarm.kpi.staleAlarms": "Elavult riasztások",
    "alarm.kpi.priorityDistribution": "Prioritás eloszlás",
    "alarm.kpi.topBadActors": "Legproblémásabbak",
    "alarm.kpi.avgAckTime": "Átl. nyugtázási idő",
    "alarm.kpi.unacknowledged": "Nem nyugtázott",
    "alarm.audit.title": "Audit napló",
    "alarm.audit.action": "Művelet",
    "alarm.audit.performedBy": "Végrehajtotta",
    "alarm.audit.details": "Részletek",
    "settings.deadband": "Holtszalag (%)",
    "settings.onDelay": "Bekapcsolási késleltetés (s)",
    "settings.offDelay": "Kikapcsolási késleltetés (s)",
    "emissions.title": "Kibocsátások",
    "emissions.selectCluster": "Klaszter kiválasztása",
    "emissions.totalEmissions": "Összes Kibocsátás",
    "emissions.uncertainty": "Bizonytalanság",
    "emissions.coverage": "Adatlefedettség",
    "emissions.partial": "Részleges",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "Nincs elérhető kibocsátási adat",
    "emissions.noCluster": "Válasszon klasztert a kibocsátások megtekintéséhez",
    "emissions.totalHours": "Összes Óra",
    "emissions.completeHours": "Teljes",
    "emissions.gapHours": "Adathiányok",
    "emissions.quality.good": "Jó",
    "emissions.quality.moderate": "Közepes",
    "emissions.quality.poor": "Gyenge",
    "emissions.viewDetail": "Teljes részletek megtekintése",
    "emissions.last24h": "24ó",
    "emissions.last7d": "7n",
    "emissions.last30d": "30n",
    "emissions.lastYear": "1é",
    "emissions.customRange": "Egyéni",
    "emissions.allClusters": "Összes Klaszter",
    "analytics": "Elemzes",
    "analytics.totalSiteEmissions": "Teljes Telephely Kibocsatas",
    "analytics.activeLeaks": "Aktiv Szivargasok",
    "analytics.siteUncertainty": "Telephely Bizonytalansag",
    "analytics.emissionsByCluster": "Kibocsatasok Klaszterenként",
    "analytics.windVsEmissions": "Szel vs Kibocsatas",
    "analytics.assetStatus": "Eszkoz Allapot",
    "analytics.dataCoverage": "Adatlefedettseg",
    "analytics.lastPeak": "Utolso Csucs",
    "analytics.lastReading": "Utolso Meres",
    "analytics.allClusters": "Összes Klaszter",
    "analytics.windSpeed": "Szelsebesseg",
    "analytics.emissionRate": "Kibocsatasi Rata",
    "companyInfo": "Ceg Info",
    "companyName": "Cegnev",
    "companyAddress": "Cim",
    "companyContact": "Kapcsolat",
    "companyLogo": "Logo",
    "uploadLogo": "Logo Feltoltes",
    "exportPdf": "PDF Export",
    "generatingPdf": "Generalas...",
    "siteReport": "Telephely Jelentes",
    "clusterReport": "Klaszter Jelentes",
    "pdfBranding": "PDF Branding",
  },
  ro: {
    "rep.qGood": "Bun",
    "rep.qModerate": "Moderat",
    "rep.qPoor": "Slab",
    "rep.totalEmissions": "Emisii Totale",
    "rep.totalSiteEmissions": "Emisii Totale Locatie",
    "rep.uncertainty": "Incertitudine",
    "rep.dataCoverage": "Acoperire Date",
    "rep.period": "Perioadă",
    "rep.generated": "Generat",
    "rep.confidential": "Confidențial",
    "rep.pageOf": "Pagina {n} din {m}",
    "rep.subtitle": "Monitorizarea scurgerilor de gaz",
    "rep.daily": "Zilnic",
    "rep.weekly": "Săptămânal",
    "rep.monthly": "Lunar",
    "rep.annual": "Anual",
    "rep.quarterly": "Trimestrial",
    "rep.halfYearly": "Semestrial",
    "rep.emissionReport": "RAPORT DE EMISII",
    "rep.siteEmissionReport": "RAPORT DE EMISII AL SITULUI",
    "rep.dataQuality": "Calitatea datelor",
    "rep.colPeriod": "Perioadă",
    "rep.colMass": "Masă",
    "rep.colQuality": "Calitate",
    "rep.colReadings": "Citiri",
    "rep.colCluster": "Cluster",
    "rep.colCoverage": "Acoperire",
    "rep.dailyLeakReport": "RAPORT ZILNIC DE SCURGERI",
    "rep.site": "Sit",
    "rep.area": "Zonă",
    "rep.reportDate": "Data raportului",
    "rep.leakEvents": "Evenimente de scurgere",
    "rep.none": "Niciunul",
    "rep.l1Threshold": "Prag de alarmă L1",
    "rep.generatedBy": "Generat de",
    "rep.internalDoc": "Document intern — generat automat de sistemul de monitorizare LMSmini.",
    "rep.noDetections": "NICIO DETECȚIE",
    "rep.noDetectionsBody": "În data de {d} nu a fost înregistrată nicio concentrație de gaz peste pragul de alarmă L1 ({p} ppm·m).",
    "rep.leakOf": "SCURGEREA {n} DIN {m}",
    "rep.colDate": "Dată",
    "rep.colTime": "Oră",
    "rep.colConcentration": "Concentrație",
    "rep.fig": "Fig.",
    "rep.capPlant": "vedere instalație, poziția indicatorului laser",
    "rep.capPlantNa": "vedere instalație indisponibilă",
    "rep.capCamera": "vedere cameră",
    "rep.capCameraNa": "vedere cameră indisponibilă",
    "rep.capAt": "{s} · {w} la {t}",
    "rep.noCameraImage": "NICIO IMAGINE DE CAMERĂ",
    "rep.noCameraBody": "Pentru acest eveniment nu a fost capturată nicio imagine. Verificați dacă clusterul are o cameră configurată și dacă fluxul RTSP este accesibil.",
    "rep.noCameraFile": "Fișierul imagine înregistrat pentru acest eveniment nu mai există pe disc.",
    "rep.noPlantView": "NICIO VEDERE A INSTALAȚIEI",
    "rep.noPlantBody": "Pentru acest eveniment nu a fost înregistrată poziția PTZ, deci locația indicatorului laser nu poate fi reconstituită.",
    "fld.opticalBaseline": "Linie de bază optică",
    "syslog.opticalBaseline": "Linie de bază optică modificată — {p}",
    "focus.report": "Raport zilnic",
    "focus.reportBusy": "SE GENEREAZĂ...",
    "focus.reportSaved": "Raport salvat — {p} scurgeri",
    "focus.reportSavedEmpty": "Raport salvat — nicio detecție",
    "focus.reportFailed": "Generarea raportului a eșuat",
    "ptz.tabManual": "MANUAL",
    "ptz.tabAutomatic": "AUTOMAT",
    "ptz.resetDcs": "Resetare releu DCS",
    "ptz.threshold": "PRAG",
    "ptz.zoomAlwaysOn": "MEREU ACTIV",
    "ptz.recordPath": "ÎNREGISTRARE TRASEU",
    "ptz.recordWaypoint": "ÎNREGISTRARE PUNCT",
    "ptz.pointsRecorded": "puncte înregistrate",
    "ptz.savedTraces": "TRASEE SALVATE",
    "ptz.autoShutoff": "OPRIRE AUTOMATĂ",
    "ptz.autoStopPatrol": "Auto-oprire patrulă",
    "ptz.startPatrol": "PORNIRE PATRULĂ",
    "ptz.stopPatrol": "OPRIRE PATRULĂ",
    "syslog.dcsRelayReset": "Releu DCS resetat: {p}",
    "fld.laserPointer": "Indicator laser",
    "btn.laserOn": "PORNEȘTE",
    "btn.laserOff": "OPREȘTE",
    "btn.saveFirst": "SALVAȚI ÎNTÂI",
    "focus.laserDistance": "Distanța țintă",
    "focus.laserOffScreen": "LASER în afara cadrului · micșorează zoomul",
    "app.subtitle": "Sistem de Supraveghere v1.1",
    "login.bootstrapTitle": "Creează administrator",
    "login.bootstrapHint": "Prima pornire — creați contul de administrator.",
    "login.confirmPassword": "Confirmă parola",
    "login.bootstrapMismatch": "Parolele nu se potrivesc",
    "login.bootstrapTooShort": "Parola trebuie să aibă cel puțin 8 caractere",
    "hdr.emissionMetrics": "METRICI EMISII",
    "hdr.emissionsOverTime": "EMISII ÎN TIMP",
    "hdr.windVsEmission": "VÂNT VS EMISIE",
    "hdr.assetStatus": "STARE ECHIPAMENTE",
    "hdr.eventLog": "JURNAL EVENIMENTE",
    "hdr.performanceMetrics": "METRICI PERFORMANȚĂ",
    "hdr.priorityDistribution": "DISTRIBUȚIE PRIORITĂȚI",
    "hdr.ptzMode": "MOD PTZ",
    "hdr.runtimeResources": "RESURSE RUNTIME",
    "hdr.operationalControls": "COMENZI OPERAȚIONALE",
    "hdr.ptzTransport": "TRANSPORT PTZ",
    "hdr.sensorTransport": "TRANSPORT SENZOR",
    "hdr.laserBeamPointer": "INDICATOR LASER",
    "hdr.laserMarkerVideo": "MARCATOR LASER (VIDEO)",
    "hdr.deadbandDelay": "BANDĂ MOARTĂ & ÎNTÂRZIERE",
    "hdr.noSignal": "FĂRĂ SEMNAL",
    "hdr.cameraIp": "IP CAMERĂ",
    "hdr.sensorIp": "IP SENZOR",
    "hdr.dcsIp": "IP DCS",
    "fld.cameraIp": "IP cameră",
    "fld.sensorIp": "IP senzor",
    "fld.enableDcs": "Activează DCS",
    "fld.moxaIp": "IP MOXA",
    "fld.homeDuration": "Durată Home (ms)",
    "fld.ptzIpNport": "IP PTZ (NPort)",
    "fld.ptzIpOwn": "IP PTZ (adresă proprie)",
    "focus.ir": "IR",
    "hdr.irCamera": "CAMERĂ IR (a doua sursă video)",
    "settings.irCameraHint": "Dispozitiv de rețea separat, cu IP și credențiale proprii. Configurat, modul Focus primește un al treilea tab pentru comutare; se decodează un singur flux odată. Marcatorul laser rămâne doar pe camera principală, fiind calculat din câmpul ei vizual.",
    "fld.irCameraIp": "IP cameră IR",
    "fld.irCameraUsername": "Utilizator cameră IR",
    "fld.irCameraPassword": "Parolă cameră IR (gol = neschimbată)",
    "fld.irRtspUrl": "URL flux IR (rtsp://)",
    "fld.ptzPort": "Port PTZ",
    "fld.deviceAddress": "Adresă dispozitiv",
    "fld.sensorPort": "Port senzor",
    "fld.pathLength": "Lungime cale (m)",
    "fld.enableWind": "Activează vânt",
    "fld.windSensorIp": "IP senzor vânt",
    "fld.windSensorPort": "Port senzor vânt",
    "fld.sensorX": "Senzor X",
    "fld.sensorY": "Senzor Y",
    "fld.laserEndX": "Capăt laser X",
    "fld.laserEndY": "Capăt laser Y",
    "fld.enableLaser": "Activează laser",
    "fld.hOffset": "Offset H",
    "fld.vOffset": "Offset V",
    "fld.showOnVideo": "Afișează pe video",
    "fld.baseLaserCamera": "Bază laser↔cameră (m)",
    "fld.verticalOffset": "Offset vertical (m)",
    "fld.laserSide": "Latura laser",
    "fld.defaultDistance": "Distanță implicită (m)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, max 500 KB",
    "msg.noEmissionPeriod": "Nicio dată de emisie pentru această perioadă",
    "calib.title": "Calibrare PTZ",
    "settings.laserMarkerHint": "Marcatorul estimează unde indică laserul din zoom + distanță (laserul și camera se mișcă împreună pe PTZ). Reglați FOV wide/tele după modelul camerei și offsetul boresight la o distanță cunoscută.",
    "calTL": "1: Sus-Stânga",
    "calTR": "2: Sus-Dreapta",
    "calBL": "3: Jos-Stânga",
    "calBR": "4: Jos-Dreapta",
    "settings.addCalNode": "Adaugă nod",
    "calib.noPlantImage": "Nicio imagine de instalație configurată",
    "calib.configureFirst": "Configurați o imagine de instalație în setări înainte de calibrare.",
    "calib.backToSettings": "Înapoi la Setări",
    "calib.clickToPlace": "Faceți clic pe imagine pentru a plasa punctele. Punct activ:",
    "logs.noEvents": "Niciun eveniment înregistrat",
    "settings.calInterpHint": "Interpolare liniară între nodurile zoom→offset",
    "nav.gridView": "VIZUALIZARE GRILĂ",
    "nav.siteMap": "HARTĂ AMPLASAMENT",
    "nav.logout": "Deconectare",
    "nav.level": "Nivel",
    "home.activeClusters": "CLUSTERE ACTIVE",
    "home.normal": "NORMAL",
    "home.warnings": "AVERTISMENTE",
    "home.critical": "CRITIC",
    "home.initializing": "INIȚIALIZARE...",
    "home.notifications": "Notificări",
    "home.unread": "necitite",
    "home.noAlarms": "FĂRĂ ALARME",
    "home.ack": "CONF.",
    "home.ackAll": "CONF. TOATE",
    "sitemap.status": "STARE",
    "sitemap.cluster": "CLUSTER",
    "sitemap.area": "ZONĂ",
    "sitemap.thresholds": "PRAGURI",
    "sitemap.focus": "FOCUS",
    "login.supervisorySystem": "Sistem de Supraveghere",
    "login.operatorAccess": "Acces Operator",
    "login.username": "UTILIZATOR",
    "login.systemStatusOk": "TOATE SISTEMELE OPERAȚIONALE",
    "login.systemStatusOffline": "HARDWARE OFFLINE",
    "login.systemStatusProbing": "VERIFICARE SISTEM…",
    "login.systemStatusPartial": "HARDWARE PARȚIAL ONLINE",
    "login.systemStatusUnconfigured": "HARDWARE NECONECTAT",
    "login.systemStatusNoClusters": "Niciun cluster configurat",
    "login.cluster": "cluster",
    "login.clusters": "clustere",
    "login.devicesOnline": "online",
    "login.devicesOffline": "offline",
    "login.password": "PAROLĂ",
    "login.loggingIn": "CONECTARE...",
    "login.login": "CONECTARE",
    "login.authError": "Eroare de autentificare",
    "focus.loading": "ÎNCĂRCARE...",
    "focus.hlsStream": "Flux HLS",
    "focus.clusterPlant": "Plan Cluster",
    "focus.video": "VIDEO",
    "focus.plant": "PLAN",
    "focus.live": "ÎN DIRECT",
    "focus.noFeed": "FĂRĂ SEMNAL",
    "focus.noPlantConfigured": "NICIUN PLAN CONFIGURAT",
    "focus.uploadPlantHint": "Încărcați o imagine a planului în setările clusterului",
    "focus.criticalLeak": "SCURGERE CRITICĂ DETECTATĂ",
    "focus.warningThreshold": "PRAG DE AVERTISMENT DEPĂȘIT",
    "focus.concentrationAt": "Concentrația la",
    "focus.limit": "Limită",
    "focus.acknowledge": "CONFIRMĂ",
    "focus.alarmAcked": "Alarmă confirmată de Admin",
    "focus.realtimeConcentration": "CONCENTRAȚIE ÎN TIMP REAL",
    "focus.cameraControl": "Control Cameră",
    "focus.noAlarmEvents": "Niciun eveniment de alarmă înregistrat",
    "focus.sensorReading":  "Citire senzor",
    "syslog.appStarted":    "Aplicație pornită",
    "syslog.cameraOffline": "Cameră offline: {p}",
    "syslog.cameraOnline":  "Cameră online: {p}",
    "syslog.hwSensorOffline": "Senzor laser offline: {p}",
    "syslog.hwSensorOnline":  "Senzor laser online: {p}",
    "syslog.ptzOffline":    "PTZ offline: {p}",
    "syslog.ptzOnline":     "PTZ online: {p}",
    "syslog.sensorOffline": "Senzor offline: {p}",
    "syslog.sensorOnline":  "Senzor online: {p}",
    "syslog.tracesEncoderMigration": "{p} traseu/trasee PTZ vechi arhivat(e) — reînregistrează pentru a folosi feedback-ul encoder",
    "syslog.patrolStarted": "Patrulare auto pornită — {p}",
    "syslog.patrolStopped": "Patrulare auto oprită — {p}",
    "syslog.patrolStoppedAlarm": "Patrulare auto oprită la alarmă CRITICĂ — {p}",
    "syslog.patrolFault": "Patrulare auto oprită — conexiune pierdută — {p}",
    "syslog.patrolAutoResumeArmed": "Reluare auto activată — se așteaptă legătura — {p}",
    "syslog.patrolAutoResumed": "Patrulare auto reluată automat — {p}",
    "syslog.ptzGotoAlarm": "PTZ direcționat către zona alarmei — {p}",
    "evt.goToLeak": "MERGI LA SCURGERE",
    "syslog.ptzGotoNoMove": "PTZ nu s-a deplasat către zona alarmei — {p}",
    "syslog.ptzZeroCalibrated": "Punctul zero PTZ calibrat — {p}",
    "syslog.videoLost":     "Semnal video pierdut — {p}",
    "syslog.logsCleared":   "Jurnalul de sistem șters de operator ({p} intrări eliminate)",
    "logs.deleteBtn":       "ȘTERGE JURNALELE",
    "logs.downloadBtn":     "DESCARCĂ",
    "logs.confirmTitle":    "Ștergeți toate jurnalele?",
    "logs.confirmMsg":      "Aceasta va elimina permanent {p} intrări din jurnal. O intrare AUDIT care înregistrează această acțiune va rămâne. Continuați?",
    "logs.cancel":          "Anulează",
    "logs.confirm":         "Șterge",
    "logs.noPermission":    "Permisiune insuficientă",
    "focus.operationTime": "Timp de funcționare",
      "focus.systemStatus": "Starea sistemului",
      "focus.laserSensor": "Senzor",
      "focus.ptzCamera": "Cameră",
      "focus.online": "ONLINE",
      "focus.offline": "OFFLINE",
      "focus.horizSpeed": "Vit. orizont.",
      "focus.vertSpeed": "Vit. vert.",
      "focus.parking": "Parcare",
    "focus.home": "Home",
    "syslog.ptzParking": "Parcare transport (pan 0, tilt sus) — {p}",
      "focus.wiper": "Ștergător cameră",
      "focus.operatorControls": "Comenzi operator",
      "focus.scanControls": "Comenzi scanare",
      "focus.eventDate": "Data",
      "focus.eventTime": "Ora",
      "focus.eventSource": "Sursă",
      "focus.eventDescription": "Eveniment",
      "focus.gasDetection": "Sistem detectare gaze",
      "focus.userAction": "Acțiune utilizator",
      "focus.systemLms": "Sistem LMS",
      "focus.alarmTriggeredEvent": "Alarmă declanșată",
      "focus.alarmAckedEvent": "Alarmă confirmată",
      "focus.alarmClearedEvent": "Alarmă ștearsă",
      "focus.alarmShelvedEvent": "Alarmă suspendată",
    "ptz.controls": "COMENZI PTZ",
    "ptz.wide": "LARG",
    "ptz.tele": "TELE",
    "ptz.rec": "ÎNR.",
    "ptz.points": "PUNCTE",
    "ptz.cancel": "ANULARE",
    "ptz.point": "PUNCT",
    "ptz.save": "SALVARE",
    "ptz.traceName": "NUME TRASEU",
    "ptz.traceNamePlaceholder": "ex. Scanare Nord",
    "ptz.presets": "PRESETĂRI",
    "ptz.recordTrace": "ÎNREGISTRARE TRASEU",
    "ptz.modePoints": "Puncte",
    "ptz.mode360": "Rotație 360°",
    "ptz.ringHint": "Înclină camera la înălțimea dorită și apasă „Adaugă bandă“. Fiecare bandă = o rotație completă de 360° la acea înclinare (12 puncte).",
    "ptz.ringNoEncoder": "Acest cap nu publică encoderul brut: modul 360° pe benzi nu poate capta înclinarea.",
    "ptz.ringBand": "înclin. {p}° · 360°",
    "ptz.addBand": "Adaugă banda T{p}",
    "ptz.bandsCount": "{p} benzi",
    "ptz.autoStop.off": "OFF",
    "ptz.autoStop.tooltip": "Oprire automată a patrulei după durata selectată",
    "ptz.stopAuto": "OPRIRE PATRULĂ",
    "ptz.autoMode": "PORNIRE PATRULĂ",
    "ptz.homing": "CALIBRARE...",
    "ptz.noTrace": "FĂRĂ TRASEU",
    "ptz.noTracesSaved": "Niciun traseu salvat",
    "card.streamLost": "CONEXIUNE PTZ PIERDUTĂ",
    "card.live": "ÎN DIRECT",
    "card.standby": "ÎN AȘTEPTARE",
    "card.focusMode": "MOD FOCUS",
    "settings.title": "Setări",
    "settings.systemConfig": "Configurare Sistem",
    "settings.clusterSettings": "Setări Cluster",
    "settings.streaming": "Streaming",
    "settings.system": "Sistem",
    "settings.administration": "Administrare",
    "settings.activeClusters": "CLUSTERE ACTIVE",
    "settings.totalAlarms": "ALARME TOTALE",
    "settings.unacknowledged": "NECONFIRMATE",
    "settings.clusterManagement": "Gestionare Clustere",
    "settings.loading": "ÎNCĂRCARE...",
    "settings.editCluster": "Editare Cluster",
    "settings.name": "Nume",
    "settings.areaCode": "Cod Zonă",
    "settings.thresholdL1": "Prag L1 (Avertisment)",
    "settings.thresholdL2": "Prag L2 (Critic)",
    "settings.ptzLimits": "LIMITE PTZ",
    "settings.ptzAutoSpeed": "VITEZĂ AUTO PAN/TILT",
    "settings.ptzAutoSpeedHint": "Viteză Pelco-D (1–63) folosită în patrula automată și rutele cu waypoint.",
    "settings.ptzPatrolAutoResume": "RELUARE AUTO PATRULĂ",
    "settings.ptzPatrolAutoResumeHint": "Dacă este pornit, după o eroare de legătură sau keepalive capul revine în poziția inițială și reia patrula automat. Dacă este oprit, rămâne oprit până când un operator îl repornește.",
    "settings.clusterPlant": "PLAN CLUSTER",
    "settings.replace": "ÎNLOCUIRE",
    "settings.remove": "ȘTERGERE",
    "settings.removePlant": "Ștergeți planul?",
    "settings.uploading": "ÎNCĂRCARE...",
    "settings.uploadPlant": "ÎNCĂRCARE PLAN",
    "settings.cancel": "ANULARE",
    "settings.save": "SALVARE",
    "settings.ptzTraces": "TRASEE PTZ",
    "settings.noTraceRecorded": "Niciun traseu înregistrat. Folosiți comenzile PTZ în Modul Focus.",
    "settings.deactivate": "DEZACTIVARE",
    "settings.select": "SELECTARE",
    "settings.deleteTrace": "Ștergeți acest traseu?",
    "settings.addCluster": "ADĂUGARE CLUSTER",
    "settings.newCluster": "Cluster Nou",
    "settings.create": "CREARE",
    "settings.deactivateCluster": "Dezactivați acest cluster?",
    "settings.plant": "Plan",
    "settings.ptzTrace": "Traseu PTZ",
    "settings.noHardwareIp": "Niciun IP hardware configurat",
    "settings.totalClusters": "CLUSTERE TOTALE",
    "settings.activeStreams": "STREAMURI ACTIVE",
    "settings.rtspConfigured": "RTSP CONFIGURATE",
    "settings.converterTitle": "Convertor RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • Segmente 2s",
    "settings.starting": "PORNIRE...",
    "settings.active": "ACTIV",
    "settings.error": "EROARE",
    "settings.rtspUrl": "URL RTSP",
    "settings.start": "PORNIRE",
    "settings.stop": "OPRIRE",
    "settings.startedAt": "Pornit:",
    "settings.loadingDiag": "ÎNCĂRCARE DIAGNOSTICE...",
    "settings.ramMemory": "MEMORIE RAM",
    "settings.totalRequests": "cereri totale",
    "settings.wsClients": "clienți WebSocket",
    "settings.database": "Bază de Date",
    "settings.latency": "LATENȚĂ",
    "settings.apiHealth": "Sănătate API",
    "settings.systemInfo": "Informații Sistem",
    "settings.softwareVersion": "Versiune Software",
    "settings.cameraProtocol": "Protocol Cameră",
    "settings.ptzModel": "MODEL PTZ",
    "settings.ptzModelLabel": "Model echipament",
    "settings.ptzModelHint": "Selectează tipul de echipament: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D prin NPort) sau BIK-INFORM (Pelco-D extins prin NPort, optică fixă, fără zoom) — setează automat protocolul și transportul. Custom = câmpuri manuale.",
    "settings.telemetryFreq": "Frecvență Telemetrie",
    "settings.defaultThresholdL1": "Prag Implicit L1",
    "settings.defaultThresholdL2": "Prag Implicit L2",
    "settings.alarmManagement": "Gestionare Alarme",
    "settings.simulationMode": "Mod Demo (Simulare)",
    "settings.simulationDesc": "Când este activat, generează date simulate de la senzori pentru demonstrații și târguri. Dezactivați pentru funcționarea cu hardware real.",
    "settings.simulationEnabled": "Simulare Activă",
    "settings.simulationDisabled": "Mod Hardware Real",
    "alarm.hero.allClear": "NICIO ALARMĂ ACTIVĂ",
    "alarm.hero.unacked": "{n} NECONFIRMATE",
    "alarm.hero.stale": "{n} ALARME ÎNVECHITE",
    "alarm.hero.flood": "INUNDAȚIE DE ALARME",
    "alarm.hero.disabled": "ALARME DEZACTIVATE",
    "alarm.hero.warmingUp": "Se încarcă metricile…",
    "alarm.toggle.label": "Generare",
    "alarm.stopPatrol.label": "Oprește patrularea la L2",
    "alarm.audioAlert.label": "Alertă sonoră",
    "alarm.toggle.on": "ACTIVAT",
    "alarm.toggle.off": "DEZACTIVAT",
    "system.titleOk": "TOATE SISTEMELE OPERAȚIONALE",
    "system.titleDemo": "MOD DEMO ACTIV",
    "system.titleWarning": "UTILIZARE RIDICATĂ A RESURSELOR",
    "system.titleCritical": "EROARE BAZĂ DE DATE",
    "system.cores": "nuclee",
    "system.warmingUp": "Inițializare…",
    "settings.backupRestore": "Backup și Restaurare",
    "backup.title": "Backup și Restaurare",
    "backup.description": "Creați copii de siguranță complete ale sistemului și restaurați din instantanee anterioare. Copiile includ toate clusterele, utilizatorii, alarmele, jurnalele de audit, permisiunile și imaginile instalației.",
    "backup.createBackup": "Creare Backup",
    "backup.creating": "Se creează backup...",
    "backup.restoring": "Se restaurează...",
    "backup.restore": "Restaurare",
    "backup.restoreFailed": "Restaurare eșuată",
    "backup.download": "Descărcare",
    "backup.delete": "Ștergere",
    "backup.upload": "Încărcare Backup",
    "backup.uploadSuccess": "Backup încărcat: {f}",
    "backup.uploadFailed": "Încărcare eșuată",
    "backup.uploadDesc": "Încărcați un fișier de backup descărcat anterior.",
    "backup.confirmRestore": "Sunteți sigur că doriți să restaurați acest backup? Datele curente vor fi suprascrise.",
    "backup.confirmDelete": "Sunteți sigur că doriți să ștergeți acest backup?",
    "backup.noBackups": "Nu s-au găsit backup-uri. Creați primul backup mai sus.",
    "backup.lastBackup": "Ultimul Backup",
    "backup.totalBackups": "Total backup-uri",
    "backup.createdBy": "Creat de",
    "backup.createdAt": "Creat la",
    "backup.fileSize": "Dimensiune fișier",
    "backup.contents": "Conținut",
    "backup.selectTables": "Selectați tabelele de restaurat",
    "backup.restoreSuccess": "Backup restaurat cu succes",
    "backup.createSuccess": "Backup creat cu succes",
    "backup.clusters": "Clustere",
    "backup.users": "Utilizatori",
    "backup.ptzTraces": "Trasee PTZ",
    "backup.alarmEvents": "Evenimente alarmă",
    "backup.auditLog": "Jurnal de audit",
    "backup.rolePermissions": "Permisiuni roluri",
    "backup.plantImages": "Imagini instalație",
    "backup.siteName": "Numele locației",
    "backup.siteNameDesc": "Identifică această instalare în numele fișierelor de backup",
    "backup.siteNamePlaceholder": "ex. Rafinărie-Nord",
    "ftp.title": "Backup FTP programat",
    "ftp.description": "Trimite automat backup-uri către un server FTP extern la intervale regulate.",
    "ftp.enabled": "Activează backup FTP programat",
    "ftp.host": "Gazdă FTP",
    "ftp.port": "Port",
    "ftp.user": "Nume utilizator",
    "ftp.password": "Parolă",
    "ftp.remotePath": "Cale la distanță",
    "ftp.secure": "Folosește FTPS (Securizat)",
    "ftp.interval": "Interval backup (ore)",
    "ftp.testConnection": "Testează conexiunea",
    "ftp.testing": "Se testează...",
    "ftp.testSuccess": "Conexiune reușită",
    "ftp.testFailed": "Conexiune eșuată",
    "ftp.backupNow": "Trimite backup acum",
    "ftp.sending": "Se trimite...",
    "ftp.lastBackup": "Ultimul backup FTP",
    "ftp.lastResult": "Ultimul rezultat",
    "ftp.schedulerActive": "Planificator activ",
    "ftp.saveSettings": "Salvează setările FTP",
    "ftp.saving": "Se salvează...",
    "ftp.saved": "Setări salvate",
    "ftp.never": "Niciodată",
    "ftp.success": "Succes",
    "ftp.error": "Eroare",
    "ftp.yes": "Da",
    "ftp.no": "Nu",
    "settings.license": "Licență",
    "settings.activeUsers": "UTILIZATORI ACTIVI",
    "settings.levelLegend": "LEGENDĂ NIVELURI",
    "settings.userAccounts": "Conturi Utilizatori",
    "settings.language": "Limbă",
    "settings.languageDesc": "Selectați limba interfeței",
    "users.accessDenied": "Acces Refuzat",
    "users.superAdminRequired": "Nivel Super Admin (Lv.5) necesar pentru gestionarea utilizatorilor.",
    "users.backToSettings": "ÎNAPOI LA SETĂRI",
    "users.userManagement": "Gestionare Utilizatori",
    "users.accountAdmin": "Administrare Conturi",
    "users.editUser": "Editare Utilizator",
    "users.displayName": "NUME AFIȘAT",
    "users.role": "ROL",
    "users.level": "NIVEL",
    "users.deactivateUser": "Dezactivați acest utilizator?",
    "users.newPassword": "PAROLĂ NOUĂ",
    "users.minChars": "Minimum 4 caractere",
    "users.change": "MODIFICARE",
    "users.addUser": "ADĂUGARE UTILIZATOR",
    "users.newUser": "Utilizator Nou",
    "roles.viewer": "Observator",
    "roles.operator": "Operator",
    "roles.supervisor": "Supervizor",
    "roles.admin": "Administrator",
    "roles.superadmin": "Super Admin",
    "notFound.title": "404 Pagina nu a fost găsită",
    "notFound.hint": "Ați uitat să adăugați pagina la router?",
    "settings.roles": "Roluri și Permisiuni",
    "settings.rolesDesc": "Configurați permisiunile pentru fiecare nivel de utilizator. Modificările intră în vigoare imediat.",
    "settings.resetDefaults": "RESETARE IMPLICITE",
    "settings.rolesLevel5Note": "Permisiunile nivelului 5 (Super Admin) nu pot fi modificate — accesul complet este întotdeauna garantat.",
    "settings.permission": "PERMISIUNE",
    "settings.level": "NIV",
    "settings.saving": "SALVARE...",
    "perm.acknowledgeAlarms": "Confirmarea alarmelor",
    "perm.controlPtz": "Comenzi cameră PTZ",
    "perm.recordTraces": "Înregistrare trasee PTZ",
    "perm.accessSettings": "Acces la setări",
    "perm.manageClusters": "Gestionare clustere",
    "perm.accessStreaming": "Gestionare streaming",
    "perm.managePlantImages": "Gestionare imagini fabrică",
    "perm.deleteTraces": "Ștergere trasee PTZ",
    "perm.manageUsers": "Gestionare utilizatori",
    "perm.changeLanguage": "Schimbare limbă",
    "perm.viewEmissions": "Vizualizare date emisii",
    "perm.exportReports": "Export rapoarte PDF",
    "perm.manageAlarms": "Gestionare alarme",
    "perm.manageSystem": "Gestionare sistem",
    "perm.deleteSystemLog": "Ștergere jurnal de sistem",
    "access.restricted": "Acces restricționat",
    "access.ptzRestricted": "Comenzile PTZ necesită nivelul Operator sau superior",
    "access.settingsRestricted": "Setările necesită nivelul Supervizor sau superior",
    "access.readOnlyMode": "Mod doar citire — Nivel Admin necesar pentru modificări",
    "access.ackRestricted": "Confirmarea alarmei necesită nivelul Operator sau superior",
    "alarm.state.UNACK": "NECONFIRMATĂ",
    "alarm.state.ACKED": "CONFIRMATĂ",
    "alarm.state.RTNUN": "REVENIRE LA NORMAL",
    "alarm.state.SHLVD": "SUSPENDATĂ",
    "alarm.priority.HIGH": "RIDICATĂ",
    "alarm.priority.MEDIUM": "MEDIE",
    "alarm.priority.LOW": "SCĂZUTĂ",
    "alarm.shelve": "SUSPENDARE",
    "alarm.unshelve": "RESTABILIRE",
    "alarm.shelveReason": "Motivul suspendării",
    "alarm.shelvedUntil": "Suspendată până la",
    "alarm.shelvedBy": "Suspendată de",
    "alarm.outOfService": "SCOASĂ DIN FUNCȚIUNE",
    "alarm.oosReason": "Motiv scoatere din funcțiune",
    "alarm.oosBy": "Scoasă din funcțiune de",
    "alarm.kpi.alarmRate": "Rata alarmelor",
    "alarm.kpi.floodDetected": "Inundație detectată",
    "alarm.kpi.staleAlarms": "Alarme învechite",
    "alarm.kpi.priorityDistribution": "Distribuția priorităților",
    "alarm.kpi.topBadActors": "Principalii problematici",
    "alarm.kpi.avgAckTime": "Timp mediu de confirmare",
    "alarm.kpi.unacknowledged": "Neconfirmate",
    "alarm.audit.title": "Jurnal de audit",
    "alarm.audit.action": "Acțiune",
    "alarm.audit.performedBy": "Efectuat de",
    "alarm.audit.details": "Detalii",
    "settings.deadband": "Bandă moartă (%)",
    "settings.onDelay": "Întârziere activare (s)",
    "settings.offDelay": "Întârziere dezactivare (s)",
    "emissions.title": "Emisii",
    "emissions.selectCluster": "Selectează cluster",
    "emissions.totalEmissions": "Emisii Totale",
    "emissions.uncertainty": "Incertitudine",
    "emissions.coverage": "Acoperire Date",
    "emissions.partial": "Parțial",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "Nu sunt date de emisii disponibile",
    "emissions.noCluster": "Selectează un cluster pentru a vedea emisiile",
    "emissions.totalHours": "Ore Totale",
    "emissions.completeHours": "Complete",
    "emissions.gapHours": "Lacune Date",
    "emissions.quality.good": "Bun",
    "emissions.quality.moderate": "Moderat",
    "emissions.quality.poor": "Slab",
    "emissions.viewDetail": "Vezi detalii complete",
    "emissions.last24h": "24h",
    "emissions.last7d": "7z",
    "emissions.last30d": "30z",
    "emissions.lastYear": "1a",
    "emissions.customRange": "Personalizat",
    "emissions.allClusters": "Toate Clusterele",
    "analytics": "Analize",
    "analytics.totalSiteEmissions": "Emisii Totale Locatie",
    "analytics.activeLeaks": "Scurgeri Active",
    "analytics.siteUncertainty": "Incertitudine Locatie",
    "analytics.emissionsByCluster": "Emisii pe Cluster",
    "analytics.windVsEmissions": "Vant vs Emisii",
    "analytics.assetStatus": "Stare Active",
    "analytics.dataCoverage": "Acoperire Date",
    "analytics.lastPeak": "Ultimul Varf",
    "analytics.lastReading": "Ultima Citire",
    "analytics.allClusters": "Toate Clusterele",
    "analytics.windSpeed": "Viteza Vantului",
    "analytics.emissionRate": "Rata Emisiilor",
    "companyInfo": "Info Companie",
    "companyName": "Nume Companie",
    "companyAddress": "Adresa",
    "companyContact": "Contact",
    "companyLogo": "Logo",
    "uploadLogo": "Incarca Logo",
    "exportPdf": "Export PDF",
    "generatingPdf": "Generare...",
    "siteReport": "Raport Locatie",
    "clusterReport": "Raport Cluster",
    "pdfBranding": "Branding PDF",
  },
  ru: {
    "rep.qGood": "Хорошо",
    "rep.qModerate": "Удовлетворительно",
    "rep.qPoor": "Плохо",
    "rep.totalEmissions": "Общие Выбросы",
    "rep.totalSiteEmissions": "Общие Выбросы Объекта",
    "rep.uncertainty": "Неопределённость",
    "rep.dataCoverage": "Покрытие Данных",
    "rep.period": "Период",
    "rep.generated": "Создан",
    "rep.confidential": "Конфиденциально",
    "rep.pageOf": "Страница {n} из {m}",
    "rep.subtitle": "Мониторинг утечек газа",
    "rep.daily": "Ежедневно",
    "rep.weekly": "Еженедельно",
    "rep.monthly": "Ежемесячно",
    "rep.annual": "Ежегодно",
    "rep.quarterly": "Ежеквартально",
    "rep.halfYearly": "Раз в полгода",
    "rep.emissionReport": "ОТЧЁТ ПО ВЫБРОСАМ",
    "rep.siteEmissionReport": "ОТЧЁТ ПО ВЫБРОСАМ ОБЪЕКТА",
    "rep.dataQuality": "Качество данных",
    "rep.colPeriod": "Период",
    "rep.colMass": "Масса",
    "rep.colQuality": "Качество",
    "rep.colReadings": "Измерения",
    "rep.colCluster": "Кластер",
    "rep.colCoverage": "Покрытие",
    "rep.dailyLeakReport": "СУТОЧНЫЙ ОТЧЁТ ОБ УТЕЧКАХ",
    "rep.site": "Объект",
    "rep.area": "Зона",
    "rep.reportDate": "Дата отчёта",
    "rep.leakEvents": "События утечки",
    "rep.none": "Нет",
    "rep.l1Threshold": "Порог тревоги L1",
    "rep.generatedBy": "Создал",
    "rep.internalDoc": "Внутренний документ — создан автоматически системой мониторинга LMSmini.",
    "rep.noDetections": "ОБНАРУЖЕНИЙ НЕТ",
    "rep.noDetectionsBody": "{d} концентрация газа выше порога тревоги L1 ({p} ppm·m) не зафиксирована.",
    "rep.leakOf": "УТЕЧКА {n} ИЗ {m}",
    "rep.colDate": "Дата",
    "rep.colTime": "Время",
    "rep.colConcentration": "Концентрация",
    "rep.fig": "Рис.",
    "rep.capPlant": "схема объекта, положение лазерной точки",
    "rep.capPlantNa": "схема объекта недоступна",
    "rep.capCamera": "вид с камеры",
    "rep.capCameraNa": "вид с камеры недоступен",
    "rep.capAt": "{s} · {w} в {t}",
    "rep.noCameraImage": "НЕТ ИЗОБРАЖЕНИЯ С КАМЕРЫ",
    "rep.noCameraBody": "Для этого события снимок не был получен. Проверьте, настроена ли камера для кластера и доступен ли её RTSP-поток.",
    "rep.noCameraFile": "Файл снимка, записанный для этого события, отсутствует на диске.",
    "rep.noPlantView": "НЕТ СХЕМЫ ОБЪЕКТА",
    "rep.noPlantBody": "Для этого события положение PTZ не записано, поэтому положение лазерной точки восстановить нельзя.",
    "fld.opticalBaseline": "Оптическая базовая линия",
    "syslog.opticalBaseline": "Оптическая базовая линия изменена — {p}",
    "focus.report": "Суточный отчёт",
    "focus.reportBusy": "СОЗДАНИЕ...",
    "focus.reportSaved": "Отчёт сохранён — утечек: {p}",
    "focus.reportSavedEmpty": "Отчёт сохранён — обнаружений нет",
    "focus.reportFailed": "Не удалось создать отчёт",
    "ptz.tabManual": "РУЧНОЙ",
    "ptz.tabAutomatic": "АВТО",
    "ptz.resetDcs": "Сброс реле DCS",
    "ptz.threshold": "ПОРОГ",
    "ptz.zoomAlwaysOn": "ВСЕГДА АКТИВНО",
    "ptz.recordPath": "ЗАПИСЬ МАРШРУТА",
    "ptz.recordWaypoint": "ЗАПИСАТЬ ТОЧКУ",
    "ptz.pointsRecorded": "точек записано",
    "ptz.savedTraces": "СОХРАНЁННЫЕ МАРШРУТЫ",
    "ptz.autoShutoff": "АВТООТКЛЮЧЕНИЕ",
    "ptz.autoStopPatrol": "Авто-стоп патруля",
    "ptz.startPatrol": "СТАРТ ПАТРУЛЯ",
    "ptz.stopPatrol": "СТОП ПАТРУЛЯ",
    "syslog.dcsRelayReset": "Реле DCS сброшено: {p}",
    "fld.laserPointer": "Лазерный указатель",
    "btn.laserOn": "ВКЛ",
    "btn.laserOff": "ВЫКЛ",
    "btn.saveFirst": "СНАЧАЛА СОХРАНИТЕ",
    "focus.laserDistance": "Расстояние до цели",
    "focus.laserOffScreen": "ЛАЗЕР вне кадра · уменьшите зум",
    "app.subtitle": "Система Мониторинга v1.1",
    "login.bootstrapTitle": "Создать администратора",
    "login.bootstrapHint": "Первый запуск — создайте учётную запись администратора.",
    "login.confirmPassword": "Подтвердите пароль",
    "login.bootstrapMismatch": "Пароли не совпадают",
    "login.bootstrapTooShort": "Пароль должен содержать не менее 8 символов",
    "hdr.emissionMetrics": "ПОКАЗАТЕЛИ ВЫБРОСОВ",
    "hdr.emissionsOverTime": "ВЫБРОСЫ ВО ВРЕМЕНИ",
    "hdr.windVsEmission": "ВЕТЕР VS ВЫБРОСЫ",
    "hdr.assetStatus": "СОСТОЯНИЕ ОБЪЕКТОВ",
    "hdr.eventLog": "ЖУРНАЛ СОБЫТИЙ",
    "hdr.performanceMetrics": "ПОКАЗАТЕЛИ ПРОИЗВОДИТЕЛЬНОСТИ",
    "hdr.priorityDistribution": "РАСПРЕДЕЛЕНИЕ ПРИОРИТЕТОВ",
    "hdr.ptzMode": "РЕЖИМ PTZ",
    "hdr.runtimeResources": "РЕСУРСЫ ВЫПОЛНЕНИЯ",
    "hdr.operationalControls": "ОПЕРАЦИОННОЕ УПРАВЛЕНИЕ",
    "hdr.ptzTransport": "ТРАНСПОРТ PTZ",
    "hdr.sensorTransport": "ТРАНСПОРТ ДАТЧИКА",
    "hdr.laserBeamPointer": "ЛАЗЕРНЫЙ УКАЗАТЕЛЬ",
    "hdr.laserMarkerVideo": "ЛАЗЕРНАЯ МЕТКА (ВИДЕО)",
    "hdr.deadbandDelay": "МЁРТВАЯ ЗОНА И ЗАДЕРЖКА",
    "hdr.noSignal": "НЕТ СИГНАЛА",
    "hdr.cameraIp": "IP КАМЕРЫ",
    "hdr.sensorIp": "IP ДАТЧИКА",
    "hdr.dcsIp": "IP DCS",
    "fld.cameraIp": "IP камеры",
    "fld.sensorIp": "IP датчика",
    "fld.enableDcs": "Включить DCS",
    "fld.moxaIp": "IP MOXA",
    "fld.homeDuration": "Длительность Home (мс)",
    "fld.ptzIpNport": "IP PTZ (NPort)",
    "fld.ptzIpOwn": "IP PTZ (собственный адрес)",
    "focus.ir": "ИК",
    "hdr.irCamera": "ИК-КАМЕРА (второй источник видео)",
    "settings.irCameraHint": "Отдельное сетевое устройство со своим IP и учётными данными. После настройки в режиме Focus появляется третья вкладка для переключения; одновременно декодируется только один поток. Лазерный маркер остаётся только на основной камере, так как рассчитывается по её полю зрения.",
    "fld.irCameraIp": "IP ИК-камеры",
    "fld.irCameraUsername": "Пользователь ИК-камеры",
    "fld.irCameraPassword": "Пароль ИК-камеры (пусто = без изменений)",
    "fld.irRtspUrl": "URL потока ИК (rtsp://)",
    "fld.ptzPort": "Порт PTZ",
    "fld.deviceAddress": "Адрес устройства",
    "fld.sensorPort": "Порт датчика",
    "fld.pathLength": "Длина пути (м)",
    "fld.enableWind": "Включить ветер",
    "fld.windSensorIp": "IP датчика ветра",
    "fld.windSensorPort": "Порт датчика ветра",
    "fld.sensorX": "Датчик X",
    "fld.sensorY": "Датчик Y",
    "fld.laserEndX": "Конец лазера X",
    "fld.laserEndY": "Конец лазера Y",
    "fld.enableLaser": "Включить лазер",
    "fld.hOffset": "Смещение H",
    "fld.vOffset": "Смещение V",
    "fld.showOnVideo": "Показать на видео",
    "fld.baseLaserCamera": "База лазер↔камера (м)",
    "fld.verticalOffset": "Вертикальное смещение (м)",
    "fld.laserSide": "Сторона лазера",
    "fld.defaultDistance": "Расстояние по умолчанию (м)",
    "fld.boresightH": "Boresight H",
    "fld.boresightV": "Boresight V",
    "msg.pngJpegMax": "PNG/JPEG, макс 500 КБ",
    "msg.noEmissionPeriod": "Нет данных о выбросах за этот период",
    "calib.title": "Калибровка PTZ",
    "settings.laserMarkerHint": "Маркер оценивает, куда направлен лазер, по зуму + расстоянию (лазер и камера движутся вместе на PTZ). Настройте FOV широкий/теле под модель камеры и смещение boresight на известном расстоянии.",
    "calTL": "1: Верх-Лево",
    "calTR": "2: Верх-Право",
    "calBL": "3: Низ-Лево",
    "calBR": "4: Низ-Право",
    "settings.addCalNode": "Добавить узел",
    "calib.noPlantImage": "Изображение объекта не настроено",
    "calib.configureFirst": "Перед калибровкой настройте изображение объекта в настройках.",
    "calib.backToSettings": "Назад к настройкам",
    "calib.clickToPlace": "Нажмите на изображение, чтобы разместить точки. Активная точка:",
    "logs.noEvents": "Событий не зафиксировано",
    "settings.calInterpHint": "Линейная интерполяция между узлами зум→смещение",
    "nav.gridView": "СЕТКА",
    "nav.siteMap": "КАРТА ОБЪЕКТА",
    "nav.logout": "Выход",
    "nav.level": "Уровень",
    "home.activeClusters": "АКТИВНЫЕ КЛАСТЕРЫ",
    "home.normal": "НОРМА",
    "home.warnings": "ПРЕДУПРЕЖДЕНИЯ",
    "home.critical": "КРИТИЧЕСКИЕ",
    "home.initializing": "ИНИЦИАЛИЗАЦИЯ...",
    "home.notifications": "Уведомления",
    "home.unread": "непрочитанных",
    "home.noAlarms": "НЕТ ТРЕВОГ",
    "home.ack": "ПОДТВ.",
    "home.ackAll": "ПОДТВ. ВСЕ",
    "sitemap.status": "СТАТУС",
    "sitemap.cluster": "КЛАСТЕР",
    "sitemap.area": "ЗОНА",
    "sitemap.thresholds": "ПОРОГИ",
    "sitemap.focus": "ФОКУС",
    "login.supervisorySystem": "Система Мониторинга",
    "login.operatorAccess": "Вход Оператора",
    "login.username": "ЛОГИН",
    "login.systemStatusOk": "ВСЕ СИСТЕМЫ В РАБОТЕ",
    "login.systemStatusOffline": "ОБОРУДОВАНИЕ НЕ В СЕТИ",
    "login.systemStatusProbing": "ПРОВЕРКА СИСТЕМЫ…",
    "login.systemStatusPartial": "ОБОРУДОВАНИЕ ЧАСТИЧНО В СЕТИ",
    "login.systemStatusUnconfigured": "ОБОРУДОВАНИЕ НЕ ПОДКЛЮЧЕНО",
    "login.systemStatusNoClusters": "Нет настроенных кластеров",
    "login.cluster": "кластер",
    "login.clusters": "кластеров",
    "login.devicesOnline": "в сети",
    "login.devicesOffline": "не в сети",
    "login.password": "ПАРОЛЬ",
    "login.loggingIn": "ВХОД...",
    "login.login": "ВОЙТИ",
    "login.authError": "Ошибка аутентификации",
    "focus.loading": "ЗАГРУЗКА...",
    "focus.hlsStream": "HLS Поток",
    "focus.clusterPlant": "План Кластера",
    "focus.video": "ВИДЕО",
    "focus.plant": "ПЛАН",
    "focus.live": "ПРЯМОЙ ЭФИР",
    "focus.noFeed": "НЕТ СИГНАЛА",
    "focus.noPlantConfigured": "ПЛАН НЕ НАСТРОЕН",
    "focus.uploadPlantHint": "Загрузите изображение плана в настройках кластера",
    "focus.criticalLeak": "ОБНАРУЖЕНА КРИТИЧЕСКАЯ УТЕЧКА",
    "focus.warningThreshold": "ПОРОГ ПРЕДУПРЕЖДЕНИЯ ПРЕВЫШЕН",
    "focus.concentrationAt": "Концентрация",
    "focus.limit": "Предел",
    "focus.acknowledge": "ПОДТВЕРДИТЬ",
    "focus.alarmAcked": "Тревога подтверждена Админом",
    "focus.realtimeConcentration": "КОНЦЕНТРАЦИЯ В РЕАЛЬНОМ ВРЕМЕНИ",
    "focus.cameraControl": "Управление Камерой",
    "focus.noAlarmEvents": "Нет зарегистрированных событий тревоги",
    "focus.sensorReading":  "Показание датчика",
    "syslog.appStarted":    "Приложение запущено",
    "syslog.cameraOffline": "Камера офлайн: {p}",
    "syslog.cameraOnline":  "Камера онлайн: {p}",
    "syslog.hwSensorOffline": "Лазерный датчик офлайн: {p}",
    "syslog.hwSensorOnline":  "Лазерный датчик онлайн: {p}",
    "syslog.ptzOffline":    "PTZ офлайн: {p}",
    "syslog.ptzOnline":     "PTZ онлайн: {p}",
    "syslog.sensorOffline": "Датчик офлайн: {p}",
    "syslog.sensorOnline":  "Датчик онлайн: {p}",
    "syslog.tracesEncoderMigration": "{p} устаревший(их) маршрут(ов) PTZ архивирован(о) — перезапишите для использования энкодера",
    "syslog.patrolStarted": "Авто-патруль запущен — {p}",
    "syslog.patrolStopped": "Авто-патруль остановлен — {p}",
    "syslog.patrolStoppedAlarm": "Авто-патруль остановлен по КРИТИЧЕСКОМУ сигналу — {p}",
    "syslog.patrolFault": "Авто-патруль остановлен — соединение потеряно — {p}",
    "syslog.patrolAutoResumeArmed": "Автовозобновление включено — ожидание связи — {p}",
    "syslog.patrolAutoResumed": "Авто-патруль автоматически возобновлён — {p}",
    "syslog.ptzGotoAlarm": "PTZ наведён на место тревоги — {p}",
    "evt.goToLeak": "К УТЕЧКЕ",
    "syslog.ptzGotoNoMove": "PTZ не переместился к месту тревоги — {p}",
    "syslog.ptzZeroCalibrated": "Нулевая позиция PTZ откалибрована — {p}",
    "syslog.videoLost":     "Видеосигнал потерян — {p}",
    "syslog.logsCleared":   "Системный журнал очищен оператором ({p} записей удалено)",
    "logs.deleteBtn":       "УДАЛИТЬ ЖУРНАЛЫ",
    "logs.downloadBtn":     "СКАЧАТЬ",
    "logs.confirmTitle":    "Удалить все журналы?",
    "logs.confirmMsg":      "Это безвозвратно удалит {p} записей журнала. Запись AUDIT, фиксирующая это действие, сохранится. Продолжить?",
    "logs.cancel":          "Отмена",
    "logs.confirm":         "Удалить",
    "logs.noPermission":    "Недостаточно прав",
    "focus.operationTime": "Время работы",
      "focus.systemStatus": "Состояние системы",
      "focus.laserSensor": "Датчик",
      "focus.ptzCamera": "Камера",
      "focus.online": "ОНЛАЙН",
      "focus.offline": "ОФЛАЙН",
      "focus.horizSpeed": "Гориз. скорость",
      "focus.vertSpeed": "Верт. скорость",
      "focus.parking": "Парковка",
    "focus.home": "Дом",
    "syslog.ptzParking": "Парковка для транспорта (pan 0, наклон вверх) — {p}",
      "focus.wiper": "Очиститель камеры",
      "focus.operatorControls": "Управление оператора",
      "focus.scanControls": "Управление сканированием",
      "focus.eventDate": "Дата",
      "focus.eventTime": "Время",
      "focus.eventSource": "Источник",
      "focus.eventDescription": "Событие",
      "focus.gasDetection": "Система обнаружения газа",
      "focus.userAction": "Действие пользователя",
      "focus.systemLms": "Система LMS",
      "focus.alarmTriggeredEvent": "Тревога сработала",
      "focus.alarmAckedEvent": "Тревога подтверждена",
      "focus.alarmClearedEvent": "Тревога снята",
      "focus.alarmShelvedEvent": "Тревога отложена",
    "ptz.controls": "УПРАВЛЕНИЕ PTZ",
    "ptz.wide": "ШИРЕ",
    "ptz.tele": "ТЕЛЕ",
    "ptz.rec": "ЗАПИСЬ",
    "ptz.points": "ТОЧЕК",
    "ptz.cancel": "ОТМЕНА",
    "ptz.point": "ТОЧКА",
    "ptz.save": "СОХРАНИТЬ",
    "ptz.traceName": "НАЗВАНИЕ МАРШРУТА",
    "ptz.traceNamePlaceholder": "напр. Северное сканирование",
    "ptz.presets": "ПРЕСЕТЫ",
    "ptz.recordTrace": "ЗАПИСАТЬ МАРШРУТ",
    "ptz.modePoints": "Точки",
    "ptz.mode360": "Обзор 360°",
    "ptz.ringHint": "Наклоните камеру на нужную высоту и нажмите «Добавить пояс». Каждый пояс = полный обзор 360° при этом наклоне (12 точек).",
    "ptz.ringNoEncoder": "Это устройство не сообщает сырой энкодер: режим 360° по поясам не может зафиксировать наклон.",
    "ptz.ringBand": "наклон {p}° · 360°",
    "ptz.addBand": "Добавить пояс T{p}",
    "ptz.bandsCount": "Поясов: {p}",
    "ptz.autoStop.off": "ВЫКЛ",
    "ptz.autoStop.tooltip": "Автоматическая остановка патруля по истечении выбранной длительности",
    "ptz.stopAuto": "СТОП ПАТРУЛЬ",
    "ptz.autoMode": "СТАРТ ПАТРУЛЬ",
    "ptz.homing": "КАЛИБРОВКА...",
    "ptz.noTrace": "НЕТ МАРШРУТА",
    "ptz.noTracesSaved": "Нет сохранённых маршрутов",
    "card.streamLost": "PTZ СОЕДИНЕНИЕ ПОТЕРЯНО",
    "card.live": "ПРЯМОЙ ЭФИР",
    "card.standby": "ОЖИДАНИЕ",
    "card.focusMode": "РЕЖИМ ФОКУС",
    "settings.title": "Настройки",
    "settings.systemConfig": "Конфигурация Системы",
    "settings.clusterSettings": "Настройки Кластеров",
    "settings.streaming": "Стриминг",
    "settings.system": "Система",
    "settings.administration": "Администрирование",
    "settings.activeClusters": "АКТИВНЫЕ КЛАСТЕРЫ",
    "settings.totalAlarms": "ВСЕГО ТРЕВОГ",
    "settings.unacknowledged": "НЕ ПОДТВЕРЖДЕНЫ",
    "settings.clusterManagement": "Управление Кластерами",
    "settings.loading": "ЗАГРУЗКА...",
    "settings.editCluster": "Редактировать Кластер",
    "settings.name": "Название",
    "settings.areaCode": "Код Зоны",
    "settings.thresholdL1": "Порог L1 (Предупреждение)",
    "settings.thresholdL2": "Порог L2 (Критический)",
    "settings.ptzLimits": "ПРЕДЕЛЫ PTZ",
    "settings.ptzAutoSpeed": "АВТО. СКОРОСТЬ PAN/TILT",
    "settings.ptzAutoSpeedHint": "Скорость Pelco-D (1–63), используемая при автопатруле и маршрутах по точкам.",
    "settings.ptzPatrolAutoResume": "АВТОВОЗОБНОВЛЕНИЕ ПАТРУЛЯ",
    "settings.ptzPatrolAutoResumeHint": "Если ВКЛ, после сбоя связи или keepalive головка возвращается в исходное положение и автоматически возобновляет патрулирование. Если ВЫКЛ, остаётся остановленной до перезапуска оператором.",
    "settings.clusterPlant": "ПЛАН КЛАСТЕРА",
    "settings.replace": "ЗАМЕНИТЬ",
    "settings.remove": "УДАЛИТЬ",
    "settings.removePlant": "Удалить план?",
    "settings.uploading": "ЗАГРУЗКА...",
    "settings.uploadPlant": "ЗАГРУЗИТЬ ПЛАН",
    "settings.cancel": "ОТМЕНА",
    "settings.save": "СОХРАНИТЬ",
    "settings.ptzTraces": "МАРШРУТЫ PTZ",
    "settings.noTraceRecorded": "Маршруты не записаны. Используйте управление PTZ в Режиме Фокус.",
    "settings.deactivate": "ДЕАКТИВИРОВАТЬ",
    "settings.select": "ВЫБРАТЬ",
    "settings.deleteTrace": "Удалить этот маршрут?",
    "settings.addCluster": "ДОБАВИТЬ КЛАСТЕР",
    "settings.newCluster": "Новый Кластер",
    "settings.create": "СОЗДАТЬ",
    "settings.deactivateCluster": "Деактивировать этот кластер?",
    "settings.plant": "План",
    "settings.ptzTrace": "Маршрут PTZ",
    "settings.noHardwareIp": "IP оборудования не настроен",
    "settings.totalClusters": "ВСЕГО КЛАСТЕРОВ",
    "settings.activeStreams": "АКТИВНЫЕ ПОТОКИ",
    "settings.rtspConfigured": "RTSP НАСТРОЕНЫ",
    "settings.converterTitle": "Конвертер RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • Сегменты 2с",
    "settings.starting": "ЗАПУСК...",
    "settings.active": "АКТИВЕН",
    "settings.error": "ОШИБКА",
    "settings.rtspUrl": "URL RTSP",
    "settings.start": "ЗАПУСТИТЬ",
    "settings.stop": "ОСТАНОВИТЬ",
    "settings.startedAt": "Запущен:",
    "settings.loadingDiag": "ЗАГРУЗКА ДИАГНОСТИКИ...",
    "settings.ramMemory": "ОПЕРАТИВНАЯ ПАМЯТЬ",
    "settings.totalRequests": "всего запросов",
    "settings.wsClients": "WebSocket клиентов",
    "settings.database": "База Данных",
    "settings.latency": "ЗАДЕРЖКА",
    "settings.apiHealth": "Состояние API",
    "settings.systemInfo": "Информация о Системе",
    "settings.softwareVersion": "Версия ПО",
    "settings.cameraProtocol": "Протокол Камеры",
    "settings.ptzModel": "МОДЕЛЬ PTZ",
    "settings.ptzModelLabel": "Модель оборудования",
    "settings.ptzModelHint": "Выбор типа оборудования: INDUSVISION (ONVIF), TECNOVIDEO (Pelco-D через NPort) или BIK-INFORM (расширенный Pelco-D через NPort, фиксированный объектив, без зума) — протокол и транспорт задаются автоматически. Custom = ручные поля.",
    "settings.telemetryFreq": "Частота Телеметрии",
    "settings.defaultThresholdL1": "Порог L1 по умолчанию",
    "settings.defaultThresholdL2": "Порог L2 по умолчанию",
    "settings.alarmManagement": "Управление Тревогами",
    "settings.simulationMode": "Демо-режим (Симуляция)",
    "settings.simulationDesc": "При включении генерирует симулированные данные датчиков для демонстраций и выставок. Отключите для работы с реальным оборудованием.",
    "settings.simulationEnabled": "Симуляция Активна",
    "settings.simulationDisabled": "Режим Реального Оборудования",
    "alarm.hero.allClear": "НЕТ АКТИВНЫХ АЛАРМОВ",
    "alarm.hero.unacked": "{n} НЕ ПОДТВЕРЖДЕНО",
    "alarm.hero.stale": "{n} УСТАРЕВШИХ АЛАРМОВ",
    "alarm.hero.flood": "ШКВАЛ АЛАРМОВ",
    "alarm.hero.disabled": "АЛАРМЫ ОТКЛЮЧЕНЫ",
    "alarm.hero.warmingUp": "Загрузка метрик…",
    "alarm.toggle.label": "Генерация",
    "alarm.stopPatrol.label": "Остановить патруль при L2",
    "alarm.audioAlert.label": "Звуковое оповещение",
    "alarm.toggle.on": "ВКЛЮЧЕНА",
    "alarm.toggle.off": "ОТКЛЮЧЕНА",
    "system.titleOk": "ВСЕ СИСТЕМЫ В РАБОТЕ",
    "system.titleDemo": "ДЕМО-РЕЖИМ АКТИВЕН",
    "system.titleWarning": "ВЫСОКАЯ НАГРУЗКА РЕСУРСОВ",
    "system.titleCritical": "ОШИБКА БАЗЫ ДАННЫХ",
    "system.cores": "ядер",
    "system.warmingUp": "Инициализация…",
    "settings.backupRestore": "Резервное копирование",
    "backup.title": "Резервное копирование и восстановление",
    "backup.description": "Создавайте полные резервные копии системы и восстанавливайте из предыдущих снимков. Копии включают все кластеры, пользователей, тревоги, журналы аудита, разрешения и изображения установок.",
    "backup.createBackup": "Создать копию",
    "backup.creating": "Создание копии...",
    "backup.restoring": "Восстановление...",
    "backup.restore": "Восстановить",
    "backup.restoreFailed": "Восстановление не удалось",
    "backup.download": "Скачать",
    "backup.delete": "Удалить",
    "backup.upload": "Загрузить копию",
    "backup.uploadSuccess": "Копия загружена: {f}",
    "backup.uploadFailed": "Ошибка загрузки",
    "backup.uploadDesc": "Загрузите ранее скачанный файл резервной копии.",
    "backup.confirmRestore": "Вы уверены, что хотите восстановить эту копию? Текущие данные будут перезаписаны.",
    "backup.confirmDelete": "Вы уверены, что хотите удалить эту резервную копию?",
    "backup.noBackups": "Резервные копии не найдены. Создайте первую копию выше.",
    "backup.lastBackup": "Последняя копия",
    "backup.totalBackups": "Всего копий",
    "backup.createdBy": "Создал",
    "backup.createdAt": "Создано",
    "backup.fileSize": "Размер файла",
    "backup.contents": "Содержимое",
    "backup.selectTables": "Выберите таблицы для восстановления",
    "backup.restoreSuccess": "Копия успешно восстановлена",
    "backup.createSuccess": "Резервная копия создана",
    "backup.clusters": "Кластеры",
    "backup.users": "Пользователи",
    "backup.ptzTraces": "PTZ маршруты",
    "backup.alarmEvents": "События тревог",
    "backup.auditLog": "Журнал аудита",
    "backup.rolePermissions": "Разрешения ролей",
    "backup.plantImages": "Изображения установок",
    "backup.siteName": "Название площадки",
    "backup.siteNameDesc": "Идентифицирует эту установку в именах файлов резервных копий",
    "backup.siteNamePlaceholder": "напр. НПЗ-Север",
    "ftp.title": "Запланированное FTP-резервирование",
    "ftp.description": "Автоматическая отправка резервных копий на внешний FTP-сервер через регулярные интервалы.",
    "ftp.enabled": "Включить запланированное FTP-резервирование",
    "ftp.host": "FTP-сервер",
    "ftp.port": "Порт",
    "ftp.user": "Имя пользователя",
    "ftp.password": "Пароль",
    "ftp.remotePath": "Удалённый путь",
    "ftp.secure": "Использовать FTPS (Безопасный)",
    "ftp.interval": "Интервал резервирования (часы)",
    "ftp.testConnection": "Проверить соединение",
    "ftp.testing": "Проверка...",
    "ftp.testSuccess": "Соединение успешно",
    "ftp.testFailed": "Ошибка соединения",
    "ftp.backupNow": "Отправить копию сейчас",
    "ftp.sending": "Отправка...",
    "ftp.lastBackup": "Последняя FTP-копия",
    "ftp.lastResult": "Последний результат",
    "ftp.schedulerActive": "Планировщик активен",
    "ftp.saveSettings": "Сохранить настройки FTP",
    "ftp.saving": "Сохранение...",
    "ftp.saved": "Настройки сохранены",
    "ftp.never": "Никогда",
    "ftp.success": "Успех",
    "ftp.error": "Ошибка",
    "ftp.yes": "Да",
    "ftp.no": "Нет",
    "settings.license": "Лицензия",
    "settings.activeUsers": "АКТИВНЫЕ ПОЛЬЗОВАТЕЛИ",
    "settings.levelLegend": "ЛЕГЕНДА УРОВНЕЙ",
    "settings.userAccounts": "Учётные Записи",
    "settings.language": "Язык",
    "settings.languageDesc": "Выберите язык интерфейса",
    "users.accessDenied": "Доступ Запрещён",
    "users.superAdminRequired": "Для управления пользователями требуется уровень Super Admin (Lv.5).",
    "users.backToSettings": "НАЗАД К НАСТРОЙКАМ",
    "users.userManagement": "Управление Пользователями",
    "users.accountAdmin": "Администрирование Учётных Записей",
    "users.editUser": "Редактировать Пользователя",
    "users.displayName": "ОТОБРАЖАЕМОЕ ИМЯ",
    "users.role": "РОЛЬ",
    "users.level": "УРОВЕНЬ",
    "users.deactivateUser": "Деактивировать этого пользователя?",
    "users.newPassword": "НОВЫЙ ПАРОЛЬ",
    "users.minChars": "Минимум 4 символа",
    "users.change": "ИЗМЕНИТЬ",
    "users.addUser": "ДОБАВИТЬ ПОЛЬЗОВАТЕЛЯ",
    "users.newUser": "Новый Пользователь",
    "roles.viewer": "Наблюдатель",
    "roles.operator": "Оператор",
    "roles.supervisor": "Супервизор",
    "roles.admin": "Администратор",
    "roles.superadmin": "Супер Админ",
    "notFound.title": "404 Страница не найдена",
    "notFound.hint": "Вы забыли добавить страницу в маршрутизатор?",
    "settings.roles": "Роли и Разрешения",
    "settings.rolesDesc": "Настройте разрешения для каждого уровня пользователя. Изменения вступают в силу немедленно.",
    "settings.resetDefaults": "СБРОС ПО УМОЛЧАНИЮ",
    "settings.rolesLevel5Note": "Разрешения уровня 5 (Супер Админ) не могут быть изменены — полный доступ всегда гарантирован.",
    "settings.permission": "РАЗРЕШЕНИЕ",
    "settings.level": "УРВ",
    "settings.saving": "СОХРАНЕНИЕ...",
    "perm.acknowledgeAlarms": "Подтверждение тревог",
    "perm.controlPtz": "Управление PTZ камерой",
    "perm.recordTraces": "Запись PTZ траекторий",
    "perm.accessSettings": "Доступ к настройкам",
    "perm.manageClusters": "Управление кластерами",
    "perm.accessStreaming": "Управление потоками",
    "perm.managePlantImages": "Управление изображениями завода",
    "perm.deleteTraces": "Удаление PTZ траекторий",
    "perm.manageUsers": "Управление пользователями",
    "perm.changeLanguage": "Смена языка",
    "perm.viewEmissions": "Просмотр данных о выбросах",
    "perm.exportReports": "Экспорт PDF отчётов",
    "perm.manageAlarms": "Управление тревогами",
    "perm.manageSystem": "Управление системой",
    "perm.deleteSystemLog": "Удалить системный журнал",
    "access.restricted": "Доступ ограничен",
    "access.ptzRestricted": "Управление PTZ требует уровня Оператор или выше",
    "access.settingsRestricted": "Настройки требуют уровня Супервизор или выше",
    "access.readOnlyMode": "Режим чтения — Для изменений требуется уровень Админ",
    "access.ackRestricted": "Подтверждение тревоги требует уровня Оператор или выше",
    "alarm.state.UNACK": "НЕ ПОДТВЕРЖДЕНА",
    "alarm.state.ACKED": "ПОДТВЕРЖДЕНА",
    "alarm.state.RTNUN": "ВОЗВРАТ К НОРМЕ",
    "alarm.state.SHLVD": "ОТЛОЖЕНА",
    "alarm.priority.HIGH": "ВЫСОКИЙ",
    "alarm.priority.MEDIUM": "СРЕДНИЙ",
    "alarm.priority.LOW": "НИЗКИЙ",
    "alarm.shelve": "ОТЛОЖИТЬ",
    "alarm.unshelve": "ВОССТАНОВИТЬ",
    "alarm.shelveReason": "Причина откладывания",
    "alarm.shelvedUntil": "Отложена до",
    "alarm.shelvedBy": "Отложена пользователем",
    "alarm.outOfService": "ВЫВЕДЕНА ИЗ ЭКСПЛУАТАЦИИ",
    "alarm.oosReason": "Причина вывода из эксплуатации",
    "alarm.oosBy": "Выведена из эксплуатации пользователем",
    "alarm.kpi.alarmRate": "Частота тревог",
    "alarm.kpi.floodDetected": "Обнаружен поток тревог",
    "alarm.kpi.staleAlarms": "Устаревшие тревоги",
    "alarm.kpi.priorityDistribution": "Распределение приоритетов",
    "alarm.kpi.topBadActors": "Наиболее проблемные",
    "alarm.kpi.avgAckTime": "Среднее время подтверждения",
    "alarm.kpi.unacknowledged": "Неподтверждённые",
    "alarm.audit.title": "Журнал аудита",
    "alarm.audit.action": "Действие",
    "alarm.audit.performedBy": "Выполнено",
    "alarm.audit.details": "Подробности",
    "settings.deadband": "Зона нечувствительности (%)",
    "settings.onDelay": "Задержка включения (с)",
    "settings.offDelay": "Задержка выключения (с)",
    "emissions.title": "Выбросы",
    "emissions.selectCluster": "Выбрать кластер",
    "emissions.totalEmissions": "Общие Выбросы",
    "emissions.uncertainty": "Неопределённость",
    "emissions.coverage": "Покрытие Данных",
    "emissions.partial": "Частичный",
    "emissions.exportJson": "Export JSON",
    "emissions.noData": "Нет данных о выбросах",
    "emissions.noCluster": "Выберите кластер для просмотра выбросов",
    "emissions.totalHours": "Всего Часов",
    "emissions.completeHours": "Полных",
    "emissions.gapHours": "Пробелы в Данных",
    "emissions.quality.good": "Хорошо",
    "emissions.quality.moderate": "Удовлетворительно",
    "emissions.quality.poor": "Плохо",
    "emissions.viewDetail": "Посмотреть подробности",
    "emissions.last24h": "24ч",
    "emissions.last7d": "7д",
    "emissions.last30d": "30д",
    "emissions.lastYear": "1г",
    "emissions.customRange": "Произвольный",
    "emissions.allClusters": "Все Кластеры",
    "analytics": "Аналитика",
    "analytics.totalSiteEmissions": "Общие Выбросы Объекта",
    "analytics.activeLeaks": "Активные Утечки",
    "analytics.siteUncertainty": "Неопределённость Объекта",
    "analytics.emissionsByCluster": "Выбросы по Кластерам",
    "analytics.windVsEmissions": "Ветер vs Выбросы",
    "analytics.assetStatus": "Состояние Активов",
    "analytics.dataCoverage": "Покрытие Данных",
    "analytics.lastPeak": "Последний Пик",
    "analytics.lastReading": "Последнее Чтение",
    "analytics.allClusters": "Все Кластеры",
    "analytics.windSpeed": "Скорость Ветра",
    "analytics.emissionRate": "Скорость Выбросов",
    "companyInfo": "Инфо Компании",
    "companyName": "Название Компании",
    "companyAddress": "Адрес",
    "companyContact": "Контакт",
    "companyLogo": "Логотип",
    "uploadLogo": "Загрузить Логотип",
    "exportPdf": "Экспорт PDF",
    "generatingPdf": "Генерация...",
    "siteReport": "Отчёт Объекта",
    "clusterReport": "Отчёт Кластера",
    "pdfBranding": "Брендинг PDF",
  },
  ko: {
    "rep.qGood": "양호",
    "rep.qModerate": "보통",
    "rep.qPoor": "불량",
    "rep.totalEmissions": "총 배출량",
    "rep.totalSiteEmissions": "현장 총 배출량",
    "rep.uncertainty": "불확실도",
    "rep.dataCoverage": "데이터 커버리지",
    "rep.period": "기간",
    "rep.generated": "생성",
    "rep.confidential": "기밀",
    "rep.pageOf": "{m}페이지 중 {n}페이지",
    "rep.subtitle": "가스 누출 모니터링",
    "rep.daily": "일간",
    "rep.weekly": "주간",
    "rep.monthly": "월간",
    "rep.annual": "연간",
    "rep.quarterly": "분기별",
    "rep.halfYearly": "반기별",
    "rep.emissionReport": "배출 리포트",
    "rep.siteEmissionReport": "사업장 배출 리포트",
    "rep.dataQuality": "데이터 품질",
    "rep.colPeriod": "기간",
    "rep.colMass": "질량",
    "rep.colQuality": "품질",
    "rep.colReadings": "측정값",
    "rep.colCluster": "클러스터",
    "rep.colCoverage": "커버리지",
    "rep.dailyLeakReport": "일일 누출 리포트",
    "rep.site": "사업장",
    "rep.area": "구역",
    "rep.reportDate": "리포트 날짜",
    "rep.leakEvents": "누출 이벤트",
    "rep.none": "없음",
    "rep.l1Threshold": "L1 경보 임계값",
    "rep.generatedBy": "생성자",
    "rep.internalDoc": "내부 문서 — LMSmini 모니터링 시스템에서 자동 생성됨.",
    "rep.noDetections": "감지 없음",
    "rep.noDetectionsBody": "{d}에 L1 경보 임계값({p} ppm·m)을 초과하는 가스 농도가 기록되지 않았습니다.",
    "rep.leakOf": "누출 {n} / {m}",
    "rep.colDate": "날짜",
    "rep.colTime": "시간",
    "rep.colConcentration": "농도",
    "rep.fig": "그림",
    "rep.capPlant": "플랜트 뷰, 레이저 포인터 위치",
    "rep.capPlantNa": "플랜트 뷰 사용 불가",
    "rep.capCamera": "카메라 뷰",
    "rep.capCameraNa": "카메라 뷰 사용 불가",
    "rep.capAt": "{s} · {w} {t}",
    "rep.noCameraImage": "카메라 이미지 없음",
    "rep.noCameraBody": "이 이벤트에 대한 스냅샷이 캡처되지 않았습니다. 클러스터에 카메라가 설정되어 있고 RTSP 스트림에 연결할 수 있는지 확인하십시오.",
    "rep.noCameraFile": "이 이벤트에 기록된 스냅샷 파일이 디스크에 더 이상 없습니다.",
    "rep.noPlantView": "플랜트 뷰 없음",
    "rep.noPlantBody": "이 이벤트에 대한 PTZ 위치가 기록되지 않아 레이저 포인터 위치를 복원할 수 없습니다.",
    "fld.opticalBaseline": "광학 기준선",
    "syslog.opticalBaseline": "광학 기준선 변경됨 — {p}",
    "focus.report": "일일 리포트",
    "focus.reportBusy": "생성 중...",
    "focus.reportSaved": "리포트 저장됨 — 누출 {p}건",
    "focus.reportSavedEmpty": "리포트 저장됨 — 감지 없음",
    "focus.reportFailed": "리포트 생성 실패",
    "ptz.tabManual": "수동",
    "ptz.tabAutomatic": "자동",
    "ptz.resetDcs": "DCS 릴레이 재설정",
    "ptz.threshold": "임계값",
    "ptz.zoomAlwaysOn": "항상 활성",
    "ptz.recordPath": "경로 기록",
    "ptz.recordWaypoint": "지점 기록",
    "ptz.pointsRecorded": "지점 기록됨",
    "ptz.savedTraces": "저장된 경로",
    "ptz.autoShutoff": "자동 종료",
    "ptz.autoStopPatrol": "순찰 자동 정지",
    "ptz.startPatrol": "순찰 시작",
    "ptz.stopPatrol": "순찰 정지",
    "syslog.dcsRelayReset": "DCS 릴레이 재설정됨: {p}",
    "fld.laserPointer": "레이저 포인터",
    "btn.laserOn": "켜기",
    "btn.laserOff": "끄기",
    "btn.saveFirst": "먼저 저장",
    "focus.laserDistance": "목표 거리",
    "focus.laserOffScreen": "레이저 화면 밖 · 줌 아웃",
    "app.subtitle": "감시 시스템 v1.1",
    "login.bootstrapTitle": "관리자 생성",
    "login.bootstrapHint": "첫 실행 — 관리자 계정을 생성하세요.",
    "login.confirmPassword": "비밀번호 확인",
    "login.bootstrapMismatch": "비밀번호가 일치하지 않습니다",
    "login.bootstrapTooShort": "비밀번호는 8자 이상이어야 합니다",
    "hdr.emissionMetrics": "배출 지표",
    "hdr.emissionsOverTime": "시간별 배출",
    "hdr.windVsEmission": "바람 대 배출",
    "hdr.assetStatus": "자산 상태",
    "hdr.eventLog": "이벤트 로그",
    "hdr.performanceMetrics": "성능 지표",
    "hdr.priorityDistribution": "우선순위 분포",
    "hdr.ptzMode": "PTZ 모드",
    "hdr.runtimeResources": "런타임 리소스",
    "hdr.operationalControls": "운영 제어",
    "hdr.ptzTransport": "PTZ 전송",
    "hdr.sensorTransport": "센서 전송",
    "hdr.laserBeamPointer": "레이저 포인터",
    "hdr.laserMarkerVideo": "레이저 마커 (비디오)",
    "hdr.deadbandDelay": "데드밴드 및 지연",
    "hdr.noSignal": "신호 없음",
    "hdr.cameraIp": "카메라 IP",
    "hdr.sensorIp": "센서 IP",
    "hdr.dcsIp": "DCS IP",
    "fld.cameraIp": "카메라 IP",
    "fld.sensorIp": "센서 IP",
    "fld.enableDcs": "DCS 활성화",
    "fld.moxaIp": "MOXA IP",
    "fld.homeDuration": "홈 지속시간 (ms)",
    "fld.ptzIpNport": "PTZ IP (NPort)",
    "fld.ptzIpOwn": "PTZ IP (자체 주소)",
    "focus.ir": "적외선",
    "hdr.irCamera": "적외선 카메라 (보조 영상 소스)",
    "settings.irCameraHint": "자체 IP와 인증 정보를 가진 별도의 네트워크 장치입니다. 설정하면 포커스 모드에 전환용 세 번째 탭이 생기며, 한 번에 하나의 스트림만 디코딩합니다. 레이저 마커는 주 카메라의 화각으로 계산되므로 주 카메라에서만 표시됩니다.",
    "fld.irCameraIp": "적외선 카메라 IP",
    "fld.irCameraUsername": "적외선 카메라 사용자",
    "fld.irCameraPassword": "적외선 카메라 비밀번호 (비우면 유지)",
    "fld.irRtspUrl": "적외선 스트림 URL (rtsp://)",
    "fld.ptzPort": "PTZ 포트",
    "fld.deviceAddress": "장치 주소",
    "fld.sensorPort": "센서 포트",
    "fld.pathLength": "경로 길이 (m)",
    "fld.enableWind": "바람 활성화",
    "fld.windSensorIp": "풍속계 IP",
    "fld.windSensorPort": "풍속계 포트",
    "fld.sensorX": "센서 X",
    "fld.sensorY": "센서 Y",
    "fld.laserEndX": "레이저 끝 X",
    "fld.laserEndY": "레이저 끝 Y",
    "fld.enableLaser": "레이저 활성화",
    "fld.hOffset": "H 오프셋",
    "fld.vOffset": "V 오프셋",
    "fld.showOnVideo": "비디오에 표시",
    "fld.baseLaserCamera": "레이저↔카메라 기준 (m)",
    "fld.verticalOffset": "수직 오프셋 (m)",
    "fld.laserSide": "레이저 방향",
    "fld.defaultDistance": "기본 거리 (m)",
    "fld.boresightH": "보어사이트 H",
    "fld.boresightV": "보어사이트 V",
    "msg.pngJpegMax": "PNG/JPEG, 최대 500 KB",
    "msg.noEmissionPeriod": "이 기간의 배출 데이터 없음",
    "calib.title": "PTZ 보정",
    "settings.laserMarkerHint": "마커는 줌 + 거리로 레이저가 가리키는 위치를 추정합니다 (레이저와 카메라는 PTZ에서 함께 움직임). 카메라 모델에 맞게 FOV 광각/망원을, 알려진 거리에서 보어사이트 오프셋을 조정하세요.",
    "calTL": "1: 좌상단",
    "calTR": "2: 우상단",
    "calBL": "3: 좌하단",
    "calBR": "4: 우하단",
    "settings.addCalNode": "노드 추가",
    "calib.noPlantImage": "설비 이미지가 설정되지 않음",
    "calib.configureFirst": "보정 전에 설정에서 설비 이미지를 구성하세요.",
    "calib.backToSettings": "설정으로 돌아가기",
    "calib.clickToPlace": "이미지를 클릭하여 점을 배치하세요. 활성 점:",
    "logs.noEvents": "기록된 이벤트 없음",
    "settings.calInterpHint": "줌→오프셋 노드 간 선형 보간",
    "nav.gridView": "그리드 보기",
    "nav.siteMap": "현장 지도",
    "nav.logout": "로그아웃",
    "nav.level": "레벨",
    "home.activeClusters": "활성 클러스터",
    "home.normal": "정상",
    "home.warnings": "경고",
    "home.critical": "위험",
    "home.initializing": "초기화 중...",
    "home.notifications": "알림",
    "home.unread": "읽지 않음",
    "home.noAlarms": "알람 없음",
    "home.ack": "확인",
    "home.ackAll": "전체 확인",
    "sitemap.status": "상태",
    "sitemap.cluster": "클러스터",
    "sitemap.area": "구역",
    "sitemap.thresholds": "임계값",
    "sitemap.focus": "집중",
    "login.supervisorySystem": "감시 시스템",
    "login.operatorAccess": "운영자 접근",
    "login.username": "사용자명",
    "login.systemStatusOk": "모든 시스템 정상 작동",
    "login.systemStatusOffline": "하드웨어 오프라인",
    "login.systemStatusProbing": "시스템 점검 중…",
    "login.systemStatusPartial": "하드웨어 부분 온라인",
    "login.systemStatusUnconfigured": "하드웨어 연결되지 않음",
    "login.systemStatusNoClusters": "구성된 클러스터 없음",
    "login.cluster": "클러스터",
    "login.clusters": "클러스터",
    "login.devicesOnline": "온라인",
    "login.devicesOffline": "오프라인",
    "login.password": "비밀번호",
    "login.loggingIn": "로그인 중...",
    "login.login": "로그인",
    "login.authError": "인증 오류",
    "focus.loading": "로딩 중...",
    "focus.hlsStream": "HLS 스트림",
    "focus.clusterPlant": "클러스터 설비도",
    "focus.video": "영상",
    "focus.plant": "설비도",
    "focus.live": "실시간",
    "focus.noFeed": "영상 없음",
    "focus.noPlantConfigured": "설비도 미설정",
    "focus.uploadPlantHint": "클러스터 설정에서 설비도 이미지를 업로드하세요",
    "focus.criticalLeak": "위험 누출 감지",
    "focus.warningThreshold": "경고 임계값 초과",
    "focus.concentrationAt": "농도",
    "focus.limit": "한도",
    "focus.acknowledge": "확인",
    "focus.alarmAcked": "관리자가 알람 확인",
    "focus.realtimeConcentration": "실시간 농도",
    "focus.cameraControl": "카메라 제어",
    "focus.noAlarmEvents": "기록된 알람 이벤트 없음",
    "focus.sensorReading":  "센서 측정값",
    "syslog.appStarted":    "애플리케이션 시작됨",
    "syslog.cameraOffline": "카메라 오프라인: {p}",
    "syslog.cameraOnline":  "카메라 온라인: {p}",
    "syslog.hwSensorOffline": "레이저 센서 오프라인: {p}",
    "syslog.hwSensorOnline":  "레이저 센서 온라인: {p}",
    "syslog.ptzOffline":    "PTZ 오프라인: {p}",
    "syslog.ptzOnline":     "PTZ 온라인: {p}",
    "syslog.sensorOffline": "센서 오프라인: {p}",
    "syslog.sensorOnline":  "센서 온라인: {p}",
    "syslog.tracesEncoderMigration": "{p}개의 레거시 PTZ 트레이스가 보관됨 — 인코더 피드백을 사용하려면 다시 기록하세요",
    "syslog.patrolStarted": "자동 순찰 시작 — {p}",
    "syslog.patrolStopped": "자동 순찰 중지 — {p}",
    "syslog.patrolStoppedAlarm": "위험 경보로 자동 순찰 중지 — {p}",
    "syslog.patrolFault": "자동 순찰 중지 — 연결 끊김 — {p}",
    "syslog.patrolAutoResumeArmed": "자동 재개 준비됨 — 연결 대기 중 — {p}",
    "syslog.patrolAutoResumed": "자동 순찰 자동 재개됨 — {p}",
    "syslog.ptzGotoAlarm": "PTZ를 경보 지점으로 이동 — {p}",
    "evt.goToLeak": "누출 지점으로",
    "syslog.ptzGotoNoMove": "PTZ가 경보 지점으로 이동하지 않았습니다 — {p}",
    "syslog.ptzZeroCalibrated": "PTZ 영점 보정됨 — {p}",
    "syslog.videoLost":     "비디오 신호 끊김 — {p}",
    "syslog.logsCleared":   "운영자가 시스템 로그를 삭제함 ({p}개 항목 제거됨)",
    "logs.deleteBtn":       "로그 삭제",
    "logs.downloadBtn":     "다운로드",
    "logs.confirmTitle":    "모든 로그를 삭제하시겠습니까?",
    "logs.confirmMsg":      "{p}개의 로그 항목이 영구적으로 제거됩니다. 이 작업을 기록하는 AUDIT 항목은 유지됩니다. 계속하시겠습니까?",
    "logs.cancel":          "취소",
    "logs.confirm":         "삭제",
    "logs.noPermission":    "권한 부족",
    "focus.operationTime": "운영 시간",
    "focus.systemStatus": "시스템 상태",
    "focus.laserSensor": "센서",
    "focus.ptzCamera": "카메라",
    "focus.online": "온라인",
    "focus.offline": "오프라인",
    "focus.horizSpeed": "수평 속도",
    "focus.vertSpeed": "수직 속도",
    "focus.parking": "파킹",
    "focus.home": "홈",
    "syslog.ptzParking": "운송 주차 (pan 0, 틸트 위로) — {p}",
    "focus.wiper": "카메라 와이퍼",
    "focus.operatorControls": "운영자 제어",
    "focus.scanControls": "스캔 제어",
    "focus.eventDate": "날짜",
    "focus.eventTime": "시간",
    "focus.eventSource": "출처",
    "focus.eventDescription": "이벤트",
    "focus.gasDetection": "가스 감지 시스템",
    "focus.userAction": "사용자 조작",
    "focus.systemLms": "시스템 LMS",
    "focus.alarmTriggeredEvent": "알람 발생",
    "focus.alarmAckedEvent": "알람 확인",
    "focus.alarmClearedEvent": "알람 해제",
    "focus.alarmShelvedEvent": "알람 보류",
    "ptz.controls": "PTZ 제어",
    "ptz.wide": "광각",
    "ptz.tele": "망원",
    "ptz.rec": "녹화",
    "ptz.points": "포인트",
    "ptz.cancel": "취소",
    "ptz.point": "포인트",
    "ptz.save": "저장",
    "ptz.traceName": "경로 이름",
    "ptz.traceNamePlaceholder": "예: 북측 스캔",
    "ptz.presets": "프리셋",
    "ptz.recordTrace": "경로 녹화",
    "ptz.modePoints": "포인트",
    "ptz.mode360": "360° 스캔",
    "ptz.ringHint": "카메라를 원하는 높이로 기울인 뒤 ‘구간 추가’를 누르세요. 각 구간 = 해당 틸트에서의 360° 전체 스캔 (12개 지점).",
    "ptz.ringNoEncoder": "이 장비는 원시 엔코더를 제공하지 않습니다: 360° 구간 모드는 틸트 값을 기록할 수 없습니다.",
    "ptz.ringBand": "틸트 {p}° · 360°",
    "ptz.addBand": "구간 T{p} 추가",
    "ptz.bandsCount": "{p}개 구간",
    "ptz.autoStop.off": "OFF",
    "ptz.autoStop.tooltip": "선택한 시간 후 자동 순찰 자동 중지",
    "ptz.stopAuto": "순찰 중지",
    "ptz.autoMode": "순찰 시작",
    "ptz.homing": "원점 이동 중...",
    "ptz.noTrace": "경로 없음",
    "ptz.noTracesSaved": "저장된 경로가 없습니다",
    "card.streamLost": "PTZ 연결 끊김",
    "card.live": "실시간",
    "card.standby": "대기",
    "card.focusMode": "집중 모드",
    "settings.title": "설정",
    "settings.systemConfig": "시스템 구성",
    "settings.clusterSettings": "클러스터 설정",
    "settings.streaming": "스트리밍",
    "settings.system": "시스템",
    "settings.administration": "관리",
    "settings.activeClusters": "활성 클러스터",
    "settings.totalAlarms": "총 알람",
    "settings.unacknowledged": "미확인",
    "settings.clusterManagement": "클러스터 관리",
    "settings.loading": "로딩 중...",
    "settings.editCluster": "클러스터 편집",
    "settings.name": "이름",
    "settings.areaCode": "구역 코드",
    "settings.thresholdL1": "임계값 L1 (경고)",
    "settings.thresholdL2": "임계값 L2 (위험)",
    "settings.ptzLimits": "PTZ 한계",
    "settings.ptzAutoSpeed": "자동 PAN/TILT 속도",
    "settings.ptzAutoSpeedHint": "자동 순찰 및 경유지 경로에 사용되는 Pelco-D 속도 (1–63).",
    "settings.ptzPatrolAutoResume": "순찰 자동 재개",
    "settings.ptzPatrolAutoResumeHint": "켜면 링크 또는 keepalive 장애 후 헤드가 홈으로 복귀하여 순찰을 자동으로 재개합니다. 끄면 운영자가 다시 시작할 때까지 정지 상태로 유지됩니다.",
    "settings.clusterPlant": "클러스터 설비도",
    "settings.replace": "교체",
    "settings.remove": "삭제",
    "settings.removePlant": "설비도를 삭제하시겠습니까?",
    "settings.uploading": "업로드 중...",
    "settings.uploadPlant": "설비도 업로드",
    "settings.cancel": "취소",
    "settings.save": "저장",
    "settings.ptzTraces": "PTZ 경로",
    "settings.noTraceRecorded": "기록된 경로 없음. 집중 모드에서 PTZ 제어로 경로를 녹화하세요.",
    "settings.deactivate": "비활성화",
    "settings.select": "선택",
    "settings.deleteTrace": "이 경로를 삭제하시겠습니까?",
    "settings.addCluster": "클러스터 추가",
    "settings.newCluster": "새 클러스터",
    "settings.create": "생성",
    "settings.deactivateCluster": "이 클러스터를 비활성화하시겠습니까?",
    "settings.plant": "설비도",
    "settings.ptzTrace": "PTZ 경로",
    "settings.noHardwareIp": "하드웨어 IP 미설정",
    "settings.totalClusters": "총 클러스터",
    "settings.activeStreams": "활성 스트림",
    "settings.rtspConfigured": "RTSP 설정됨",
    "settings.converterTitle": "변환기 RTSP → HLS",
    "settings.converterSubtitle": "FFmpeg • HLS • 2초 세그먼트",
    "settings.starting": "시작 중...",
    "settings.active": "활성",
    "settings.error": "오류",
    "settings.rtspUrl": "RTSP URL",
    "settings.start": "시작",
    "settings.stop": "중지",
    "settings.startedAt": "시작 시간:",
    "settings.loadingDiag": "진단 로딩 중...",
    "settings.ramMemory": "RAM 메모리",
    "settings.totalRequests": "총 요청",
    "settings.wsClients": "WebSocket 클라이언트",
    "settings.database": "데이터베이스",
    "settings.latency": "지연 시간",
    "settings.apiHealth": "API 상태",
    "settings.systemInfo": "시스템 정보",
    "settings.softwareVersion": "소프트웨어 버전",
    "settings.cameraProtocol": "카메라 프로토콜",
    "settings.ptzModel": "PTZ 모델",
    "settings.ptzModelLabel": "장비 모델",
    "settings.ptzModelHint": "장비 유형 선택: INDUSVISION (ONVIF), TECNOVIDEO (NPort 경유 Pelco-D) 또는 BIK-INFORM (NPort 경유 확장 Pelco-D, 고정 초점, 줌 없음) — 프로토콜과 전송을 자동 설정합니다. Custom = 수동 필드.",
    "settings.telemetryFreq": "텔레메트리 주기",
    "settings.defaultThresholdL1": "기본 임계값 L1",
    "settings.defaultThresholdL2": "기본 임계값 L2",
    "settings.alarmManagement": "알람 관리",
    "settings.simulationMode": "데모 모드 (시뮬레이션)",
    "settings.simulationDesc": "활성화하면 시연 및 전시 목적으로 시뮬레이션 센서 데이터를 생성합니다. 실제 하드웨어 운영 시 비활성화하세요.",
    "settings.simulationEnabled": "시뮬레이션 활성",
    "settings.simulationDisabled": "실제 하드웨어 모드",
    "alarm.hero.allClear": "활성 알람 없음",
    "alarm.hero.unacked": "{n}개 미확인",
    "alarm.hero.stale": "{n}개 오래된 알람",
    "alarm.hero.flood": "알람 폭주 감지",
    "alarm.hero.disabled": "알람 비활성화됨",
    "alarm.hero.warmingUp": "지표 로딩 중…",
    "alarm.toggle.label": "생성",
    "alarm.stopPatrol.label": "L2에서 순찰 중지",
    "alarm.audioAlert.label": "음향 경보",
    "alarm.toggle.on": "사용",
    "alarm.toggle.off": "사용 안 함",
    "system.titleOk": "모든 시스템 정상 작동",
    "system.titleDemo": "데모 모드 실행 중",
    "system.titleWarning": "리소스 사용량 높음",
    "system.titleCritical": "데이터베이스 오류",
    "system.cores": "코어",
    "system.warmingUp": "초기화 중…",
    "settings.backupRestore": "백업 및 복원",
    "backup.title": "백업 및 복원",
    "backup.description": "전체 시스템 백업을 생성하고 이전 스냅샷에서 복원합니다. 백업에는 모든 클러스터, 사용자, 알람, 감사 로그, 권한 및 설비도 이미지가 포함됩니다.",
    "backup.createBackup": "백업 생성",
    "backup.creating": "백업 생성 중...",
    "backup.restoring": "복원 중...",
    "backup.restore": "복원",
    "backup.restoreFailed": "복원 실패",
    "backup.download": "다운로드",
    "backup.delete": "삭제",
    "backup.upload": "백업 업로드",
    "backup.uploadSuccess": "백업 업로드됨: {f}",
    "backup.uploadFailed": "업로드 실패",
    "backup.uploadDesc": "이전에 다운로드한 백업 파일을 업로드하여 복원합니다.",
    "backup.confirmRestore": "이 백업을 복원하시겠습니까? 현재 데이터가 덮어씌워집니다.",
    "backup.confirmDelete": "이 백업을 삭제하시겠습니까?",
    "backup.noBackups": "백업을 찾을 수 없습니다. 위에서 첫 번째 백업을 생성하세요.",
    "backup.lastBackup": "마지막 백업",
    "backup.totalBackups": "총 백업",
    "backup.createdBy": "생성자",
    "backup.createdAt": "생성 시간",
    "backup.fileSize": "파일 크기",
    "backup.contents": "내용",
    "backup.selectTables": "복원할 테이블 선택",
    "backup.restoreSuccess": "백업이 성공적으로 복원되었습니다",
    "backup.createSuccess": "백업이 성공적으로 생성되었습니다",
    "backup.clusters": "클러스터",
    "backup.users": "사용자",
    "backup.ptzTraces": "PTZ 경로",
    "backup.alarmEvents": "알람 이벤트",
    "backup.auditLog": "감사 로그",
    "backup.rolePermissions": "역할 권한",
    "backup.plantImages": "설비도 이미지",
    "backup.siteName": "현장 이름",
    "backup.siteNameDesc": "백업 파일명에 이 설치를 식별합니다",
    "backup.siteNamePlaceholder": "예: 정유소-북측",
    "ftp.title": "예약 FTP 백업",
    "ftp.description": "정기적으로 외부 FTP 서버에 자동으로 백업을 전송합니다.",
    "ftp.enabled": "예약 FTP 백업 활성화",
    "ftp.host": "FTP 호스트",
    "ftp.port": "포트",
    "ftp.user": "사용자명",
    "ftp.password": "비밀번호",
    "ftp.remotePath": "원격 경로",
    "ftp.secure": "FTPS 사용 (보안)",
    "ftp.interval": "백업 간격 (시간)",
    "ftp.testConnection": "연결 테스트",
    "ftp.testing": "테스트 중...",
    "ftp.testSuccess": "연결 성공",
    "ftp.testFailed": "연결 실패",
    "ftp.backupNow": "지금 백업 전송",
    "ftp.sending": "전송 중...",
    "ftp.lastBackup": "마지막 FTP 백업",
    "ftp.lastResult": "마지막 결과",
    "ftp.schedulerActive": "스케줄러 활성",
    "ftp.saveSettings": "FTP 설정 저장",
    "ftp.saving": "저장 중...",
    "ftp.saved": "설정 저장됨",
    "ftp.never": "없음",
    "ftp.success": "성공",
    "ftp.error": "오류",
    "ftp.yes": "예",
    "ftp.no": "아니오",
    "settings.license": "라이선스",
    "settings.activeUsers": "활성 사용자",
    "settings.levelLegend": "레벨 범례",
    "settings.userAccounts": "사용자 계정",
    "settings.language": "언어",
    "settings.languageDesc": "인터페이스 언어를 선택하세요",
    "users.accessDenied": "접근 거부",
    "users.superAdminRequired": "사용자 관리에는 슈퍼 관리자 레벨(Lv.5)이 필요합니다.",
    "users.backToSettings": "설정으로 돌아가기",
    "users.userManagement": "사용자 관리",
    "users.accountAdmin": "계정 관리",
    "users.editUser": "사용자 편집",
    "users.displayName": "표시 이름",
    "users.role": "역할",
    "users.level": "레벨",
    "users.deactivateUser": "이 사용자를 비활성화하시겠습니까?",
    "users.newPassword": "새 비밀번호",
    "users.minChars": "최소 4자",
    "users.change": "변경",
    "users.addUser": "사용자 추가",
    "users.newUser": "새 사용자",
    "roles.viewer": "뷰어",
    "roles.operator": "운영자",
    "roles.supervisor": "감독자",
    "roles.admin": "관리자",
    "roles.superadmin": "슈퍼 관리자",
    "notFound.title": "404 페이지를 찾을 수 없습니다",
    "notFound.hint": "라우터에 페이지를 추가하는 것을 잊으셨나요?",
    "settings.roles": "역할 및 권한",
    "settings.rolesDesc": "각 사용자 레벨의 권한을 구성합니다. 변경 사항은 모든 사용자에게 즉시 적용됩니다.",
    "settings.resetDefaults": "기본값 복원",
    "settings.rolesLevel5Note": "레벨 5(슈퍼 관리자) 권한은 수정할 수 없습니다 — 전체 접근이 항상 보장됩니다.",
    "settings.permission": "권한",
    "settings.level": "레벨",
    "settings.saving": "저장 중...",
    "perm.acknowledgeAlarms": "알람 확인",
    "perm.controlPtz": "PTZ 카메라 제어",
    "perm.recordTraces": "PTZ 경로 녹화",
    "perm.accessSettings": "설정 접근",
    "perm.manageClusters": "클러스터 관리",
    "perm.accessStreaming": "스트리밍 관리",
    "perm.managePlantImages": "설비도 이미지 관리",
    "perm.deleteTraces": "PTZ 경로 삭제",
    "perm.manageUsers": "사용자 관리",
    "perm.changeLanguage": "언어 변경",
    "perm.viewEmissions": "배출 데이터 보기",
    "perm.exportReports": "PDF 보고서 내보내기",
    "perm.manageAlarms": "알람 관리",
    "perm.manageSystem": "시스템 관리",
    "perm.deleteSystemLog": "시스템 로그 삭제",
    "access.restricted": "접근 제한",
    "access.ptzRestricted": "PTZ 제어에는 운영자 레벨 이상이 필요합니다",
    "access.settingsRestricted": "설정에는 감독자 레벨 이상이 필요합니다",
    "access.readOnlyMode": "읽기 전용 모드 — 변경에는 관리자 레벨이 필요합니다",
    "access.ackRestricted": "알람 확인에는 운영자 레벨 이상이 필요합니다",
    "alarm.state.UNACK": "미확인",
    "alarm.state.ACKED": "확인됨",
    "alarm.state.RTNUN": "정상 복귀",
    "alarm.state.SHLVD": "보류됨",
    "alarm.priority.HIGH": "높음",
    "alarm.priority.MEDIUM": "중간",
    "alarm.priority.LOW": "낮음",
    "alarm.shelve": "보류",
    "alarm.unshelve": "보류 해제",
    "alarm.shelveReason": "보류 사유",
    "alarm.shelvedUntil": "보류 종료",
    "alarm.shelvedBy": "보류 설정자",
    "alarm.outOfService": "서비스 중단",
    "alarm.oosReason": "중단 사유",
    "alarm.oosBy": "중단 설정자",
    "alarm.kpi.alarmRate": "알람 발생률",
    "alarm.kpi.floodDetected": "폭주 감지",
    "alarm.kpi.staleAlarms": "오래된 알람",
    "alarm.kpi.priorityDistribution": "우선순위 분포",
    "alarm.kpi.topBadActors": "주요 문제 지점",
    "alarm.kpi.avgAckTime": "평균 확인 시간",
    "alarm.kpi.unacknowledged": "미확인",
    "alarm.audit.title": "감사 추적",
    "alarm.audit.action": "조치",
    "alarm.audit.performedBy": "수행자",
    "alarm.audit.details": "세부사항",
    "settings.deadband": "데드밴드 (%)",
    "settings.onDelay": "온딜레이 (초)",
    "settings.offDelay": "오프딜레이 (초)",
    "emissions.title": "배출",
    "emissions.selectCluster": "클러스터 선택",
    "emissions.totalEmissions": "총 배출량",
    "emissions.uncertainty": "불확실도",
    "emissions.coverage": "데이터 커버리지",
    "emissions.partial": "부분",
    "emissions.exportJson": "JSON 내보내기",
    "emissions.noData": "배출 데이터 없음",
    "emissions.noCluster": "배출량을 보려면 클러스터를 선택하세요",
    "emissions.totalHours": "총 시간",
    "emissions.completeHours": "완료",
    "emissions.gapHours": "데이터 공백",
    "emissions.quality.good": "양호",
    "emissions.quality.moderate": "보통",
    "emissions.quality.poor": "불량",
    "emissions.viewDetail": "전체 상세 보기",
    "emissions.last24h": "24시간",
    "emissions.last7d": "7일",
    "emissions.last30d": "30일",
    "emissions.lastYear": "1년",
    "emissions.customRange": "사용자 지정",
    "emissions.allClusters": "전체 클러스터",
    "analytics": "분석",
    "analytics.totalSiteEmissions": "현장 총 배출량",
    "analytics.activeLeaks": "활성 누출",
    "analytics.siteUncertainty": "현장 불확실도",
    "analytics.emissionsByCluster": "클러스터별 배출량",
    "analytics.windVsEmissions": "풍속 대 배출량",
    "analytics.assetStatus": "자산 상태",
    "analytics.dataCoverage": "데이터 커버리지",
    "analytics.lastPeak": "마지막 피크",
    "analytics.lastReading": "마지막 측정",
    "analytics.allClusters": "전체 클러스터",
    "analytics.windSpeed": "풍속",
    "analytics.emissionRate": "배출률",
    "companyInfo": "회사 정보",
    "companyName": "회사명",
    "companyAddress": "주소",
    "companyContact": "연락처",
    "companyLogo": "로고",
    "uploadLogo": "로고 업로드",
    "exportPdf": "PDF 내보내기",
    "generatingPdf": "생성 중...",
    "siteReport": "현장 보고서",
    "clusterReport": "클러스터 보고서",
    "pdfBranding": "PDF 브랜딩",
  },
};

export const DEFAULT_LANGUAGE = "en";

export type LanguageCode = string;

/** Traduce una chiave. Ricade sull'inglese e poi sulla chiave stessa: una
 *  chiave visibile in pagina si nota e si corregge, una stringa vuota no. */
export function t(lang: LanguageCode, key: string): string {
  return TABLE[lang]?.[key] ?? TABLE[DEFAULT_LANGUAGE]?.[key] ?? key;
}

/** Le chiavi che mancano in una lingua rispetto all'inglese. Vuoto = parita'.
 *  Serve al test che tiene le nove lingue allineate. */
export function missingKeys(lang: LanguageCode): string[] {
  const base = Object.keys(TABLE[DEFAULT_LANGUAGE] ?? {});
  const target = TABLE[lang] ?? {};
  return base.filter((k) => !(k in target));
}

export function keyCount(lang: LanguageCode): number {
  return Object.keys(TABLE[lang] ?? {}).length;
}

export { TABLE as TRANSLATIONS };
